export const yelp_data = {
  businesses: [
    {
      alias: "golden-boy-pizza-hamburg",
      categories: [
        {
          alias: "pizza",
          title: "Pizza",
        },
        {
          alias: "food",
          title: "Food",
        },
      ],
      coordinates: {
        latitude: 41.7873382568359,
        longitude: -123.051551818848,
      },
      display_phone: "(415) 982-9738",
      distance: 4992.437696561071,
      id: "QPOI0dYeAl3U8iPM_IYWnA",
      image_url:
        "https://s3-media0.fl.yelpcdn.com/bphoto/l6pmTy99YZTrX3Gn7Uhduw/348s.jpg",
      is_closed: true,
      location: {
        address1: "James",
        address2: "Street",
        address3: "68M",
        city: "Los Angeles",
        country: "US",
        display_address: ["James", "Street", "68M", "Los Angeles, CA 22399"],
        state: "CA",
        zip_code: "22399",
      },
      name: "Golden Boy Pizza",
      phone: "+14159829738",
      price: "$",
      rating: 4,
      review_count: 903,
      transactions: ["restaurant_reservation"],
      url: "https://www.yelp.com/biz/golden-boy-pizza-hamburg?adjust_creative=XsIsNkqpLmHqfJ51zfRn3A&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=XsIsNkqpLmHqfJ51zfRn3A",
      business_hours: {
        open: [
          {
            is_overnight: false,
            start: 15,
            end: 130,
            day: 0,
          },
          {
            is_overnight: false,
            start: 630,
            end: 1730,
            day: 1,
          },
          {
            is_overnight: false,
            start: 45,
            end: 500,
            day: 2,
          },
        ],
        hours_type: "REGULAR",
        is_open_now: false,
      },
    },
  ],
  region: {
    center: {
      latitude: 37.76089938976322,
      longitude: -122.43644714355469,
    },
  },
  total: 6800,
};

export const categories = [
  {
    alias: "3dprinting",
    title: "3D Printing",
  },
  {
    alias: "abruzzese",
    title: "Abruzzese",
  },
  {
    alias: "absinthebars",
    title: "Absinthe Bars",
  },
  {
    alias: "acaibowls",
    title: "Acai Bowls",
  },
  {
    alias: "accessories",
    title: "Accessories",
  },
  {
    alias: "accountants",
    title: "Accountants",
  },
  {
    alias: "acnetreatment",
    title: "Acne Treatment",
  },
  {
    alias: "active",
    title: "Active Life",
  },
  {
    alias: "acupuncture",
    title: "Acupuncture",
  },
  {
    alias: "addictionmedicine",
    title: "Addiction Medicine",
  },
  {
    alias: "adoptionservices",
    title: "Adoption Services",
  },
  {
    alias: "adult",
    title: "Adult Shops",
  },
  {
    alias: "adultedu",
    title: "Adult Education",
  },
  {
    alias: "adultentertainment",
    title: "Adult Entertainment",
  },
  {
    alias: "advertising",
    title: "Advertising",
  },
  {
    alias: "aerialfitness",
    title: "Aerial Fitness",
  },
  {
    alias: "aerialtours",
    title: "Aerial Tours",
  },
  {
    alias: "aestheticians",
    title: "Aestheticians",
  },
  {
    alias: "afghani",
    title: "Afghan",
  },
  {
    alias: "african",
    title: "African",
  },
  {
    alias: "afrobrazilian",
    title: "Afro-Brazilian",
  },
  {
    alias: "agriturismi",
    title: "Agriturismi",
  },
  {
    alias: "aircraftdealers",
    title: "Aircraft Dealers",
  },
  {
    alias: "aircraftrepairs",
    title: "Aircraft Repairs",
  },
  {
    alias: "airductcleaning",
    title: "Air Duct Cleaning",
  },
  {
    alias: "airlines",
    title: "Airlines",
  },
  {
    alias: "airport_shuttles",
    title: "Airport Shuttles",
  },
  {
    alias: "airportlounges",
    title: "Airport Lounges",
  },
  {
    alias: "airports",
    title: "Airports",
  },
  {
    alias: "airportterminals",
    title: "Airport Terminals",
  },
  {
    alias: "airsoft",
    title: "Airsoft",
  },
  {
    alias: "alentejo",
    title: "Alentejo",
  },
  {
    alias: "algarve",
    title: "Algarve",
  },
  {
    alias: "allergist",
    title: "Allergists",
  },
  {
    alias: "alsatian",
    title: "Alsatian",
  },
  {
    alias: "alternativemedicine",
    title: "Alternative Medicine",
  },
  {
    alias: "altoatesine",
    title: "Altoatesine",
  },
  {
    alias: "amateursportsteams",
    title: "Amateur Sports Teams",
  },
  {
    alias: "amusementparks",
    title: "Amusement Parks",
  },
  {
    alias: "andalusian",
    title: "Andalusian",
  },
  {
    alias: "anesthesiologists",
    title: "Anesthesiologists",
  },
  {
    alias: "animalassistedtherapy",
    title: "Animal Assisted Therapy",
  },
  {
    alias: "animalholistic",
    title: "Holistic Animal Care",
  },
  {
    alias: "animalphysicaltherapy",
    title: "Animal Physical Therapy",
  },
  {
    alias: "animalshelters",
    title: "Animal Shelters",
  },
  {
    alias: "antiques",
    title: "Antiques",
  },
  {
    alias: "apartmentagents",
    title: "Apartment Agents",
  },
  {
    alias: "apartments",
    title: "Apartments",
  },
  {
    alias: "appliances",
    title: "Appliances",
  },
  {
    alias: "appraisalservices",
    title: "Appraisal Services",
  },
  {
    alias: "apulian",
    title: "Apulian",
  },
  {
    alias: "aquariums",
    title: "Aquariums",
  },
  {
    alias: "aquariumservices",
    title: "Aquarium Services",
  },
  {
    alias: "arabian",
    title: "Arabic",
  },
  {
    alias: "arabpizza",
    title: "Arab Pizza",
  },
  {
    alias: "arcades",
    title: "Arcades",
  },
  {
    alias: "archery",
    title: "Archery",
  },
  {
    alias: "architects",
    title: "Architects",
  },
  {
    alias: "architecturaltours",
    title: "Architectural Tours",
  },
  {
    alias: "argentine",
    title: "Argentine",
  },
  {
    alias: "armenian",
    title: "Armenian",
  },
  {
    alias: "arroceria_paella",
    title: "Arroceria / Paella",
  },
  {
    alias: "artclasses",
    title: "Art Classes",
  },
  {
    alias: "artconsultants",
    title: "Art Consultants",
  },
  {
    alias: "artificialturf",
    title: "Artificial Turf",
  },
  {
    alias: "artinstallation",
    title: "Art Installation",
  },
  {
    alias: "artmuseums",
    title: "Art Museums",
  },
  {
    alias: "artrestoration",
    title: "Art Restoration",
  },
  {
    alias: "arts",
    title: "Arts & Entertainment",
  },
  {
    alias: "artsandcrafts",
    title: "Arts & Crafts",
  },
  {
    alias: "artschools",
    title: "Art Schools",
  },
  {
    alias: "artspacerentals",
    title: "Art Space Rentals",
  },
  {
    alias: "artsupplies",
    title: "Art Supplies",
  },
  {
    alias: "arttours",
    title: "Art Tours",
  },
  {
    alias: "asianfusion",
    title: "Asian Fusion",
  },
  {
    alias: "assistedliving",
    title: "Assisted Living Facilities",
  },
  {
    alias: "astrologers",
    title: "Astrologers",
  },
  {
    alias: "asturian",
    title: "Asturian",
  },
  {
    alias: "ateliers",
    title: "Ateliers",
  },
  {
    alias: "attractionfarms",
    title: "Attraction Farms",
  },
  {
    alias: "atvrentals",
    title: "ATV Rentals/Tours",
  },
  {
    alias: "auctionhouses",
    title: "Auction Houses",
  },
  {
    alias: "audiologist",
    title: "Audiologist",
  },
  {
    alias: "audiovisualequipmentrental",
    title: "Audio/Visual Equipment Rental",
  },
  {
    alias: "australian",
    title: "Australian",
  },
  {
    alias: "austrian",
    title: "Austrian",
  },
  {
    alias: "authorized_postal_representative",
    title: "Authorized Postal Representative",
  },
  {
    alias: "auto",
    title: "Automotive",
  },
  {
    alias: "auto_detailing",
    title: "Auto Detailing",
  },
  {
    alias: "autocustomization",
    title: "Auto Customization",
  },
  {
    alias: "autodamageassessment",
    title: "Car Inspectors",
  },
  {
    alias: "autoelectric",
    title: "Auto Electric Services",
  },
  {
    alias: "autoglass",
    title: "Auto Glass Services",
  },
  {
    alias: "autoinsurance",
    title: "Auto Insurance",
  },
  {
    alias: "autoloanproviders",
    title: "Auto Loan Providers",
  },
  {
    alias: "autopartssupplies",
    title: "Auto Parts & Supplies",
  },
  {
    alias: "autorepair",
    title: "Auto Repair",
  },
  {
    alias: "autosecurity",
    title: "Auto Security",
  },
  {
    alias: "autoupholstery",
    title: "Auto Upholstery",
  },
  {
    alias: "auvergnat",
    title: "Auvergnat",
  },
  {
    alias: "aviationservices",
    title: "Aviation Services",
  },
  {
    alias: "awnings",
    title: "Awnings",
  },
  {
    alias: "axethrowing",
    title: "Axe Throwing",
  },
  {
    alias: "ayurveda",
    title: "Ayurveda",
  },
  {
    alias: "azores",
    title: "Azores",
  },
  {
    alias: "baby_gear",
    title: "Baby Gear & Furniture",
  },
  {
    alias: "backflowservices",
    title: "Backflow Services",
  },
  {
    alias: "backshop",
    title: "Backshop",
  },
  {
    alias: "baden",
    title: "Baden",
  },
  {
    alias: "badminton",
    title: "Badminton",
  },
  {
    alias: "bagels",
    title: "Bagels",
  },
  {
    alias: "baguettes",
    title: "Baguettes",
  },
  {
    alias: "bailbondsmen",
    title: "Bail Bondsmen",
  },
  {
    alias: "bakeries",
    title: "Bakeries",
  },
  {
    alias: "balloonservices",
    title: "Balloon Services",
  },
  {
    alias: "bangladeshi",
    title: "Bangladeshi",
  },
  {
    alias: "bankruptcy",
    title: "Bankruptcy Law",
  },
  {
    alias: "banks",
    title: "Banks & Credit Unions",
  },
  {
    alias: "barbers",
    title: "Barbers",
  },
  {
    alias: "barcrawl",
    title: "Bar Crawl",
  },
  {
    alias: "barreclasses",
    title: "Barre Classes",
  },
  {
    alias: "bars",
    title: "Bars",
  },
  {
    alias: "bartenders",
    title: "Bartenders",
  },
  {
    alias: "bartendingschools",
    title: "Bartending Schools",
  },
  {
    alias: "baseballfields",
    title: "Baseball Fields",
  },
  {
    alias: "basketballcourts",
    title: "Basketball Courts",
  },
  {
    alias: "basque",
    title: "Basque",
  },
  {
    alias: "bathing_area",
    title: "Bathing Area",
  },
  {
    alias: "batterystores",
    title: "Battery Stores",
  },
  {
    alias: "battingcages",
    title: "Batting Cages",
  },
  {
    alias: "bavarian",
    title: "Bavarian",
  },
  {
    alias: "bbq",
    title: "Barbeque",
  },
  {
    alias: "beachbars",
    title: "Beach Bars",
  },
  {
    alias: "beachequipmentrental",
    title: "Beach Equipment Rentals",
  },
  {
    alias: "beaches",
    title: "Beaches",
  },
  {
    alias: "beachvolleyball",
    title: "Beach Volleyball",
  },
  {
    alias: "beautysvc",
    title: "Beauty & Spas",
  },
  {
    alias: "bedbreakfast",
    title: "Bed & Breakfast",
  },
  {
    alias: "beer_and_wine",
    title: "Beer, Wine & Spirits",
  },
  {
    alias: "beerbar",
    title: "Beer Bar",
  },
  {
    alias: "beergarden",
    title: "Beer Garden",
  },
  {
    alias: "beergardens",
    title: "Beer Gardens",
  },
  {
    alias: "beerhall",
    title: "Beer Hall",
  },
  {
    alias: "beertours",
    title: "Beer Tours",
  },
  {
    alias: "behavioranalysts",
    title: "Behavior Analysts",
  },
  {
    alias: "beira",
    title: "Beira",
  },
  {
    alias: "beisl",
    title: "Beisl",
  },
  {
    alias: "belgian",
    title: "Belgian",
  },
  {
    alias: "bento",
    title: "Bento",
  },
  {
    alias: "berrichon",
    title: "Berrichon",
  },
  {
    alias: "bespoke",
    title: "Bespoke Clothing",
  },
  {
    alias: "bettingcenters",
    title: "Betting Centers",
  },
  {
    alias: "beverage_stores",
    title: "Beverage Store",
  },
  {
    alias: "bicyclepaths",
    title: "Bicycle Paths",
  },
  {
    alias: "bicycles",
    title: "Bicycles",
  },
  {
    alias: "bike_repair_maintenance",
    title: "Bike Repair/Maintenance",
  },
  {
    alias: "bikeassociations",
    title: "Bike Associations",
  },
  {
    alias: "bikeparking",
    title: "Bike Parking",
  },
  {
    alias: "bikerentals",
    title: "Bike Rentals",
  },
  {
    alias: "bikerepair",
    title: "Bike Repair",
  },
  {
    alias: "bikes",
    title: "Bikes",
  },
  {
    alias: "bikesharing",
    title: "Bike Sharing",
  },
  {
    alias: "bikeshop",
    title: "Bike Shop",
  },
  {
    alias: "biketours",
    title: "Bike tours",
  },
  {
    alias: "billingservices",
    title: "Billing Services",
  },
  {
    alias: "bingo",
    title: "Bingo Halls",
  },
  {
    alias: "biohazardcleanup",
    title: "Biohazard Cleanup",
  },
  {
    alias: "birdshops",
    title: "Bird Shops",
  },
  {
    alias: "bistros",
    title: "Bistros",
  },
  {
    alias: "blacksea",
    title: "Black Sea",
  },
  {
    alias: "blinds",
    title: "Shades & Blinds",
  },
  {
    alias: "blooddonation",
    title: "Blood & Plasma Donation Centers",
  },
  {
    alias: "blowfish",
    title: "Blowfish",
  },
  {
    alias: "blowoutservices",
    title: "Blow Dry/Out Services",
  },
  {
    alias: "boatcharters",
    title: "Boat Charters",
  },
  {
    alias: "boatdealers",
    title: "Boat Dealers",
  },
  {
    alias: "boating",
    title: "Boating",
  },
  {
    alias: "boatpartsandsupplies",
    title: "Boat Parts & Supplies",
  },
  {
    alias: "boatrepair",
    title: "Boat Repair",
  },
  {
    alias: "boattours",
    title: "Boat Tours",
  },
  {
    alias: "bobsledding",
    title: "Bobsledding",
  },
  {
    alias: "bocceball",
    title: "Bocce Ball",
  },
  {
    alias: "bodycontouring",
    title: "Body Contouring",
  },
  {
    alias: "bodyshops",
    title: "Body Shops",
  },
  {
    alias: "bookbinding",
    title: "Bookbinding",
  },
  {
    alias: "bookkeepers",
    title: "Bookkeepers",
  },
  {
    alias: "bookstores",
    title: "Bookstores",
  },
  {
    alias: "bootcamps",
    title: "Boot Camps",
  },
  {
    alias: "boudoirphotography",
    title: "Boudoir Photography",
  },
  {
    alias: "bouncehouserentals",
    title: "Bounce House Rentals",
  },
  {
    alias: "bourguignon",
    title: "Bourguignon",
  },
  {
    alias: "bowling",
    title: "Bowling",
  },
  {
    alias: "boxing",
    title: "Boxing",
  },
  {
    alias: "brasseries",
    title: "Brasseries",
  },
  {
    alias: "brazilian",
    title: "Brazilian",
  },
  {
    alias: "brazilianempanadas",
    title: "Brazilian Empanadas",
  },
  {
    alias: "brazilianjiujitsu",
    title: "Brazilian Jiu-jitsu",
  },
  {
    alias: "breakfast_brunch",
    title: "Breakfast & Brunch",
  },
  {
    alias: "breweries",
    title: "Breweries",
  },
  {
    alias: "brewingsupplies",
    title: "Brewing Supplies",
  },
  {
    alias: "brewpubs",
    title: "Brewpubs",
  },
  {
    alias: "bridal",
    title: "Bridal",
  },
  {
    alias: "british",
    title: "British",
  },
  {
    alias: "bubblesoccer",
    title: "Bubble Soccer",
  },
  {
    alias: "bubbletea",
    title: "Bubble Tea",
  },
  {
    alias: "buddhist_temples",
    title: "Buddhist Temples",
  },
  {
    alias: "buffets",
    title: "Buffets",
  },
  {
    alias: "buildingsupplies",
    title: "Building Supplies",
  },
  {
    alias: "bulgarian",
    title: "Bulgarian",
  },
  {
    alias: "bulkbilling",
    title: "Bulk Billing",
  },
  {
    alias: "bungeejumping",
    title: "Bungee Jumping",
  },
  {
    alias: "burgers",
    title: "Burgers",
  },
  {
    alias: "burmese",
    title: "Burmese",
  },
  {
    alias: "buses",
    title: "Buses",
  },
  {
    alias: "businessconsulting",
    title: "Business Consulting",
  },
  {
    alias: "businessfinancing",
    title: "Business Financing",
  },
  {
    alias: "businesslawyers",
    title: "Business Law",
  },
  {
    alias: "busrental",
    title: "Bus Rental",
  },
  {
    alias: "busstations",
    title: "Bus Stations",
  },
  {
    alias: "bustours",
    title: "Bus Tours",
  },
  {
    alias: "butcher",
    title: "Butcher",
  },
  {
    alias: "c_and_mh",
    title: "Counseling & Mental Health",
  },
  {
    alias: "cabaret",
    title: "Cabaret",
  },
  {
    alias: "cabinetry",
    title: "Cabinetry",
  },
  {
    alias: "cablecars",
    title: "Cable Cars",
  },
  {
    alias: "cafes",
    title: "Cafes",
  },
  {
    alias: "cafeteria",
    title: "Cafeteria",
  },
  {
    alias: "cajun",
    title: "Cajun/Creole",
  },
  {
    alias: "cakeshop",
    title: "Patisserie/Cake Shop",
  },
  {
    alias: "calabrian",
    title: "Calabrian",
  },
  {
    alias: "calligraphy",
    title: "Calligraphy",
  },
  {
    alias: "cambodian",
    title: "Cambodian",
  },
  {
    alias: "campgrounds",
    title: "Campgrounds",
  },
  {
    alias: "candlestores",
    title: "Candle Stores",
  },
  {
    alias: "candy",
    title: "Candy Stores",
  },
  {
    alias: "cannabis_clinics",
    title: "Cannabis Clinics",
  },
  {
    alias: "cannabiscollective",
    title: "Cannabis Collective",
  },
  {
    alias: "cannabisdispensaries",
    title: "Cannabis Dispensaries",
  },
  {
    alias: "cannabisreferrals",
    title: "Medical Cannabis Referrals",
  },
  {
    alias: "cannabistours",
    title: "Cannabis Tours",
  },
  {
    alias: "canteen",
    title: "Canteen",
  },
  {
    alias: "cantonese",
    title: "Cantonese",
  },
  {
    alias: "canyoneering",
    title: "Canyoneering",
  },
  {
    alias: "car_dealers",
    title: "Car Dealers",
  },
  {
    alias: "carauctions",
    title: "Car Auctions",
  },
  {
    alias: "carbrokers",
    title: "Car Brokers",
  },
  {
    alias: "carbuyers",
    title: "Car Buyers",
  },
  {
    alias: "cardioclasses",
    title: "Cardio Classes",
  },
  {
    alias: "cardiology",
    title: "Cardiologists",
  },
  {
    alias: "careercounseling",
    title: "Career Counseling",
  },
  {
    alias: "caribbean",
    title: "Caribbean",
  },
  {
    alias: "caricatures",
    title: "Caricatures",
  },
  {
    alias: "carousels",
    title: "Carousels",
  },
  {
    alias: "carpenters",
    title: "Carpenters",
  },
  {
    alias: "carpet_cleaning",
    title: "Carpet Cleaning",
  },
  {
    alias: "carpetdyeing",
    title: "Carpet Dyeing",
  },
  {
    alias: "carpeting",
    title: "Carpeting",
  },
  {
    alias: "carpetinstallation",
    title: "Carpet Installation",
  },
  {
    alias: "carrental",
    title: "Car Rental",
  },
  {
    alias: "carshares",
    title: "Car Share Services",
  },
  {
    alias: "carwash",
    title: "Car Wash",
  },
  {
    alias: "carwindowtinting",
    title: "Car Window Tinting",
  },
  {
    alias: "casinos",
    title: "Casinos",
  },
  {
    alias: "castles",
    title: "Castles",
  },
  {
    alias: "catalan",
    title: "Catalan",
  },
  {
    alias: "catering",
    title: "Caterers",
  },
  {
    alias: "cellphoneaccessories",
    title: "Mobile Phone Accessories",
  },
  {
    alias: "centralbrazilian",
    title: "Central Brazilian",
  },
  {
    alias: "ceremonialclothing",
    title: "Ceremonial Clothing",
  },
  {
    alias: "challengecourses",
    title: "Challenge Courses",
  },
  {
    alias: "champagne_bars",
    title: "Champagne Bars",
  },
  {
    alias: "chech",
    title: "Chech",
  },
  {
    alias: "cheekufta",
    title: "Chee Kufta",
  },
  {
    alias: "cheerleading",
    title: "Cheerleading",
  },
  {
    alias: "cheese",
    title: "Cheese Shops",
  },
  {
    alias: "cheesesteaks",
    title: "Cheesesteaks",
  },
  {
    alias: "cheesetastingclasses",
    title: "Cheese Tasting Classes",
  },
  {
    alias: "chicken_wings",
    title: "Chicken Wings",
  },
  {
    alias: "chickenshop",
    title: "Chicken Shop",
  },
  {
    alias: "childbirthedu",
    title: "Childbirth Education",
  },
  {
    alias: "childcare",
    title: "Child Care & Day Care",
  },
  {
    alias: "childcloth",
    title: "Children's Clothing",
  },
  {
    alias: "childproofing",
    title: "Childproofing",
  },
  {
    alias: "childrensmuseums",
    title: "Children's Museums",
  },
  {
    alias: "chilean",
    title: "Chilean",
  },
  {
    alias: "chimneycakes",
    title: "Chimney Cakes",
  },
  {
    alias: "chimneysweeps",
    title: "Chimney Sweeps",
  },
  {
    alias: "chinese",
    title: "Chinese",
  },
  {
    alias: "chinesebazaar",
    title: "Chinese Bazaar",
  },
  {
    alias: "chinesemartialarts",
    title: "Chinese Martial Arts",
  },
  {
    alias: "chiropractors",
    title: "Chiropractors",
  },
  {
    alias: "chocolate",
    title: "Chocolatiers & Shops",
  },
  {
    alias: "choirs",
    title: "Choirs",
  },
  {
    alias: "christmastrees",
    title: "Christmas Trees",
  },
  {
    alias: "churches",
    title: "Churches",
  },
  {
    alias: "churros",
    title: "Churros",
  },
  {
    alias: "cideries",
    title: "Cideries",
  },
  {
    alias: "cigarbars",
    title: "Cigar Bars",
  },
  {
    alias: "circuittraininggyms",
    title: "Circuit Training Gyms",
  },
  {
    alias: "circusschools",
    title: "Circus Schools",
  },
  {
    alias: "civiccenter",
    title: "Civic Center",
  },
  {
    alias: "climbing",
    title: "Climbing",
  },
  {
    alias: "clockrepair",
    title: "Clock Repair",
  },
  {
    alias: "clothingrental",
    title: "Clothing Rental",
  },
  {
    alias: "clowns",
    title: "Clowns",
  },
  {
    alias: "clubcrawl",
    title: "Club Crawl",
  },
  {
    alias: "cocktailbars",
    title: "Cocktail Bars",
  },
  {
    alias: "coffee",
    title: "Coffee & Tea",
  },
  {
    alias: "coffeeroasteries",
    title: "Coffee Roasteries",
  },
  {
    alias: "coffeeshops",
    title: "Coffeeshops",
  },
  {
    alias: "coffeeteasupplies",
    title: "Coffee & Tea Supplies",
  },
  {
    alias: "collegecounseling",
    title: "College Counseling",
  },
  {
    alias: "collegeuniv",
    title: "Colleges & Universities",
  },
  {
    alias: "colombian",
    title: "Colombian",
  },
  {
    alias: "colonics",
    title: "Colonics",
  },
  {
    alias: "comedyclubs",
    title: "Comedy Clubs",
  },
  {
    alias: "comfortfood",
    title: "Comfort Food",
  },
  {
    alias: "comicbooks",
    title: "Comic Books",
  },
  {
    alias: "commercialrealestate",
    title: "Commercial Real Estate",
  },
  {
    alias: "commissionedartists",
    title: "Commissioned Artists",
  },
  {
    alias: "communitybookbox",
    title: "Community Book Box",
  },
  {
    alias: "communitycenters",
    title: "Community Centers",
  },
  {
    alias: "communitygardens",
    title: "Community Gardens",
  },
  {
    alias: "computers",
    title: "Computers",
  },
  {
    alias: "concept_shops",
    title: "Concept Shops",
  },
  {
    alias: "conciergemedicine",
    title: "Concierge Medicine",
  },
  {
    alias: "condominiums",
    title: "Condominiums",
  },
  {
    alias: "congee",
    title: "Congee",
  },
  {
    alias: "consumerlaw",
    title: "Consumer Law",
  },
  {
    alias: "contractlaw",
    title: "Contract Law",
  },
  {
    alias: "contractors",
    title: "General Contractors",
  },
  {
    alias: "convenience",
    title: "Convenience Stores",
  },
  {
    alias: "conveyorsushi",
    title: "Conveyor Belt Sushi",
  },
  {
    alias: "cookingclasses",
    title: "Cooking Classes",
  },
  {
    alias: "cookingschools",
    title: "Cooking Schools",
  },
  {
    alias: "copyshops",
    title: "Printing Services",
  },
  {
    alias: "corsican",
    title: "Corsican",
  },
  {
    alias: "cosmeticdentists",
    title: "Cosmetic Dentists",
  },
  {
    alias: "cosmetics",
    title: "Cosmetics & Beauty Supply",
  },
  {
    alias: "cosmeticsurgeons",
    title: "Cosmetic Surgeons",
  },
  {
    alias: "cosmetology_schools",
    title: "Cosmetology Schools",
  },
  {
    alias: "costumes",
    title: "Costumes",
  },
  {
    alias: "countertopinstall",
    title: "Countertop Installation",
  },
  {
    alias: "countryclubs",
    title: "Country Clubs",
  },
  {
    alias: "countrydancehalls",
    title: "Country Dance Halls",
  },
  {
    alias: "couriers",
    title: "Couriers & Delivery Services",
  },
  {
    alias: "courthouses",
    title: "Courthouses",
  },
  {
    alias: "courtreporters",
    title: "Court Reporters",
  },
  {
    alias: "cprclasses",
    title: "CPR Classes",
  },
  {
    alias: "craneservices",
    title: "Crane Services",
  },
  {
    alias: "cremationservices",
    title: "Cremation Services",
  },
  {
    alias: "creperies",
    title: "Creperies",
  },
  {
    alias: "criminaldefense",
    title: "Criminal Defense Law",
  },
  {
    alias: "crisispregnancycenters",
    title: "Crisis Pregnancy Centers",
  },
  {
    alias: "cryotherapy",
    title: "Cryotherapy",
  },
  {
    alias: "csa",
    title: "CSA",
  },
  {
    alias: "cuban",
    title: "Cuban",
  },
  {
    alias: "cucinacampana",
    title: "Cucina campana",
  },
  {
    alias: "culturalcenter",
    title: "Cultural Center",
  },
  {
    alias: "cupcakes",
    title: "Cupcakes",
  },
  {
    alias: "currencyexchange",
    title: "Currency Exchange",
  },
  {
    alias: "currysausage",
    title: "Curry Sausage",
  },
  {
    alias: "customcakes",
    title: "Custom Cakes",
  },
  {
    alias: "custommerchandise",
    title: "Customized Merchandise",
  },
  {
    alias: "customsbrokers",
    title: "Customs Brokers",
  },
  {
    alias: "cyclingclasses",
    title: "Cycling Classes",
  },
  {
    alias: "cypriot",
    title: "Cypriot",
  },
  {
    alias: "czech",
    title: "Czech",
  },
  {
    alias: "czechslovakian",
    title: "Czech/Slovakian",
  },
  {
    alias: "dagashi",
    title: "Dagashi",
  },
  {
    alias: "damagerestoration",
    title: "Damage Restoration",
  },
  {
    alias: "dance_schools",
    title: "Dance Schools",
  },
  {
    alias: "danceclubs",
    title: "Dance Clubs",
  },
  {
    alias: "dancerestaurants",
    title: "Dance Restaurants",
  },
  {
    alias: "dancestudio",
    title: "Dance Studios",
  },
  {
    alias: "dancewear",
    title: "Dance Wear",
  },
  {
    alias: "danish",
    title: "Danish",
  },
  {
    alias: "dartarenas",
    title: "Dart Arenas",
  },
  {
    alias: "datarecovery",
    title: "Data Recovery",
  },
  {
    alias: "daycamps",
    title: "Day Camps",
  },
  {
    alias: "debtrelief",
    title: "Debt Relief Services",
  },
  {
    alias: "decksrailing",
    title: "Decks & Railing",
  },
  {
    alias: "delicatessen",
    title: "Delicatessen",
  },
  {
    alias: "delis",
    title: "Delis",
  },
  {
    alias: "demolitionservices",
    title: "Demolition Services",
  },
  {
    alias: "dentalhygeiniststorefront",
    title: "Storefront Clinics",
  },
  {
    alias: "dentalhygienists",
    title: "Dental Hygienists",
  },
  {
    alias: "dentalhygienistsmobile",
    title: "Mobile Clinics",
  },
  {
    alias: "dentists",
    title: "Dentists",
  },
  {
    alias: "departmentsofmotorvehicles",
    title: "Departments of Motor Vehicles",
  },
  {
    alias: "deptstores",
    title: "Department Stores",
  },
  {
    alias: "dermatology",
    title: "Dermatologists",
  },
  {
    alias: "desserts",
    title: "Desserts",
  },
  {
    alias: "diagnosticimaging",
    title: "Diagnostic Imaging",
  },
  {
    alias: "diagnosticservices",
    title: "Diagnostic Services",
  },
  {
    alias: "dialysisclinics",
    title: "Dialysis Clinics",
  },
  {
    alias: "diamondbuyers",
    title: "Diamond Buyers",
  },
  {
    alias: "dietitians",
    title: "Dietitians",
  },
  {
    alias: "digitizingservices",
    title: "Digitizing Services",
  },
  {
    alias: "dimsum",
    title: "Dim Sum",
  },
  {
    alias: "diners",
    title: "Diners",
  },
  {
    alias: "dinnertheater",
    title: "Dinner Theater",
  },
  {
    alias: "disabilitylaw",
    title: "Disability Law",
  },
  {
    alias: "discgolf",
    title: "Disc Golf",
  },
  {
    alias: "discountstore",
    title: "Discount Store",
  },
  {
    alias: "distilleries",
    title: "Distilleries",
  },
  {
    alias: "divebars",
    title: "Dive Bars",
  },
  {
    alias: "diveshops",
    title: "Dive Shops",
  },
  {
    alias: "diving",
    title: "Diving",
  },
  {
    alias: "divorce",
    title: "Divorce & Family Law",
  },
  {
    alias: "diyautoshop",
    title: "DIY Auto Shop",
  },
  {
    alias: "diyfood",
    title: "Do-It-Yourself Food",
  },
  {
    alias: "djs",
    title: "DJs",
  },
  {
    alias: "dog_parks",
    title: "Dog Parks",
  },
  {
    alias: "dogwalkers",
    title: "Dog Walkers",
  },
  {
    alias: "dolmusstation",
    title: "Dolmus Station",
  },
  {
    alias: "dominican",
    title: "Dominican",
  },
  {
    alias: "donairs",
    title: "Donairs",
  },
  {
    alias: "donationcenter",
    title: "Donation Center",
  },
  {
    alias: "donburi",
    title: "Donburi",
  },
  {
    alias: "donuts",
    title: "Donuts",
  },
  {
    alias: "doorsales",
    title: "Door Sales/Installation",
  },
  {
    alias: "doulas",
    title: "Doulas",
  },
  {
    alias: "dramaschools",
    title: "Drama Schools",
  },
  {
    alias: "driedfruit",
    title: "Dried Fruit",
  },
  {
    alias: "driveintheater",
    title: "Drive-In Theater",
  },
  {
    alias: "drivethrubars",
    title: "Drive-Thru Bars",
  },
  {
    alias: "driving_schools",
    title: "Driving Schools",
  },
  {
    alias: "drones",
    title: "Drones",
  },
  {
    alias: "drugstores",
    title: "Drugstores",
  },
  {
    alias: "dryclean",
    title: "Dry Cleaning",
  },
  {
    alias: "drycleaninglaundry",
    title: "Dry Cleaning & Laundry",
  },
  {
    alias: "drywall",
    title: "Drywall Installation & Repair",
  },
  {
    alias: "duilawyers",
    title: "DUI Law",
  },
  {
    alias: "duischools",
    title: "DUI Schools",
  },
  {
    alias: "dumplings",
    title: "Dumplings",
  },
  {
    alias: "dumpsterrental",
    title: "Dumpster Rental",
  },
  {
    alias: "duplicationservices",
    title: "Duplication Services",
  },
  {
    alias: "dutyfreeshops",
    title: "Duty-Free Shops",
  },
  {
    alias: "earnosethroat",
    title: "Ear Nose & Throat",
  },
  {
    alias: "eastern_european",
    title: "Eastern European",
  },
  {
    alias: "easterngerman",
    title: "Eastern German",
  },
  {
    alias: "easternmexican",
    title: "Eastern Mexican",
  },
  {
    alias: "eatertainment",
    title: "Eatertainment",
  },
  {
    alias: "editorialservices",
    title: "Editorial Services",
  },
  {
    alias: "education",
    title: "Education",
  },
  {
    alias: "educationservices",
    title: "Educational Services",
  },
  {
    alias: "egyptian",
    title: "Egyptian",
  },
  {
    alias: "eldercareplanning",
    title: "Elder Care Planning",
  },
  {
    alias: "elderlaw",
    title: "Elder Law",
  },
  {
    alias: "electricians",
    title: "Electricians",
  },
  {
    alias: "electricitysuppliers",
    title: "Electricity Suppliers",
  },
  {
    alias: "electronics",
    title: "Electronics",
  },
  {
    alias: "electronicsrepair",
    title: "Electronics Repair",
  },
  {
    alias: "elementaryschools",
    title: "Elementary Schools",
  },
  {
    alias: "elevatorservices",
    title: "Elevator Services",
  },
  {
    alias: "eltern_cafes",
    title: "Parent Cafes",
  },
  {
    alias: "embassy",
    title: "Embassy",
  },
  {
    alias: "embroideryandcrochet",
    title: "Embroidery & Crochet",
  },
  {
    alias: "emergencymedicine",
    title: "Emergency Medicine",
  },
  {
    alias: "emergencypethospital",
    title: "Emergency Pet Hospital",
  },
  {
    alias: "emergencyrooms",
    title: "Emergency Rooms",
  },
  {
    alias: "emilian",
    title: "Emilian",
  },
  {
    alias: "empanadas",
    title: "Empanadas",
  },
  {
    alias: "employmentagencies",
    title: "Employment Agencies",
  },
  {
    alias: "employmentlawyers",
    title: "Employment Law",
  },
  {
    alias: "emstraining",
    title: "EMS Training",
  },
  {
    alias: "endocrinologists",
    title: "Endocrinologists",
  },
  {
    alias: "endodontists",
    title: "Endodontists",
  },
  {
    alias: "engraving",
    title: "Engraving",
  },
  {
    alias: "entertainmentlaw",
    title: "Entertainment Law",
  },
  {
    alias: "enviroabatement",
    title: "Environmental Abatement",
  },
  {
    alias: "environmentaltesting",
    title: "Environmental Testing",
  },
  {
    alias: "eritrean",
    title: "Eritrean",
  },
  {
    alias: "eroticmassage",
    title: "Erotic Massage",
  },
  {
    alias: "escapegames",
    title: "Escape Games",
  },
  {
    alias: "estateliquidation",
    title: "Estate Liquidation",
  },
  {
    alias: "estatephotography",
    title: "Real Estate Photography",
  },
  {
    alias: "estateplanning",
    title: "Estate Planning Law",
  },
  {
    alias: "estheticians",
    title: "Estheticians",
  },
  {
    alias: "ethicgrocery",
    title: "Ethical Grocery",
  },
  {
    alias: "ethiopian",
    title: "Ethiopian",
  },
  {
    alias: "ethnicgrocery",
    title: "Ethnic Grocery",
  },
  {
    alias: "ethnicmarkets",
    title: "Ethnic Food",
  },
  {
    alias: "evchargingstations",
    title: "EV Charging Stations",
  },
  {
    alias: "eventphotography",
    title: "Event Photography",
  },
  {
    alias: "eventplanning",
    title: "Party & Event Planning",
  },
  {
    alias: "eventservices",
    title: "Event Planning & Services",
  },
  {
    alias: "excavationservices",
    title: "Excavation Services",
  },
  {
    alias: "experiences",
    title: "Experiences",
  },
  {
    alias: "eyebrowservices",
    title: "Eyebrow Services",
  },
  {
    alias: "eyelashservice",
    title: "Eyelash Service",
  },
  {
    alias: "fabricstores",
    title: "Fabric Stores",
  },
  {
    alias: "facepainting",
    title: "Face Painting",
  },
  {
    alias: "fado_houses",
    title: "Fado Houses",
  },
  {
    alias: "faithbasedcpc",
    title: "Faith-based Crisis Pregnancy Centers",
  },
  {
    alias: "falafel",
    title: "Falafel",
  },
  {
    alias: "familydr",
    title: "Family Practice",
  },
  {
    alias: "farmequipmentrepair",
    title: "Farm Equipment Repair",
  },
  {
    alias: "farmersmarket",
    title: "Farmers Market",
  },
  {
    alias: "farmingequipment",
    title: "Farming Equipment",
  },
  {
    alias: "farms",
    title: "Farms",
  },
  {
    alias: "farriers",
    title: "Farriers",
  },
  {
    alias: "fashion",
    title: "Fashion",
  },
  {
    alias: "fasil",
    title: "Fasil Music",
  },
  {
    alias: "fencesgates",
    title: "Fences & Gates",
  },
  {
    alias: "fencing",
    title: "Fencing Clubs",
  },
  {
    alias: "fengshui",
    title: "Feng Shui",
  },
  {
    alias: "ferries",
    title: "Ferries",
  },
  {
    alias: "fertility",
    title: "Fertility",
  },
  {
    alias: "festivals",
    title: "Festivals",
  },
  {
    alias: "filipino",
    title: "Filipino",
  },
  {
    alias: "financialadvising",
    title: "Financial Advising",
  },
  {
    alias: "financialservices",
    title: "Financial Services",
  },
  {
    alias: "fingerprinting",
    title: "Fingerprinting",
  },
  {
    alias: "firearmtraining",
    title: "Firearm Training",
  },
  {
    alias: "firedepartments",
    title: "Fire Departments",
  },
  {
    alias: "fireplace",
    title: "Fireplace Services",
  },
  {
    alias: "fireprotection",
    title: "Fire Protection Services",
  },
  {
    alias: "firewood",
    title: "Firewood",
  },
  {
    alias: "fireworks",
    title: "Fireworks",
  },
  {
    alias: "firstaidclasses",
    title: "First Aid Classes",
  },
  {
    alias: "fischbroetchen",
    title: "Fischbroetchen",
  },
  {
    alias: "fishing",
    title: "Fishing",
  },
  {
    alias: "fishmonger",
    title: "Fishmonger",
  },
  {
    alias: "fishnchips",
    title: "Fish & Chips",
  },
  {
    alias: "fitness",
    title: "Fitness & Instruction",
  },
  {
    alias: "fitnessequipment",
    title: "Fitness/Exercise Equipment",
  },
  {
    alias: "flatbread",
    title: "Flatbread",
  },
  {
    alias: "fleamarkets",
    title: "Flea Markets",
  },
  {
    alias: "flemish",
    title: "Flemish",
  },
  {
    alias: "flightinstruction",
    title: "Flight Instruction",
  },
  {
    alias: "floatspa",
    title: "Float Spa",
  },
  {
    alias: "flooring",
    title: "Flooring",
  },
  {
    alias: "floraldesigners",
    title: "Floral Designers",
  },
  {
    alias: "florists",
    title: "Florists",
  },
  {
    alias: "flowers",
    title: "Flowers & Gifts",
  },
  {
    alias: "flowersonly",
    title: "Flowers",
  },
  {
    alias: "flyboarding",
    title: "Flyboarding",
  },
  {
    alias: "fondue",
    title: "Fondue",
  },
  {
    alias: "food",
    title: "Food",
  },
  {
    alias: "food_court",
    title: "Food Court",
  },
  {
    alias: "foodbanks",
    title: "Food Banks",
  },
  {
    alias: "fooddeliveryservices",
    title: "Food Delivery Services",
  },
  {
    alias: "foodsafety",
    title: "Food Safety Training",
  },
  {
    alias: "foodstands",
    title: "Food Stands",
  },
  {
    alias: "foodtours",
    title: "Food Tours",
  },
  {
    alias: "foodtrucks",
    title: "Food Trucks",
  },
  {
    alias: "football",
    title: "Soccer",
  },
  {
    alias: "footcare",
    title: "Foot Care",
  },
  {
    alias: "forestry",
    title: "Forestry",
  },
  {
    alias: "formalwear",
    title: "Formal Wear",
  },
  {
    alias: "foundationrepair",
    title: "Foundation Repair",
  },
  {
    alias: "framing",
    title: "Framing",
  },
  {
    alias: "franconian",
    title: "Franconian",
  },
  {
    alias: "freediving",
    title: "Free Diving",
  },
  {
    alias: "freiduria",
    title: "Freiduria",
  },
  {
    alias: "french",
    title: "French",
  },
  {
    alias: "friterie",
    title: "Friterie",
  },
  {
    alias: "friulan",
    title: "Friulan",
  },
  {
    alias: "frozenfood",
    title: "Frozen Food",
  },
  {
    alias: "fueldocks",
    title: "Fuel Docks",
  },
  {
    alias: "funeralservices",
    title: "Funeral Services & Cemeteries",
  },
  {
    alias: "funfair",
    title: "Fun Fair",
  },
  {
    alias: "furclothing",
    title: "Fur Clothing",
  },
  {
    alias: "furniture",
    title: "Furniture Stores",
  },
  {
    alias: "furnitureassembly",
    title: "Furniture Assembly",
  },
  {
    alias: "furniturerepair",
    title: "Furniture Repair",
  },
  {
    alias: "fuzhou",
    title: "Fuzhou",
  },
  {
    alias: "galician",
    title: "Galician",
  },
  {
    alias: "galleries",
    title: "Art Galleries",
  },
  {
    alias: "gamemeat",
    title: "Game Meat",
  },
  {
    alias: "gametruckrental",
    title: "Game Truck Rental",
  },
  {
    alias: "garage_door_services",
    title: "Garage Door Services",
  },
  {
    alias: "gardeners",
    title: "Gardeners",
  },
  {
    alias: "gardening",
    title: "Nurseries & Gardening",
  },
  {
    alias: "gardens",
    title: "Botanical Gardens",
  },
  {
    alias: "gasstations",
    title: "Gas Stations",
  },
  {
    alias: "gastroenterologist",
    title: "Gastroenterologist",
  },
  {
    alias: "gastropubs",
    title: "Gastropubs",
  },
  {
    alias: "gaybars",
    title: "Gay Bars",
  },
  {
    alias: "gelato",
    title: "Gelato",
  },
  {
    alias: "gemstonesandminerals",
    title: "Gemstones & Minerals",
  },
  {
    alias: "general_litigation",
    title: "General Litigation",
  },
  {
    alias: "generaldentistry",
    title: "General Dentistry",
  },
  {
    alias: "generalfestivals",
    title: "General Festivals",
  },
  {
    alias: "generatorinstallrepair",
    title: "Generator Installation/Repair",
  },
  {
    alias: "geneticists",
    title: "Geneticists",
  },
  {
    alias: "georgian",
    title: "Georgian",
  },
  {
    alias: "german",
    title: "German",
  },
  {
    alias: "gerontologist",
    title: "Gerontologists",
  },
  {
    alias: "gestorias",
    title: "Gestorias",
  },
  {
    alias: "giblets",
    title: "Giblets",
  },
  {
    alias: "giftshops",
    title: "Gift Shops",
  },
  {
    alias: "glassandmirrors",
    title: "Glass & Mirrors",
  },
  {
    alias: "glassblowing",
    title: "Glass Blowing",
  },
  {
    alias: "gliding",
    title: "Gliding",
  },
  {
    alias: "gluhwein",
    title: "Mulled Wine",
  },
  {
    alias: "gluten_free",
    title: "Gluten-Free",
  },
  {
    alias: "gokarts",
    title: "Go Karts",
  },
  {
    alias: "goldbuyers",
    title: "Gold Buyers",
  },
  {
    alias: "golf",
    title: "Golf",
  },
  {
    alias: "golfcartdealers",
    title: "Golf Cart Dealers",
  },
  {
    alias: "golfcartrentals",
    title: "Golf Cart Rentals",
  },
  {
    alias: "golfequipment",
    title: "Golf Equipment",
  },
  {
    alias: "golflessons",
    title: "Golf Lessons",
  },
  {
    alias: "golfshops",
    title: "Golf Equipment Shops",
  },
  {
    alias: "gourmet",
    title: "Specialty Food",
  },
  {
    alias: "gozleme",
    title: "Gozleme",
  },
  {
    alias: "graphicdesign",
    title: "Graphic Design",
  },
  {
    alias: "greek",
    title: "Greek",
  },
  {
    alias: "grillingequipment",
    title: "Grilling Equipment",
  },
  {
    alias: "grillservices",
    title: "Grill Services",
  },
  {
    alias: "grocery",
    title: "Grocery",
  },
  {
    alias: "groomer",
    title: "Pet Groomers",
  },
  {
    alias: "groutservices",
    title: "Grout Services",
  },
  {
    alias: "guamanian",
    title: "Guamanian",
  },
  {
    alias: "guesthouses",
    title: "Guest Houses",
  },
  {
    alias: "guitarstores",
    title: "Guitar Stores",
  },
  {
    alias: "gun_ranges",
    title: "Gun/Rifle Ranges",
  },
  {
    alias: "guns_and_ammo",
    title: "Guns & Ammo",
  },
  {
    alias: "gunsmith",
    title: "Gunsmith",
  },
  {
    alias: "gutterservices",
    title: "Gutter Services",
  },
  {
    alias: "gymnastics",
    title: "Gymnastics",
  },
  {
    alias: "gyms",
    title: "Gyms",
  },
  {
    alias: "gyudon",
    title: "Gyudon",
  },
  {
    alias: "habilitativeservices",
    title: "Habilitative Services",
  },
  {
    alias: "hainan",
    title: "Hainan",
  },
  {
    alias: "hair",
    title: "Hair Salons",
  },
  {
    alias: "hair_extensions",
    title: "Hair Extensions",
  },
  {
    alias: "hairloss",
    title: "Hair Loss Centers",
  },
  {
    alias: "hairremoval",
    title: "Hair Removal",
  },
  {
    alias: "hairstylists",
    title: "Hair Stylists",
  },
  {
    alias: "haitian",
    title: "Haitian",
  },
  {
    alias: "hakka",
    title: "Hakka",
  },
  {
    alias: "halal",
    title: "Halal",
  },
  {
    alias: "halfwayhouses",
    title: "Halfway Houses",
  },
  {
    alias: "halotherapy",
    title: "Halotherapy",
  },
  {
    alias: "handball",
    title: "Handball",
  },
  {
    alias: "handrolls",
    title: "Hand Rolls",
  },
  {
    alias: "handyman",
    title: "Handyman",
  },
  {
    alias: "hanggliding",
    title: "Hang Gliding",
  },
  {
    alias: "hardware",
    title: "Hardware Stores",
  },
  {
    alias: "hats",
    title: "Hats",
  },
  {
    alias: "hauntedhouses",
    title: "Haunted Houses",
  },
  {
    alias: "hawaiian",
    title: "Hawaiian",
  },
  {
    alias: "hawkercentre",
    title: "Hawker Centre",
  },
  {
    alias: "hazardouswastedisposal",
    title: "Hazardous Waste Disposal",
  },
  {
    alias: "headshops",
    title: "Head Shops",
  },
  {
    alias: "health",
    title: "Health & Medical",
  },
  {
    alias: "healthcoach",
    title: "Health Coach",
  },
  {
    alias: "healthinsurance",
    title: "Health Insurance Offices",
  },
  {
    alias: "healthmarkets",
    title: "Health Markets",
  },
  {
    alias: "healthretreats",
    title: "Health Retreats",
  },
  {
    alias: "healthtrainers",
    title: "Trainers",
  },
  {
    alias: "hearing_aids",
    title: "Hearing Aids",
  },
  {
    alias: "hearingaidproviders",
    title: "Hearing Aid Providers",
  },
  {
    alias: "henghwa",
    title: "Henghwa",
  },
  {
    alias: "hennaartists",
    title: "Henna Artists",
  },
  {
    alias: "hepatologists",
    title: "Hepatologists",
  },
  {
    alias: "herbalshops",
    title: "Herbal Shops",
  },
  {
    alias: "herbsandspices",
    title: "Herbs & Spices",
  },
  {
    alias: "hessian",
    title: "Hessian",
  },
  {
    alias: "heuriger",
    title: "Heuriger",
  },
  {
    alias: "hifi",
    title: "High Fidelity Audio Equipment",
  },
  {
    alias: "highschools",
    title: "Middle Schools & High Schools",
  },
  {
    alias: "hiking",
    title: "Hiking",
  },
  {
    alias: "himalayan",
    title: "Himalayan/Nepalese",
  },
  {
    alias: "hindu_temples",
    title: "Hindu Temples",
  },
  {
    alias: "historicaltours",
    title: "Historical Tours",
  },
  {
    alias: "hkcafe",
    title: "Hong Kong Style Cafe",
  },
  {
    alias: "hobbyshops",
    title: "Hobby Shops",
  },
  {
    alias: "hockeyequipment",
    title: "Hockey Equipment",
  },
  {
    alias: "hokkien",
    title: "Hokkien",
  },
  {
    alias: "holidaydecorations",
    title: "Holiday Decorations",
  },
  {
    alias: "home_inspectors",
    title: "Home Inspectors",
  },
  {
    alias: "home_organization",
    title: "Home Organization",
  },
  {
    alias: "homeandgarden",
    title: "Home & Garden",
  },
  {
    alias: "homeappliancerepair",
    title: "Appliances & Repair",
  },
  {
    alias: "homeautomation",
    title: "Home Automation",
  },
  {
    alias: "homecleaning",
    title: "Home Cleaning",
  },
  {
    alias: "homedecor",
    title: "Home Decor",
  },
  {
    alias: "homedevelopers",
    title: "Home Developers",
  },
  {
    alias: "homeenergyauditors",
    title: "Home Energy Auditors",
  },
  {
    alias: "homehealthcare",
    title: "Home Health Care",
  },
  {
    alias: "homeinsurance",
    title: "Home & Rental Insurance",
  },
  {
    alias: "homelessshelters",
    title: "Homeless Shelters",
  },
  {
    alias: "homemadefood",
    title: "Homemade Food",
  },
  {
    alias: "homenetworkinstall",
    title: "Home Network Installation",
  },
  {
    alias: "homeopathic",
    title: "Homeopathic",
  },
  {
    alias: "homeownerassociation",
    title: "Homeowner Association",
  },
  {
    alias: "homeservices",
    title: "Home Services",
  },
  {
    alias: "homestaging",
    title: "Home Staging",
  },
  {
    alias: "hometheatreinstallation",
    title: "Home Theatre Installation",
  },
  {
    alias: "homewindowtinting",
    title: "Home Window Tinting",
  },
  {
    alias: "honduran",
    title: "Honduran",
  },
  {
    alias: "honey",
    title: "Honey",
  },
  {
    alias: "hookah_bars",
    title: "Hookah Bars",
  },
  {
    alias: "horse_boarding",
    title: "Horse Boarding",
  },
  {
    alias: "horsebackriding",
    title: "Horseback Riding",
  },
  {
    alias: "horsequipment",
    title: "Horse Equipment Shops",
  },
  {
    alias: "horseracing",
    title: "Horse Racing",
  },
  {
    alias: "horumon",
    title: "Horumon",
  },
  {
    alias: "hospice",
    title: "Hospice",
  },
  {
    alias: "hospitalists",
    title: "Hospitalists",
  },
  {
    alias: "hospitals",
    title: "Hospitals",
  },
  {
    alias: "hostels",
    title: "Hostels",
  },
  {
    alias: "hot_air_balloons",
    title: "Hot Air Balloons",
  },
  {
    alias: "hotdog",
    title: "Hot Dogs",
  },
  {
    alias: "hotdogs",
    title: "Fast Food",
  },
  {
    alias: "hotel_bar",
    title: "Hotel bar",
  },
  {
    alias: "hotels",
    title: "Hotels",
  },
  {
    alias: "hotelstravel",
    title: "Hotels & Travel",
  },
  {
    alias: "hotpot",
    title: "Hot Pot",
  },
  {
    alias: "hotsprings",
    title: "Hot Springs",
  },
  {
    alias: "hottubandpool",
    title: "Hot Tub & Pool",
  },
  {
    alias: "housesitters",
    title: "House Sitters",
  },
  {
    alias: "housingcooperatives",
    title: "Housing Cooperatives",
  },
  {
    alias: "hunan",
    title: "Hunan",
  },
  {
    alias: "hungarian",
    title: "Hungarian",
  },
  {
    alias: "huntingfishingsupplies",
    title: "Hunting & Fishing Supplies",
  },
  {
    alias: "hvac",
    title: "Heating & Air Conditioning/HVAC",
  },
  {
    alias: "hybridcarrepair",
    title: "Hybrid Car Repair",
  },
  {
    alias: "hydrojetting",
    title: "Hydro-jetting",
  },
  {
    alias: "hydroponics",
    title: "Hydroponics",
  },
  {
    alias: "hydrotherapy",
    title: "Hydrotherapy",
  },
  {
    alias: "hypnosis",
    title: "Hypnosis/Hypnotherapy",
  },
  {
    alias: "iberian",
    title: "Iberian",
  },
  {
    alias: "icecream",
    title: "Ice Cream & Frozen Yogurt",
  },
  {
    alias: "icedelivery",
    title: "Ice Delivery",
  },
  {
    alias: "immigrationlawyers",
    title: "Immigration Law",
  },
  {
    alias: "immunodermatologists",
    title: "Immunodermatologists",
  },
  {
    alias: "importedfood",
    title: "Imported Food",
  },
  {
    alias: "indonesian",
    title: "Indonesian",
  },
  {
    alias: "indoor_playcenter",
    title: "Indoor Playcentre",
  },
  {
    alias: "indoorlandscaping",
    title: "Indoor Landscaping",
  },
  {
    alias: "indpak",
    title: "Indian",
  },
  {
    alias: "infectiousdisease",
    title: "Infectious Disease Specialists",
  },
  {
    alias: "installmentloans",
    title: "Installment Loans",
  },
  {
    alias: "insulationinstallation",
    title: "Insulation Installation",
  },
  {
    alias: "insurance",
    title: "Insurance",
  },
  {
    alias: "interiordesign",
    title: "Interior Design",
  },
  {
    alias: "interlocksystems",
    title: "Interlock Systems",
  },
  {
    alias: "internalmed",
    title: "Internal Medicine",
  },
  {
    alias: "international",
    title: "International",
  },
  {
    alias: "internetbooth",
    title: "Internet Booths & Calling Centers",
  },
  {
    alias: "internetcafe",
    title: "Internet Cafes",
  },
  {
    alias: "intervaltraininggyms",
    title: "Interval Training Gyms",
  },
  {
    alias: "intlgrocery",
    title: "International Grocery",
  },
  {
    alias: "investing",
    title: "Investing",
  },
  {
    alias: "iplaw",
    title: "IP & Internet Law",
  },
  {
    alias: "irish",
    title: "Irish",
  },
  {
    alias: "irish_pubs",
    title: "Irish Pub",
  },
  {
    alias: "irrigation",
    title: "Irrigation",
  },
  {
    alias: "island_pub",
    title: "Island Pub",
  },
  {
    alias: "isps",
    title: "Internet Service Providers",
  },
  {
    alias: "israeli",
    title: "Israeli",
  },
  {
    alias: "italian",
    title: "Italian",
  },
  {
    alias: "itservices",
    title: "IT Services & Computer Repair",
  },
  {
    alias: "ivhydration",
    title: "IV Hydration",
  },
  {
    alias: "izakaya",
    title: "Izakaya",
  },
  {
    alias: "jailsandprisons",
    title: "Jails & Prisons",
  },
  {
    alias: "jaliscan",
    title: "Jaliscan",
  },
  {
    alias: "japacurry",
    title: "Japanese Curry",
  },
  {
    alias: "japanese",
    title: "Japanese",
  },
  {
    alias: "jazzandblues",
    title: "Jazz & Blues",
  },
  {
    alias: "jetskis",
    title: "Jet Skis",
  },
  {
    alias: "jewelry",
    title: "Jewelry",
  },
  {
    alias: "jewelryrepair",
    title: "Jewelry Repair",
  },
  {
    alias: "jewish",
    title: "Jewish",
  },
  {
    alias: "jpsweets",
    title: "Japanese Sweets",
  },
  {
    alias: "juicebars",
    title: "Juice Bars & Smoothies",
  },
  {
    alias: "junkremovalandhauling",
    title: "Junk Removal & Hauling",
  },
  {
    alias: "junkyards",
    title: "Junkyards",
  },
  {
    alias: "kaiseki",
    title: "Kaiseki",
  },
  {
    alias: "karaoke",
    title: "Karaoke",
  },
  {
    alias: "karaokerental",
    title: "Karaoke Rental",
  },
  {
    alias: "karate",
    title: "Karate",
  },
  {
    alias: "kebab",
    title: "Kebab",
  },
  {
    alias: "kickboxing",
    title: "Kickboxing",
  },
  {
    alias: "kids_activities",
    title: "Kids Activities",
  },
  {
    alias: "kidshairsalons",
    title: "Kids Hair Salons",
  },
  {
    alias: "kimonos",
    title: "Kimonos",
  },
  {
    alias: "kiosk",
    title: "Kiosk",
  },
  {
    alias: "kitchenandbath",
    title: "Kitchen & Bath",
  },
  {
    alias: "kitchenincubators",
    title: "Kitchen Incubators",
  },
  {
    alias: "kitchensupplies",
    title: "Kitchen Supplies",
  },
  {
    alias: "kiteboarding",
    title: "Kiteboarding",
  },
  {
    alias: "knifesharpening",
    title: "Knife Sharpening",
  },
  {
    alias: "knittingsupplies",
    title: "Knitting Supplies",
  },
  {
    alias: "kombucha",
    title: "Kombucha",
  },
  {
    alias: "kopitiam",
    title: "Kopitiam",
  },
  {
    alias: "korean",
    title: "Korean",
  },
  {
    alias: "kosher",
    title: "Kosher",
  },
  {
    alias: "kurdish",
    title: "Kurdish",
  },
  {
    alias: "kushikatsu",
    title: "Kushikatsu",
  },
  {
    alias: "laboratorytesting",
    title: "Laboratory Testing",
  },
  {
    alias: "lactationservices",
    title: "Lactation Services",
  },
  {
    alias: "lahmacun",
    title: "Lahmacun",
  },
  {
    alias: "lakes",
    title: "Lakes",
  },
  {
    alias: "lancenters",
    title: "LAN Centers",
  },
  {
    alias: "landmarks",
    title: "Landmarks & Historical Buildings",
  },
  {
    alias: "landscapearchitects",
    title: "Landscape Architects or Designers",
  },
  {
    alias: "landscaping",
    title: "Landscaping",
  },
  {
    alias: "landsurveying",
    title: "Land Surveying",
  },
  {
    alias: "language_schools",
    title: "Language Schools",
  },
  {
    alias: "laos",
    title: "Laos",
  },
  {
    alias: "laotian",
    title: "Laotian",
  },
  {
    alias: "laser_hair_removal",
    title: "Laser Hair Removal",
  },
  {
    alias: "laserlasikeyes",
    title: "Laser Eye Surgery/Lasik",
  },
  {
    alias: "lasertag",
    title: "Laser Tag",
  },
  {
    alias: "latin",
    title: "Latin American",
  },
  {
    alias: "laundromat",
    title: "Laundromat",
  },
  {
    alias: "laundryservices",
    title: "Laundry Services",
  },
  {
    alias: "lawn_bowling",
    title: "Lawn Bowling",
  },
  {
    alias: "lawnservices",
    title: "Lawn Services",
  },
  {
    alias: "lawyers",
    title: "Lawyers",
  },
  {
    alias: "leather",
    title: "Leather Goods",
  },
  {
    alias: "lebanese",
    title: "Lebanese",
  },
  {
    alias: "legalservices",
    title: "Legal Services",
  },
  {
    alias: "leisure_centers",
    title: "Leisure Centers",
  },
  {
    alias: "libraries",
    title: "Libraries",
  },
  {
    alias: "liceservices",
    title: "Lice Services",
  },
  {
    alias: "lifecoach",
    title: "Life Coach",
  },
  {
    alias: "lifeinsurance",
    title: "Life Insurance",
  },
  {
    alias: "lighting",
    title: "Lighting Fixtures & Equipment",
  },
  {
    alias: "lightingstores",
    title: "Lighting Stores",
  },
  {
    alias: "ligurian",
    title: "Ligurian",
  },
  {
    alias: "limos",
    title: "Limos",
  },
  {
    alias: "linens",
    title: "Linens",
  },
  {
    alias: "lingerie",
    title: "Lingerie",
  },
  {
    alias: "livestocksupply",
    title: "Livestock Feed & Supply",
  },
  {
    alias: "localfishstores",
    title: "Local Fish Stores",
  },
  {
    alias: "localflavor",
    title: "Local Flavor",
  },
  {
    alias: "localservices",
    title: "Local Services",
  },
  {
    alias: "locksmiths",
    title: "Keys & Locksmiths",
  },
  {
    alias: "lounges",
    title: "Lounges",
  },
  {
    alias: "luggage",
    title: "Luggage",
  },
  {
    alias: "luggagestorage",
    title: "Luggage Storage",
  },
  {
    alias: "lumbard",
    title: "Lumbard",
  },
  {
    alias: "lyonnais",
    title: "Lyonnais",
  },
  {
    alias: "macarons",
    title: "Macarons",
  },
  {
    alias: "machinerental",
    title: "Machine & Tool Rental",
  },
  {
    alias: "machineshops",
    title: "Machine Shops",
  },
  {
    alias: "madeira",
    title: "Madeira",
  },
  {
    alias: "magicians",
    title: "Magicians",
  },
  {
    alias: "mags",
    title: "Newspapers & Magazines",
  },
  {
    alias: "mahjong",
    title: "Mah Jong Halls",
  },
  {
    alias: "mailboxcenters",
    title: "Mailbox Centers",
  },
  {
    alias: "makerspaces",
    title: "Makerspaces",
  },
  {
    alias: "makeupartists",
    title: "Makeup Artists",
  },
  {
    alias: "malaysian",
    title: "Malaysian",
  },
  {
    alias: "mamak",
    title: "Mamak",
  },
  {
    alias: "marchingbands",
    title: "Marching Bands",
  },
  {
    alias: "marinas",
    title: "Marinas",
  },
  {
    alias: "marketing",
    title: "Marketing",
  },
  {
    alias: "markets",
    title: "Fruits & Veggies",
  },
  {
    alias: "marketstalls",
    title: "Market Stalls",
  },
  {
    alias: "martialarts",
    title: "Martial Arts",
  },
  {
    alias: "masonry_concrete",
    title: "Masonry/Concrete",
  },
  {
    alias: "massage",
    title: "Massage",
  },
  {
    alias: "massage_schools",
    title: "Massage Schools",
  },
  {
    alias: "massage_therapy",
    title: "Massage Therapy",
  },
  {
    alias: "massmedia",
    title: "Mass Media",
  },
  {
    alias: "matchmakers",
    title: "Matchmakers",
  },
  {
    alias: "materialeelettrico",
    title: "Materiale elettrico",
  },
  {
    alias: "maternity",
    title: "Maternity Wear",
  },
  {
    alias: "mattresses",
    title: "Mattresses",
  },
  {
    alias: "mauritius",
    title: "Mauritius",
  },
  {
    alias: "meaderies",
    title: "Meaderies",
  },
  {
    alias: "meatballs",
    title: "Meatballs",
  },
  {
    alias: "meats",
    title: "Meat Shops",
  },
  {
    alias: "medcenters",
    title: "Medical Centers",
  },
  {
    alias: "media",
    title: "Books, Mags, Music & Video",
  },
  {
    alias: "mediators",
    title: "Mediators",
  },
  {
    alias: "medicalfoot",
    title: "Medical Foot Care",
  },
  {
    alias: "medicallaw",
    title: "Medical Law",
  },
  {
    alias: "medicalspa",
    title: "Medical Spas",
  },
  {
    alias: "medicalsupplies",
    title: "Medical Supplies",
  },
  {
    alias: "medicaltransportation",
    title: "Medical Transportation",
  },
  {
    alias: "meditationcenters",
    title: "Meditation Centers",
  },
  {
    alias: "mediterranean",
    title: "Mediterranean",
  },
  {
    alias: "memorycare",
    title: "Memory Care",
  },
  {
    alias: "menscloth",
    title: "Men's Clothing",
  },
  {
    alias: "menshair",
    title: "Men's Hair Salons",
  },
  {
    alias: "metaldetectorservices",
    title: "Metal Detector Services",
  },
  {
    alias: "metalfabricators",
    title: "Metal Fabricators",
  },
  {
    alias: "metrostations",
    title: "Metro Stations",
  },
  {
    alias: "mexican",
    title: "Mexican",
  },
  {
    alias: "mideastern",
    title: "Middle Eastern",
  },
  {
    alias: "midwives",
    title: "Midwives",
  },
  {
    alias: "militarysurplus",
    title: "Military Surplus",
  },
  {
    alias: "milkbars",
    title: "Milk Bars",
  },
  {
    alias: "milkshakebars",
    title: "Milkshake Bars",
  },
  {
    alias: "minho",
    title: "Minho",
  },
  {
    alias: "mini_golf",
    title: "Mini Golf",
  },
  {
    alias: "mistingsystemservices",
    title: "Misting System Services",
  },
  {
    alias: "mobile_home_repair",
    title: "Mobile Home Repair",
  },
  {
    alias: "mobiledentrepair",
    title: "Mobile Dent Repair",
  },
  {
    alias: "mobilehomes",
    title: "Mobile Home Dealers",
  },
  {
    alias: "mobileparks",
    title: "Mobile Home Parks",
  },
  {
    alias: "mobilephonerepair",
    title: "Mobile Phone Repair",
  },
  {
    alias: "mobilephones",
    title: "Mobile Phones",
  },
  {
    alias: "mobilityequipment",
    title: "Mobility Equipment Sales & Services",
  },
  {
    alias: "modern_australian",
    title: "Modern Australian",
  },
  {
    alias: "modern_european",
    title: "Modern European",
  },
  {
    alias: "mohels",
    title: "Mohels",
  },
  {
    alias: "mongolian",
    title: "Mongolian",
  },
  {
    alias: "montessori",
    title: "Montessori Schools",
  },
  {
    alias: "moroccan",
    title: "Moroccan",
  },
  {
    alias: "mortgagebrokers",
    title: "Mortgage Brokers",
  },
  {
    alias: "mortgagelenders",
    title: "Mortgage Lenders",
  },
  {
    alias: "mortuaryservices",
    title: "Mortuary Services",
  },
  {
    alias: "mosques",
    title: "Mosques",
  },
  {
    alias: "motodealers",
    title: "Motorsport Vehicle Dealers",
  },
  {
    alias: "motorcycle_rental",
    title: "Motorcycle Rental",
  },
  {
    alias: "motorcycledealers",
    title: "Motorcycle Dealers",
  },
  {
    alias: "motorcyclepartsandsupplies",
    title: "Motorcycle Parts & Supplies",
  },
  {
    alias: "motorcyclerepair",
    title: "Motorcycle Repair",
  },
  {
    alias: "motorcyclinggear",
    title: "Motorcycle Gear",
  },
  {
    alias: "motorepairs",
    title: "Motorsport Vehicle Repairs",
  },
  {
    alias: "mountainbiking",
    title: "Mountain Biking",
  },
  {
    alias: "mountainhuts",
    title: "Mountain Huts",
  },
  {
    alias: "movers",
    title: "Movers",
  },
  {
    alias: "movietheaters",
    title: "Cinema",
  },
  {
    alias: "muaythai",
    title: "Muay Thai",
  },
  {
    alias: "municipality",
    title: "Municipality",
  },
  {
    alias: "museums",
    title: "Museums",
  },
  {
    alias: "musicalinstrumentsandteachers",
    title: "Musical Instruments & Teachers",
  },
  {
    alias: "musicians",
    title: "Musicians",
  },
  {
    alias: "musicinstrumentservices",
    title: "Musical Instrument Services",
  },
  {
    alias: "musicproduction",
    title: "Music Production Services",
  },
  {
    alias: "musicvenues",
    title: "Music Venues",
  },
  {
    alias: "musicvideo",
    title: "Music & DVDs",
  },
  {
    alias: "mystics",
    title: "Mystics",
  },
  {
    alias: "nailtechnicians",
    title: "Nail Technicians",
  },
  {
    alias: "nannys",
    title: "Nanny Services",
  },
  {
    alias: "napoletana",
    title: "Napoletana",
  },
  {
    alias: "nasilemak",
    title: "Nasi Lemak",
  },
  {
    alias: "naturalgassuppliers",
    title: "Natural Gas Suppliers",
  },
  {
    alias: "naturopathic",
    title: "Naturopathic/Holistic",
  },
  {
    alias: "nephrologists",
    title: "Nephrologists",
  },
  {
    alias: "neurologist",
    title: "Neurologist",
  },
  {
    alias: "neuropathologists",
    title: "Neuropathologists",
  },
  {
    alias: "neurotologists",
    title: "Neurotologists",
  },
  {
    alias: "newamerican",
    title: "New American",
  },
  {
    alias: "newcanadian",
    title: "Canadian (New)",
  },
  {
    alias: "newmexican",
    title: "New Mexican Cuisine",
  },
  {
    alias: "newzealand",
    title: "New Zealand",
  },
  {
    alias: "nicaraguan",
    title: "Nicaraguan",
  },
  {
    alias: "nicois",
    title: "Nicoise",
  },
  {
    alias: "nightfood",
    title: "Night Food",
  },
  {
    alias: "nightlife",
    title: "Nightlife",
  },
  {
    alias: "nikkei",
    title: "Nikkei",
  },
  {
    alias: "nonprofit",
    title: "Community Service/Non-Profit",
  },
  {
    alias: "noodles",
    title: "Noodles",
  },
  {
    alias: "norcinerie",
    title: "Norcinerie",
  },
  {
    alias: "northeasternbrazilian",
    title: "Northeastern Brazilian",
  },
  {
    alias: "northernbrazilian",
    title: "Northern Brazilian",
  },
  {
    alias: "northerngerman",
    title: "Northern German",
  },
  {
    alias: "northernmexican",
    title: "Northern Mexican",
  },
  {
    alias: "norwegian",
    title: "Traditional Norwegian",
  },
  {
    alias: "notaries",
    title: "Notaries",
  },
  {
    alias: "nudist",
    title: "Nudist",
  },
  {
    alias: "nursepractitioner",
    title: "Nurse Practitioner",
  },
  {
    alias: "nursingschools",
    title: "Nursing Schools",
  },
  {
    alias: "nutritionists",
    title: "Nutritionists",
  },
  {
    alias: "nyonya",
    title: "Nyonya",
  },
  {
    alias: "oaxacan",
    title: "Oaxacan",
  },
  {
    alias: "obgyn",
    title: "Obstetricians & Gynecologists",
  },
  {
    alias: "observatories",
    title: "Observatories",
  },
  {
    alias: "occupationaltherapy",
    title: "Occupational Therapy",
  },
  {
    alias: "oden",
    title: "Oden",
  },
  {
    alias: "officecleaning",
    title: "Office Cleaning",
  },
  {
    alias: "officeequipment",
    title: "Office Equipment",
  },
  {
    alias: "officiants",
    title: "Officiants",
  },
  {
    alias: "oilchange",
    title: "Oil Change Stations",
  },
  {
    alias: "okinawan",
    title: "Okinawan",
  },
  {
    alias: "okonomiyaki",
    title: "Okonomiyaki",
  },
  {
    alias: "oliveoil",
    title: "Olive Oil",
  },
  {
    alias: "oncologist",
    title: "Oncologist",
  },
  {
    alias: "onigiri",
    title: "Onigiri",
  },
  {
    alias: "opensandwiches",
    title: "Open Sandwiches",
  },
  {
    alias: "opera",
    title: "Opera & Ballet",
  },
  {
    alias: "opthamalogists",
    title: "Ophthalmologists",
  },
  {
    alias: "opticians",
    title: "Eyewear & Opticians",
  },
  {
    alias: "optometrists",
    title: "Optometrists",
  },
  {
    alias: "oralsurgeons",
    title: "Oral Surgeons",
  },
  {
    alias: "organdonorservices",
    title: "Organ & Tissue Donor Services",
  },
  {
    alias: "organic_stores",
    title: "Organic Stores",
  },
  {
    alias: "oriental",
    title: "Oriental",
  },
  {
    alias: "orthodontists",
    title: "Orthodontists",
  },
  {
    alias: "orthopedists",
    title: "Orthopedists",
  },
  {
    alias: "orthotics",
    title: "Orthotics",
  },
  {
    alias: "osteopathicphysicians",
    title: "Osteopathic Physicians",
  },
  {
    alias: "osteopaths",
    title: "Osteopaths",
  },
  {
    alias: "othersalons",
    title: "Nail Salons",
  },
  {
    alias: "otologists",
    title: "Otologists",
  },
  {
    alias: "ottomancuisine",
    title: "Ottoman Cuisine",
  },
  {
    alias: "outdoorfurniture",
    title: "Outdoor Furniture Stores",
  },
  {
    alias: "outdoorgear",
    title: "Outdoor Gear",
  },
  {
    alias: "outdoormovies",
    title: "Outdoor Movies",
  },
  {
    alias: "outdoorpowerequipmentservices",
    title: "Outdoor Power Equipment Services",
  },
  {
    alias: "outlet_stores",
    title: "Outlet Stores",
  },
  {
    alias: "oxygenbars",
    title: "Oxygen Bars",
  },
  {
    alias: "oyakodon",
    title: "Oyakodon",
  },
  {
    alias: "pachinko",
    title: "Pachinko",
  },
  {
    alias: "packingservices",
    title: "Packing Services",
  },
  {
    alias: "packingsupplies",
    title: "Packing Supplies",
  },
  {
    alias: "paddleboarding",
    title: "Paddleboarding",
  },
  {
    alias: "painmanagement",
    title: "Pain Management",
  },
  {
    alias: "paintandsip",
    title: "Paint & Sip",
  },
  {
    alias: "paintball",
    title: "Paintball",
  },
  {
    alias: "painters",
    title: "Painters",
  },
  {
    alias: "paintstores",
    title: "Paint Stores",
  },
  {
    alias: "paintyourownpottery",
    title: "Paint-Your-Own Pottery",
  },
  {
    alias: "pakistani",
    title: "Pakistani",
  },
  {
    alias: "palatine",
    title: "Palatine",
  },
  {
    alias: "panasian",
    title: "Pan Asian",
  },
  {
    alias: "pancakes",
    title: "Pancakes",
  },
  {
    alias: "panzerotti",
    title: "Panzerotti",
  },
  {
    alias: "paragliding",
    title: "Paragliding",
  },
  {
    alias: "parasailing",
    title: "Parasailing",
  },
  {
    alias: "parentingclasses",
    title: "Parenting Classes",
  },
  {
    alias: "parking",
    title: "Parking",
  },
  {
    alias: "parklets",
    title: "Parklets",
  },
  {
    alias: "parks",
    title: "Parks",
  },
  {
    alias: "parma",
    title: "Parma",
  },
  {
    alias: "partybikerentals",
    title: "Party Bike Rentals",
  },
  {
    alias: "partybusrentals",
    title: "Party Bus Rentals",
  },
  {
    alias: "partycharacters",
    title: "Party Characters",
  },
  {
    alias: "partyequipmentrentals",
    title: "Party Equipment Rentals",
  },
  {
    alias: "partysupplies",
    title: "Party Supplies",
  },
  {
    alias: "passportvisaservices",
    title: "Passport & Visa Services",
  },
  {
    alias: "pastashops",
    title: "Pasta Shops",
  },
  {
    alias: "patentlaw",
    title: "Patent Law",
  },
  {
    alias: "pathologists",
    title: "Pathologists",
  },
  {
    alias: "patiocoverings",
    title: "Patio Coverings",
  },
  {
    alias: "pawn",
    title: "Pawn Shops",
  },
  {
    alias: "paydayloans",
    title: "Check Cashing/Pay-day Loans",
  },
  {
    alias: "payroll",
    title: "Payroll Services",
  },
  {
    alias: "pediatric_dentists",
    title: "Pediatric Dentists",
  },
  {
    alias: "pediatricians",
    title: "Pediatricians",
  },
  {
    alias: "pedicabs",
    title: "Pedicabs",
  },
  {
    alias: "pekinese",
    title: "Pekinese",
  },
  {
    alias: "pensions",
    title: "Pensions",
  },
  {
    alias: "perfume",
    title: "Perfume",
  },
  {
    alias: "periodontists",
    title: "Periodontists",
  },
  {
    alias: "permanentmakeup",
    title: "Permanent Makeup",
  },
  {
    alias: "persian",
    title: "Persian/Iranian",
  },
  {
    alias: "personal_injury",
    title: "Personal Injury Law",
  },
  {
    alias: "personal_shopping",
    title: "Personal Shopping",
  },
  {
    alias: "personalassistants",
    title: "Personal Assistants",
  },
  {
    alias: "personalcare",
    title: "Personal Care Services",
  },
  {
    alias: "personalchefs",
    title: "Personal Chefs",
  },
  {
    alias: "peruvian",
    title: "Peruvian",
  },
  {
    alias: "pest_control",
    title: "Pest Control",
  },
  {
    alias: "pet_sitting",
    title: "Pet Sitting",
  },
  {
    alias: "pet_training",
    title: "Pet Training",
  },
  {
    alias: "petadoption",
    title: "Pet Adoption",
  },
  {
    alias: "petboarding",
    title: "Pet Boarding",
  },
  {
    alias: "petbreeders",
    title: "Pet Breeders",
  },
  {
    alias: "petcremation",
    title: "Pet Cremation Services",
  },
  {
    alias: "pethospice",
    title: "Pet Hospice",
  },
  {
    alias: "petinsurance",
    title: "Pet Insurance",
  },
  {
    alias: "petphotography",
    title: "Pet Photography",
  },
  {
    alias: "pets",
    title: "Pets",
  },
  {
    alias: "petservices",
    title: "Pet Services",
  },
  {
    alias: "petstore",
    title: "Pet Stores",
  },
  {
    alias: "pettingzoos",
    title: "Petting Zoos",
  },
  {
    alias: "pettransport",
    title: "Pet Transportation",
  },
  {
    alias: "petwasteremoval",
    title: "Pet Waste Removal",
  },
  {
    alias: "pfcomercial",
    title: "PF/Comercial",
  },
  {
    alias: "pharmacy",
    title: "Pharmacy",
  },
  {
    alias: "phlebologists",
    title: "Phlebologists",
  },
  {
    alias: "photoboothrentals",
    title: "Photo Booth Rentals",
  },
  {
    alias: "photoclasses",
    title: "Photography Classes",
  },
  {
    alias: "photographers",
    title: "Photographers",
  },
  {
    alias: "photographystores",
    title: "Photography Stores & Services",
  },
  {
    alias: "physicaltherapy",
    title: "Physical Therapy",
  },
  {
    alias: "physicians",
    title: "Doctors",
  },
  {
    alias: "piadina",
    title: "Piadina",
  },
  {
    alias: "pianobars",
    title: "Piano Bars",
  },
  {
    alias: "pianoservices",
    title: "Piano Services",
  },
  {
    alias: "pianostores",
    title: "Piano Stores",
  },
  {
    alias: "pickleball",
    title: "Pickleball",
  },
  {
    alias: "pickyourown",
    title: "Pick Your Own Farms",
  },
  {
    alias: "piemonte",
    title: "Piemonte",
  },
  {
    alias: "piercing",
    title: "Piercing",
  },
  {
    alias: "pierogis",
    title: "Pierogis",
  },
  {
    alias: "pilates",
    title: "Pilates",
  },
  {
    alias: "pita",
    title: "Pita",
  },
  {
    alias: "pizza",
    title: "Pizza",
  },
  {
    alias: "placentaencapsulation",
    title: "Placenta Encapsulations",
  },
  {
    alias: "planetarium",
    title: "Planetarium",
  },
  {
    alias: "plasticsurgeons",
    title: "Plastic Surgeons",
  },
  {
    alias: "playgrounds",
    title: "Playgrounds",
  },
  {
    alias: "playsets",
    title: "Playsets",
  },
  {
    alias: "plumbing",
    title: "Plumbing",
  },
  {
    alias: "plus_size_fashion",
    title: "Plus Size Fashion",
  },
  {
    alias: "podiatrists",
    title: "Podiatrists",
  },
  {
    alias: "poke",
    title: "Poke",
  },
  {
    alias: "poledancingclasses",
    title: "Pole Dancing Classes",
  },
  {
    alias: "policedepartments",
    title: "Police Departments",
  },
  {
    alias: "polish",
    title: "Polish",
  },
  {
    alias: "polynesian",
    title: "Polynesian",
  },
  {
    alias: "poolbilliards",
    title: "Pool & Billiards",
  },
  {
    alias: "poolcleaners",
    title: "Pool Cleaners",
  },
  {
    alias: "poolhalls",
    title: "Pool Halls",
  },
  {
    alias: "poolservice",
    title: "Pool & Hot Tub Service",
  },
  {
    alias: "popcorn",
    title: "Popcorn Shops",
  },
  {
    alias: "popuprestaurants",
    title: "Pop-Up Restaurants",
  },
  {
    alias: "popupshops",
    title: "Pop-up Shops",
  },
  {
    alias: "portabletoiletservices",
    title: "Portable Toilet Services",
  },
  {
    alias: "portuguese",
    title: "Portuguese",
  },
  {
    alias: "postoffices",
    title: "Post Offices",
  },
  {
    alias: "postpartumcare",
    title: "Postpartum Care",
  },
  {
    alias: "potatoes",
    title: "Potatoes",
  },
  {
    alias: "poutineries",
    title: "Poutineries",
  },
  {
    alias: "powdercoating",
    title: "Powder Coating",
  },
  {
    alias: "prenatal",
    title: "Prenatal/Perinatal Care",
  },
  {
    alias: "preschools",
    title: "Preschools",
  },
  {
    alias: "pressurewashers",
    title: "Pressure Washers",
  },
  {
    alias: "pretzels",
    title: "Pretzels",
  },
  {
    alias: "preventivemedicine",
    title: "Preventive Medicine",
  },
  {
    alias: "printmedia",
    title: "Print Media",
  },
  {
    alias: "privateinvestigation",
    title: "Private Investigation",
  },
  {
    alias: "privatejetcharter",
    title: "Private Jet Charter",
  },
  {
    alias: "privateschools",
    title: "Private Schools",
  },
  {
    alias: "privatetutors",
    title: "Private Tutors",
  },
  {
    alias: "processservers",
    title: "Process Servers",
  },
  {
    alias: "proctologist",
    title: "Proctologists",
  },
  {
    alias: "productdesign",
    title: "Product Design",
  },
  {
    alias: "professional",
    title: "Professional Services",
  },
  {
    alias: "propane",
    title: "Propane",
  },
  {
    alias: "propertymgmt",
    title: "Property Management",
  },
  {
    alias: "props",
    title: "Props",
  },
  {
    alias: "prosthetics",
    title: "Prosthetics",
  },
  {
    alias: "prosthodontists",
    title: "Prosthodontists",
  },
  {
    alias: "provencal",
    title: "Provencal",
  },
  {
    alias: "psychiatrists",
    title: "Psychiatrists",
  },
  {
    alias: "psychic_astrology",
    title: "Supernatural Readings",
  },
  {
    alias: "psychicmediums",
    title: "Psychic Mediums",
  },
  {
    alias: "psychics",
    title: "Psychics",
  },
  {
    alias: "psychoanalysts",
    title: "Psychoanalysts",
  },
  {
    alias: "psychologists",
    title: "Psychologists",
  },
  {
    alias: "psychotechnicaltests",
    title: "Psychotechnical Tests",
  },
  {
    alias: "psychotherapists",
    title: "Psychotherapists",
  },
  {
    alias: "pubfood",
    title: "Pub Food",
  },
  {
    alias: "publicadjusters",
    title: "Public Adjusters",
  },
  {
    alias: "publicart",
    title: "Public Art",
  },
  {
    alias: "publicmarkets",
    title: "Public Markets",
  },
  {
    alias: "publicplazas",
    title: "Public Plazas",
  },
  {
    alias: "publicrelations",
    title: "Public Relations",
  },
  {
    alias: "publicservicesgovt",
    title: "Public Services & Government",
  },
  {
    alias: "publictransport",
    title: "Public Transportation",
  },
  {
    alias: "pubs",
    title: "Pubs",
  },
  {
    alias: "pueblan",
    title: "Pueblan",
  },
  {
    alias: "puertorican",
    title: "Puerto Rican",
  },
  {
    alias: "pulmonologist",
    title: "Pulmonologist",
  },
  {
    alias: "pulquerias",
    title: "Pulquerias",
  },
  {
    alias: "pumpkinpatches",
    title: "Pumpkin Patches",
  },
  {
    alias: "qigong",
    title: "Qi Gong",
  },
  {
    alias: "races",
    title: "Races & Competitions",
  },
  {
    alias: "racetracks",
    title: "Race Tracks",
  },
  {
    alias: "racingexperience",
    title: "Racing Experience",
  },
  {
    alias: "radiologists",
    title: "Radiologists",
  },
  {
    alias: "radiostations",
    title: "Radio Stations",
  },
  {
    alias: "rafting",
    title: "Rafting/Kayaking",
  },
  {
    alias: "ramen",
    title: "Ramen",
  },
  {
    alias: "ranches",
    title: "Ranches",
  },
  {
    alias: "raw_food",
    title: "Live/Raw Food",
  },
  {
    alias: "realestate",
    title: "Real Estate",
  },
  {
    alias: "realestateagents",
    title: "Real Estate Agents",
  },
  {
    alias: "realestatelawyers",
    title: "Real Estate Law",
  },
  {
    alias: "realestatesvcs",
    title: "Real Estate Services",
  },
  {
    alias: "record_labels",
    title: "Record Labels",
  },
  {
    alias: "recording_studios",
    title: "Recording & Rehearsal Studios",
  },
  {
    alias: "recreation",
    title: "Recreation Centers",
  },
  {
    alias: "recyclingcenter",
    title: "Recycling Center",
  },
  {
    alias: "refinishing",
    title: "Refinishing Services",
  },
  {
    alias: "reflexology",
    title: "Reflexology",
  },
  {
    alias: "registrationservices",
    title: "Registration Services",
  },
  {
    alias: "registry_office",
    title: "Registry Office",
  },
  {
    alias: "rehabilitation_center",
    title: "Rehabilitation Center",
  },
  {
    alias: "reiki",
    title: "Reiki",
  },
  {
    alias: "religiousitems",
    title: "Religious Items",
  },
  {
    alias: "religiousorgs",
    title: "Religious Organizations",
  },
  {
    alias: "religiousschools",
    title: "Religious Schools",
  },
  {
    alias: "rentfurniture",
    title: "Furniture Rental",
  },
  {
    alias: "reproductivehealthservices",
    title: "Reproductive Health Services",
  },
  {
    alias: "reptileshops",
    title: "Reptile Shops",
  },
  {
    alias: "residences",
    title: "Residences",
  },
  {
    alias: "resorts",
    title: "Resorts",
  },
  {
    alias: "restaurants",
    title: "Restaurants",
  },
  {
    alias: "reststops",
    title: "Rest Stops",
  },
  {
    alias: "retinaspecialists",
    title: "Retina Specialists",
  },
  {
    alias: "retirement_homes",
    title: "Retirement Homes",
  },
  {
    alias: "reunion",
    title: "Reunion",
  },
  {
    alias: "reupholstery",
    title: "Furniture Reupholstery",
  },
  {
    alias: "rhematologists",
    title: "Rheumatologists",
  },
  {
    alias: "rhinelandian",
    title: "Rhinelandian",
  },
  {
    alias: "ribatejo",
    title: "Ribatejo",
  },
  {
    alias: "riceshop",
    title: "Rice",
  },
  {
    alias: "roadsideassist",
    title: "Roadside Assistance",
  },
  {
    alias: "robatayaki",
    title: "Robatayaki",
  },
  {
    alias: "rock_climbing",
    title: "Rock Climbing",
  },
  {
    alias: "rodeo",
    title: "Rodeo",
  },
  {
    alias: "rodizios",
    title: "Rodizios",
  },
  {
    alias: "rolfing",
    title: "Rolfing",
  },
  {
    alias: "roman",
    title: "Roman",
  },
  {
    alias: "romanian",
    title: "Romanian",
  },
  {
    alias: "roofing",
    title: "Roofing",
  },
  {
    alias: "roofinspectors",
    title: "Roof Inspectors",
  },
  {
    alias: "rotisserie_chicken",
    title: "Rotisserie Chicken",
  },
  {
    alias: "rugs",
    title: "Rugs",
  },
  {
    alias: "rumanian",
    title: "Rumanian",
  },
  {
    alias: "russian",
    title: "Russian",
  },
  {
    alias: "rv_dealers",
    title: "RV Dealers",
  },
  {
    alias: "rvparks",
    title: "RV Parks",
  },
  {
    alias: "rvrental",
    title: "RV Rental",
  },
  {
    alias: "rvrepair",
    title: "RV Repair",
  },
  {
    alias: "ryokan",
    title: "Ryokan",
  },
  {
    alias: "safestores",
    title: "Safe Stores",
  },
  {
    alias: "safetyequipment",
    title: "Safety Equipment",
  },
  {
    alias: "sailing",
    title: "Sailing",
  },
  {
    alias: "sakebars",
    title: "Sake Bars",
  },
  {
    alias: "salad",
    title: "Salad",
  },
  {
    alias: "salumerie",
    title: "Salumerie",
  },
  {
    alias: "salvadoran",
    title: "Salvadoran",
  },
  {
    alias: "sambaschools",
    title: "Samba Schools",
  },
  {
    alias: "sandblasting",
    title: "Sandblasting",
  },
  {
    alias: "sandwiches",
    title: "Sandwiches",
  },
  {
    alias: "sardinian",
    title: "Sardinian",
  },
  {
    alias: "saunainstallation",
    title: "Sauna Installation & Repair",
  },
  {
    alias: "saunas",
    title: "Saunas",
  },
  {
    alias: "scandinavian",
    title: "Scandinavian",
  },
  {
    alias: "scandinaviandesign",
    title: "Scandinavian Design",
  },
  {
    alias: "scavengerhunts",
    title: "Scavenger Hunts",
  },
  {
    alias: "schnitzel",
    title: "Schnitzel",
  },
  {
    alias: "scooterrentals",
    title: "Scooter Rentals",
  },
  {
    alias: "scootertours",
    title: "Scooter Tours",
  },
  {
    alias: "scottish",
    title: "Scottish",
  },
  {
    alias: "screen_printing_tshirt_printing",
    title: "Screen Printing/T-Shirt Printing",
  },
  {
    alias: "screenprinting",
    title: "Screen Printing",
  },
  {
    alias: "scuba",
    title: "Scuba Diving",
  },
  {
    alias: "seafood",
    title: "Seafood",
  },
  {
    alias: "seafoodmarkets",
    title: "Seafood Markets",
  },
  {
    alias: "seasonaldecorservices",
    title: "Holiday Decorating Services",
  },
  {
    alias: "security",
    title: "Security Services",
  },
  {
    alias: "securitysystems",
    title: "Security Systems",
  },
  {
    alias: "selfdefenseclasses",
    title: "Self-defense Classes",
  },
  {
    alias: "selfstorage",
    title: "Self Storage",
  },
  {
    alias: "senegalese",
    title: "Senegalese",
  },
  {
    alias: "seniorcenters",
    title: "Senior Centers",
  },
  {
    alias: "septicservices",
    title: "Septic Services",
  },
  {
    alias: "serbocroatian",
    title: "Serbo Croatian",
  },
  {
    alias: "service_stations",
    title: "Service Stations",
  },
  {
    alias: "servicestations",
    title: "Gas Stations",
  },
  {
    alias: "sessionphotography",
    title: "Session Photography",
  },
  {
    alias: "sewingalterations",
    title: "Sewing & Alterations",
  },
  {
    alias: "sextherapists",
    title: "Sex Therapists",
  },
  {
    alias: "shanghainese",
    title: "Shanghainese",
  },
  {
    alias: "sharedofficespaces",
    title: "Shared Office Spaces",
  },
  {
    alias: "sharedtaxis",
    title: "Shared Taxis",
  },
  {
    alias: "shavedice",
    title: "Shaved Ice",
  },
  {
    alias: "shavedsnow",
    title: "Shaved Snow",
  },
  {
    alias: "shedsandoutdoorstorage",
    title: "Sheds & Outdoor Storage",
  },
  {
    alias: "shipping_centers",
    title: "Shipping Centers",
  },
  {
    alias: "shoerepair",
    title: "Shoe Repair",
  },
  {
    alias: "shoes",
    title: "Shoe Stores",
  },
  {
    alias: "shoeshine",
    title: "Shoe Shine",
  },
  {
    alias: "shopping",
    title: "Shopping",
  },
  {
    alias: "shoppingcenters",
    title: "Shopping Centers",
  },
  {
    alias: "shoppingpassages",
    title: "Shopping Passages",
  },
  {
    alias: "shredding",
    title: "Shredding Services",
  },
  {
    alias: "shrines",
    title: "Shrines",
  },
  {
    alias: "shutters",
    title: "Shutters",
  },
  {
    alias: "sicilian",
    title: "Sicilian",
  },
  {
    alias: "signature_cuisine",
    title: "Signature Cuisine",
  },
  {
    alias: "signmaking",
    title: "Signmaking",
  },
  {
    alias: "sikhtemples",
    title: "Sikh Temples",
  },
  {
    alias: "silentdisco",
    title: "Silent Disco",
  },
  {
    alias: "singaporean",
    title: "Singaporean",
  },
  {
    alias: "skate_parks",
    title: "Skate Parks",
  },
  {
    alias: "skateshops",
    title: "Skate Shops",
  },
  {
    alias: "skatingrinks",
    title: "Skating Rinks",
  },
  {
    alias: "skiing",
    title: "Skiing",
  },
  {
    alias: "skillednursing",
    title: "Skilled Nursing",
  },
  {
    alias: "skincare",
    title: "Skin Care",
  },
  {
    alias: "skiresorts",
    title: "Ski Resorts",
  },
  {
    alias: "skischools",
    title: "Ski Schools",
  },
  {
    alias: "skishops",
    title: "Ski & Snowboard Shops",
  },
  {
    alias: "skydiving",
    title: "Skydiving",
  },
  {
    alias: "sledding",
    title: "Sledding",
  },
  {
    alias: "sleepspecialists",
    title: "Sleep Specialists",
  },
  {
    alias: "sleepwear",
    title: "Sleepwear",
  },
  {
    alias: "slovakian",
    title: "Slovakian",
  },
  {
    alias: "smog_check_stations",
    title: "Smog Check Stations",
  },
  {
    alias: "smokehouse",
    title: "Smokehouse",
  },
  {
    alias: "smokingareas",
    title: "Smoking Areas",
  },
  {
    alias: "snorkeling",
    title: "Snorkeling",
  },
  {
    alias: "snowremoval",
    title: "Snow Removal",
  },
  {
    alias: "snuggleservices",
    title: "Snuggle Services",
  },
  {
    alias: "soba",
    title: "Soba",
  },
  {
    alias: "social_clubs",
    title: "Social Clubs",
  },
  {
    alias: "socialsecuritylaw",
    title: "Social Security Law",
  },
  {
    alias: "softwaredevelopment",
    title: "Software Development",
  },
  {
    alias: "solarinstallation",
    title: "Solar Installation",
  },
  {
    alias: "solarpanelcleaning",
    title: "Solar Panel Cleaning",
  },
  {
    alias: "somali",
    title: "Somali",
  },
  {
    alias: "sommelierservices",
    title: "Sommelier Services",
  },
  {
    alias: "sophrologists",
    title: "Sophrologists",
  },
  {
    alias: "soulfood",
    title: "Soul Food",
  },
  {
    alias: "soup",
    title: "Soup",
  },
  {
    alias: "southafrican",
    title: "South African",
  },
  {
    alias: "southern",
    title: "Southern",
  },
  {
    alias: "souvenirs",
    title: "Souvenir Shops",
  },
  {
    alias: "spanish",
    title: "Spanish",
  },
  {
    alias: "spas",
    title: "Day Spas",
  },
  {
    alias: "speakeasies",
    title: "Speakeasies",
  },
  {
    alias: "specialbikes",
    title: "Special Bikes",
  },
  {
    alias: "specialed",
    title: "Special Education",
  },
  {
    alias: "specialtyschools",
    title: "Specialty Schools",
  },
  {
    alias: "speech_therapists",
    title: "Speech Therapists",
  },
  {
    alias: "speechtraining",
    title: "Speech Training",
  },
  {
    alias: "spermclinic",
    title: "Sperm Clinic",
  },
  {
    alias: "spinclasses",
    title: "Spin Classes",
  },
  {
    alias: "spinesurgeons",
    title: "Spine Surgeons",
  },
  {
    alias: "spiritism",
    title: "Spiritism",
  },
  {
    alias: "spiritual_shop",
    title: "Spiritual Shop",
  },
  {
    alias: "sport_equipment_hire",
    title: "Sport Equipment Hire",
  },
  {
    alias: "sportgoods",
    title: "Sporting Goods",
  },
  {
    alias: "sports_clubs",
    title: "Sports Clubs",
  },
  {
    alias: "sportsbars",
    title: "Sports Bars",
  },
  {
    alias: "sportsbetting",
    title: "Sports Betting",
  },
  {
    alias: "sportsmed",
    title: "Sports Medicine",
  },
  {
    alias: "sportspsychologists",
    title: "Sports Psychologists",
  },
  {
    alias: "sportsteams",
    title: "Professional Sports Teams",
  },
  {
    alias: "sportswear",
    title: "Sports Wear",
  },
  {
    alias: "spraytanning",
    title: "Spray Tanning",
  },
  {
    alias: "squash",
    title: "Squash",
  },
  {
    alias: "srilankan",
    title: "Sri Lankan",
  },
  {
    alias: "stadiumsarenas",
    title: "Stadiums & Arenas",
  },
  {
    alias: "stationery",
    title: "Cards & Stationery",
  },
  {
    alias: "steak",
    title: "Steakhouses",
  },
  {
    alias: "stereo_installation",
    title: "Car Stereo Installation",
  },
  {
    alias: "stockings",
    title: "Stockings",
  },
  {
    alias: "stonemasons",
    title: "Stonemasons",
  },
  {
    alias: "streetart",
    title: "Street Art",
  },
  {
    alias: "streetvendors",
    title: "Street Vendors",
  },
  {
    alias: "stripclubs",
    title: "Strip Clubs",
  },
  {
    alias: "stripteasedancers",
    title: "Striptease Dancers",
  },
  {
    alias: "structuralengineers",
    title: "Structural Engineers",
  },
  {
    alias: "stucco",
    title: "Stucco Services",
  },
  {
    alias: "studiotaping",
    title: "Studio Taping",
  },
  {
    alias: "sud_ouest",
    title: "French Southwest",
  },
  {
    alias: "sugaring",
    title: "Sugaring",
  },
  {
    alias: "sugarshacks",
    title: "Sugar Shacks",
  },
  {
    alias: "sukiyaki",
    title: "Sukiyaki",
  },
  {
    alias: "summer_camps",
    title: "Summer Camps",
  },
  {
    alias: "sunglasses",
    title: "Sunglasses",
  },
  {
    alias: "supperclubs",
    title: "Supper Clubs",
  },
  {
    alias: "suppliesrestaurant",
    title: "Restaurant Supplies",
  },
  {
    alias: "surfing",
    title: "Surfing",
  },
  {
    alias: "surflifesaving",
    title: "Surf Lifesaving",
  },
  {
    alias: "surfschools",
    title: "Surf Schools",
  },
  {
    alias: "surfshop",
    title: "Surf Shop",
  },
  {
    alias: "surgeons",
    title: "Surgeons",
  },
  {
    alias: "sushi",
    title: "Sushi Bars",
  },
  {
    alias: "swabian",
    title: "Swabian",
  },
  {
    alias: "swedish",
    title: "Swedish",
  },
  {
    alias: "swimminglessons",
    title: "Swimming Lessons/Schools",
  },
  {
    alias: "swimmingpools",
    title: "Swimming Pools",
  },
  {
    alias: "swimwear",
    title: "Swimwear",
  },
  {
    alias: "swissfood",
    title: "Swiss Food",
  },
  {
    alias: "synagogues",
    title: "Synagogues",
  },
  {
    alias: "syrian",
    title: "Syrian",
  },
  {
    alias: "szechuan",
    title: "Szechuan",
  },
  {
    alias: "tabac",
    title: "Tabac",
  },
  {
    alias: "tabernas",
    title: "Tabernas",
  },
  {
    alias: "tablaoflamenco",
    title: "Tablao Flamenco",
  },
  {
    alias: "tabletopgames",
    title: "Tabletop Games",
  },
  {
    alias: "tableware",
    title: "Tableware",
  },
  {
    alias: "tacos",
    title: "Tacos",
  },
  {
    alias: "taekwondo",
    title: "Taekwondo",
  },
  {
    alias: "taichi",
    title: "Tai Chi",
  },
  {
    alias: "taiwanese",
    title: "Taiwanese",
  },
  {
    alias: "taiyaki",
    title: "Taiyaki",
  },
  {
    alias: "takoyaki",
    title: "Takoyaki",
  },
  {
    alias: "talentagencies",
    title: "Talent Agencies",
  },
  {
    alias: "tamales",
    title: "Tamales",
  },
  {
    alias: "tanning",
    title: "Tanning",
  },
  {
    alias: "tanningbeds",
    title: "Tanning Beds",
  },
  {
    alias: "taoisttemples",
    title: "Taoist Temples",
  },
  {
    alias: "tapas",
    title: "Tapas Bars",
  },
  {
    alias: "tapasmallplates",
    title: "Tapas/Small Plates",
  },
  {
    alias: "tastingclasses",
    title: "Tasting Classes",
  },
  {
    alias: "tattoo",
    title: "Tattoo",
  },
  {
    alias: "tattooremoval",
    title: "Tattoo Removal",
  },
  {
    alias: "tavolacalda",
    title: "Tavola Calda",
  },
  {
    alias: "taxidermy",
    title: "Taxidermy",
  },
  {
    alias: "taxis",
    title: "Taxis",
  },
  {
    alias: "taxlaw",
    title: "Tax Law",
  },
  {
    alias: "taxoffice",
    title: "Tax Office",
  },
  {
    alias: "taxservices",
    title: "Tax Services",
  },
  {
    alias: "tcm",
    title: "Traditional Chinese Medicine",
  },
  {
    alias: "tea",
    title: "Tea Rooms",
  },
  {
    alias: "teachersupplies",
    title: "Teacher Supplies",
  },
  {
    alias: "teambuilding",
    title: "Team Building Activities",
  },
  {
    alias: "teethwhitening",
    title: "Teeth Whitening",
  },
  {
    alias: "telecommunications",
    title: "Telecommunications",
  },
  {
    alias: "televisionserviceproviders",
    title: "Television Service Providers",
  },
  {
    alias: "televisionstations",
    title: "Television Stations",
  },
  {
    alias: "tempura",
    title: "Tempura",
  },
  {
    alias: "tenantlaw",
    title: "Tenant and Eviction Law",
  },
  {
    alias: "tennis",
    title: "Tennis",
  },
  {
    alias: "teochew",
    title: "Teochew",
  },
  {
    alias: "teppanyaki",
    title: "Teppanyaki",
  },
  {
    alias: "testprep",
    title: "Test Preparation",
  },
  {
    alias: "tex-mex",
    title: "Tex-Mex",
  },
  {
    alias: "thai",
    title: "Thai",
  },
  {
    alias: "theater",
    title: "Performing Arts",
  },
  {
    alias: "themedcafes",
    title: "Themed Cafes",
  },
  {
    alias: "threadingservices",
    title: "Threading Services",
  },
  {
    alias: "thrift_stores",
    title: "Thrift Stores",
  },
  {
    alias: "tickets",
    title: "Tickets",
  },
  {
    alias: "ticketsales",
    title: "Ticket Sales",
  },
  {
    alias: "tikibars",
    title: "Tiki Bars",
  },
  {
    alias: "tiling",
    title: "Tiling",
  },
  {
    alias: "tires",
    title: "Tires",
  },
  {
    alias: "titleloans",
    title: "Title Loans",
  },
  {
    alias: "tobaccoshops",
    title: "Tobacco Shops",
  },
  {
    alias: "tofu",
    title: "Tofu Shops",
  },
  {
    alias: "tonkatsu",
    title: "Tonkatsu",
  },
  {
    alias: "torshi",
    title: "Torshi",
  },
  {
    alias: "tortillas",
    title: "Tortillas",
  },
  {
    alias: "tours",
    title: "Tours",
  },
  {
    alias: "towing",
    title: "Towing",
  },
  {
    alias: "towncarservice",
    title: "Town Car Service",
  },
  {
    alias: "townhall",
    title: "Town Hall",
  },
  {
    alias: "toxicologists",
    title: "Toxicologists",
  },
  {
    alias: "toys",
    title: "Toy Stores",
  },
  {
    alias: "tradamerican",
    title: "American",
  },
  {
    alias: "tradclothing",
    title: "Traditional Clothing",
  },
  {
    alias: "tradefairs",
    title: "Trade Fairs",
  },
  {
    alias: "traditional_swedish",
    title: "Traditional Swedish",
  },
  {
    alias: "trafficschools",
    title: "Traffic Schools",
  },
  {
    alias: "trafficticketinglaw",
    title: "Traffic Ticketing Law",
  },
  {
    alias: "trailerdealers",
    title: "Trailer Dealers",
  },
  {
    alias: "trailerrental",
    title: "Trailer Rental",
  },
  {
    alias: "trailerrepair",
    title: "Trailer Repair",
  },
  {
    alias: "trains",
    title: "Trains",
  },
  {
    alias: "trainstations",
    title: "Train Stations",
  },
  {
    alias: "trampoline",
    title: "Trampoline Parks",
  },
  {
    alias: "translationservices",
    title: "Translation Services",
  },
  {
    alias: "transmissionrepair",
    title: "Transmission Repair",
  },
  {
    alias: "transport",
    title: "Transportation",
  },
  {
    alias: "tras_os_montes",
    title: "Tras-os-Montes",
  },
  {
    alias: "trattorie",
    title: "Trattorie",
  },
  {
    alias: "travelagents",
    title: "Travel Agents",
  },
  {
    alias: "travelservices",
    title: "Travel Services",
  },
  {
    alias: "treeservices",
    title: "Tree Services",
  },
  {
    alias: "trinidadian",
    title: "Trinidadian",
  },
  {
    alias: "triviahosts",
    title: "Trivia Hosts",
  },
  {
    alias: "trophyshops",
    title: "Trophy Shops",
  },
  {
    alias: "tropicalmedicine",
    title: "Tropical Medicine",
  },
  {
    alias: "truck_rental",
    title: "Truck Rental",
  },
  {
    alias: "truckdealers",
    title: "Commercial Truck Dealers",
  },
  {
    alias: "truckrepair",
    title: "Commercial Truck Repair",
  },
  {
    alias: "tubing",
    title: "Tubing",
  },
  {
    alias: "tuina",
    title: "Tui Na",
  },
  {
    alias: "turkish",
    title: "Turkish",
  },
  {
    alias: "turkishravioli",
    title: "Turkish Ravioli",
  },
  {
    alias: "tuscan",
    title: "Tuscan",
  },
  {
    alias: "tutoring",
    title: "Tutoring Centers",
  },
  {
    alias: "tvmounting",
    title: "TV Mounting",
  },
  {
    alias: "udon",
    title: "Udon",
  },
  {
    alias: "ukrainian",
    title: "Ukrainian",
  },
  {
    alias: "ultrasoundimagingcenters",
    title: "Ultrasound Imaging Centers",
  },
  {
    alias: "unagi",
    title: "Unagi",
  },
  {
    alias: "underseamedicine",
    title: "Undersea/Hyperbaric Medicine",
  },
  {
    alias: "uniforms",
    title: "Uniforms",
  },
  {
    alias: "university_housing",
    title: "University Housing",
  },
  {
    alias: "unofficialyelpevents",
    title: "Unofficial Yelp Events",
  },
  {
    alias: "urgent_care",
    title: "Urgent Care",
  },
  {
    alias: "urologists",
    title: "Urologists",
  },
  {
    alias: "usedbooks",
    title: "Used Bookstore",
  },
  {
    alias: "usedcardealers",
    title: "Used Car Dealers",
  },
  {
    alias: "utilities",
    title: "Utilities",
  },
  {
    alias: "uzbek",
    title: "Uzbek",
  },
  {
    alias: "vacation_rentals",
    title: "Vacation Rentals",
  },
  {
    alias: "vacationrentalagents",
    title: "Vacation Rental Agents",
  },
  {
    alias: "valetservices",
    title: "Valet Services",
  },
  {
    alias: "vapeshops",
    title: "Vape Shops",
  },
  {
    alias: "vascularmedicine",
    title: "Vascular Medicine",
  },
  {
    alias: "vegan",
    title: "Vegan",
  },
  {
    alias: "vegetarian",
    title: "Vegetarian",
  },
  {
    alias: "vehicleshipping",
    title: "Vehicle Shipping",
  },
  {
    alias: "vehiclewraps",
    title: "Vehicle Wraps",
  },
  {
    alias: "venetian",
    title: "Venetian",
  },
  {
    alias: "venezuelan",
    title: "Venezuelan",
  },
  {
    alias: "venison",
    title: "Venison",
  },
  {
    alias: "venues",
    title: "Venues & Event Spaces",
  },
  {
    alias: "vermouthbars",
    title: "Vermouth Bars",
  },
  {
    alias: "vet",
    title: "Veterinarians",
  },
  {
    alias: "veteransorganizations",
    title: "Veterans Organizations",
  },
  {
    alias: "videoandgames",
    title: "Videos & Video Game Rental",
  },
  {
    alias: "videofilmproductions",
    title: "Video/Film Production",
  },
  {
    alias: "videogamestores",
    title: "Video Game Stores",
  },
  {
    alias: "videographers",
    title: "Videographers",
  },
  {
    alias: "vietnamese",
    title: "Vietnamese",
  },
  {
    alias: "vintage",
    title: "Used, Vintage & Consignment",
  },
  {
    alias: "vinyl_records",
    title: "Vinyl Records",
  },
  {
    alias: "vinylsiding",
    title: "Siding",
  },
  {
    alias: "virtualrealitycenters",
    title: "Virtual Reality Centers",
  },
  {
    alias: "visitorcenters",
    title: "Visitor Centers",
  },
  {
    alias: "vitaminssupplements",
    title: "Vitamins & Supplements",
  },
  {
    alias: "vocalcoach",
    title: "Vocal Coach",
  },
  {
    alias: "vocation",
    title: "Vocational & Technical School",
  },
  {
    alias: "volleyball",
    title: "Volleyball",
  },
  {
    alias: "waffles",
    title: "Waffles",
  },
  {
    alias: "waldorfschools",
    title: "Waldorf Schools",
  },
  {
    alias: "walkinclinics",
    title: "Walk-in Clinics",
  },
  {
    alias: "walkingtours",
    title: "Walking Tours",
  },
  {
    alias: "wallpapering",
    title: "Wallpapering",
  },
  {
    alias: "watch_repair",
    title: "Watch Repair",
  },
  {
    alias: "watches",
    title: "Watches",
  },
  {
    alias: "waterdelivery",
    title: "Water Delivery",
  },
  {
    alias: "waterheaterinstallrepair",
    title: "Water Heater Installation/Repair",
  },
  {
    alias: "waterparks",
    title: "Water Parks",
  },
  {
    alias: "waterproofing",
    title: "Waterproofing",
  },
  {
    alias: "waterpurification",
    title: "Water Purification Services",
  },
  {
    alias: "waterstores",
    title: "Water Stores",
  },
  {
    alias: "watersuppliers",
    title: "Water Suppliers",
  },
  {
    alias: "watertaxis",
    title: "Water Taxis",
  },
  {
    alias: "waxing",
    title: "Waxing",
  },
  {
    alias: "web_design",
    title: "Web Design",
  },
  {
    alias: "wedding_planning",
    title: "Wedding Planning",
  },
  {
    alias: "weddingchappels",
    title: "Wedding Chapels",
  },
  {
    alias: "weightlosscenters",
    title: "Weight Loss Centers",
  },
  {
    alias: "welldrilling",
    title: "Well Drilling",
  },
  {
    alias: "westernjapanese",
    title: "Western Style Japanese Food",
  },
  {
    alias: "whalewatchingtours",
    title: "Whale Watching Tours",
  },
  {
    alias: "wheelrimrepair",
    title: "Wheel & Rim Repair",
  },
  {
    alias: "whiskeybars",
    title: "Whiskey Bars",
  },
  {
    alias: "wholesale_stores",
    title: "Wholesale Stores",
  },
  {
    alias: "wholesalers",
    title: "Wholesalers",
  },
  {
    alias: "wigs",
    title: "Wigs",
  },
  {
    alias: "wildlifecontrol",
    title: "Wildlife Control",
  },
  {
    alias: "wildlifehunting",
    title: "Wildlife Hunting Ranges",
  },
  {
    alias: "willstrustsprobates",
    title: "Wills, Trusts, & Probates",
  },
  {
    alias: "windowsinstallation",
    title: "Windows Installation",
  },
  {
    alias: "windowwashing",
    title: "Window Washing",
  },
  {
    alias: "windshieldinstallrepair",
    title: "Windshield Installation & Repair",
  },
  {
    alias: "wine_bars",
    title: "Wine Bars",
  },
  {
    alias: "wineries",
    title: "Wineries",
  },
  {
    alias: "winetasteclasses",
    title: "Wine Tasting Classes",
  },
  {
    alias: "winetastingroom",
    title: "Wine Tasting Room",
  },
  {
    alias: "winetours",
    title: "Wine Tours",
  },
  {
    alias: "wok",
    title: "Wok",
  },
  {
    alias: "womenscloth",
    title: "Women's Clothing",
  },
  {
    alias: "workerscomplaw",
    title: "Workers Compensation Law",
  },
  {
    alias: "wraps",
    title: "Wraps",
  },
  {
    alias: "xmasmarkets",
    title: "Christmas Markets",
  },
  {
    alias: "yakiniku",
    title: "Yakiniku",
  },
  {
    alias: "yakitori",
    title: "Yakitori",
  },
  {
    alias: "yelpevents",
    title: "Yelp Events",
  },
  {
    alias: "yoga",
    title: "Yoga",
  },
  {
    alias: "youth_club",
    title: "Youth Club",
  },
  {
    alias: "yucatan",
    title: "Yucatan",
  },
  {
    alias: "yugoslav",
    title: "Yugoslav",
  },
  {
    alias: "zapiekanka",
    title: "Zapiekanka",
  },
  {
    alias: "zipline",
    title: "Ziplining",
  },
  {
    alias: "zoos",
    title: "Zoos",
  },
  {
    alias: "zorbing",
    title: "Zorbing",
  },
];

export const exampleData = {
  businesses: [
    {
      id: "MphfKkYFEe0BDQ6hZ0A5fA",
      alias: "gelso-and-grand-new-york",
      name: "Gelso & Grand",
      image_url:
        "https://s3-media1.fl.yelpcdn.com/bphoto/_SPm9GnY1EweCZihbDWt9g/o.jpg",
      is_closed: false,
      url: "https://www.yelp.com/biz/gelso-and-grand-new-york?adjust_creative=FlLcWTwY94L6PQ5d-K6zjg&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=FlLcWTwY94L6PQ5d-K6zjg",
      review_count: 1599,
      categories: [
        {
          alias: "italian",
          title: "Italian",
        },
        {
          alias: "pastashops",
          title: "Pasta Shops",
        },
        {
          alias: "pizza",
          title: "Pizza",
        },
      ],
      rating: 4.3,
      coordinates: {
        latitude: 40.71958,
        longitude: -73.99734,
      },
      transactions: ["pickup", "delivery"],
      price: "$$",
      location: {
        address1: "186 Grand St",
        address2: "",
        address3: "",
        city: "New York",
        zip_code: "10013",
        country: "US",
        state: "NY",
        display_address: ["186 Grand St", "New York, NY 10013"],
      },
      phone: "+12122261600",
      display_phone: "(212) 226-1600",
      distance: 1583.0802664491484,
      business_hours: [
        {
          open: [
            {
              is_overnight: false,
              start: "1100",
              end: "2300",
              day: 0,
            },
            {
              is_overnight: false,
              start: "1100",
              end: "2300",
              day: 1,
            },
            {
              is_overnight: false,
              start: "1100",
              end: "2300",
              day: 2,
            },
            {
              is_overnight: false,
              start: "1100",
              end: "2300",
              day: 3,
            },
            {
              is_overnight: false,
              start: "1100",
              end: "0000",
              day: 4,
            },
            {
              is_overnight: false,
              start: "1100",
              end: "0000",
              day: 5,
            },
            {
              is_overnight: false,
              start: "1100",
              end: "2300",
              day: 6,
            },
          ],
          hours_type: "REGULAR",
          is_open_now: true,
        },
      ],
      attributes: {
        business_temp_closed: null,
        menu_url: "https://www.gelsoandgrand.com/menu",
        open24_hours: null,
        waitlist_reservation: null,
      },
    },
    {
      id: "WG639VkTjmK5dzydd1BBJA",
      alias: "rubirosa-new-york-2",
      name: "Rubirosa",
      image_url:
        "https://s3-media3.fl.yelpcdn.com/bphoto/BYMrcy5GA756PnCd7l0PMg/o.jpg",
      is_closed: false,
      url: "https://www.yelp.com/biz/rubirosa-new-york-2?adjust_creative=FlLcWTwY94L6PQ5d-K6zjg&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=FlLcWTwY94L6PQ5d-K6zjg",
      review_count: 3484,
      categories: [
        {
          alias: "italian",
          title: "Italian",
        },
        {
          alias: "pizza",
          title: "Pizza",
        },
      ],
      rating: 4.3,
      coordinates: {
        latitude: 40.722766,
        longitude: -73.996233,
      },
      transactions: ["pickup"],
      price: "$$",
      location: {
        address1: "235 Mulberry St",
        address2: "",
        address3: "",
        city: "New York",
        zip_code: "10012",
        country: "US",
        state: "NY",
        display_address: ["235 Mulberry St", "New York, NY 10012"],
      },
      phone: "+12129650500",
      display_phone: "(212) 965-0500",
      distance: 1922.0346803084792,
      business_hours: [
        {
          open: [
            {
              is_overnight: false,
              start: "1100",
              end: "2300",
              day: 0,
            },
            {
              is_overnight: false,
              start: "1100",
              end: "2300",
              day: 1,
            },
            {
              is_overnight: false,
              start: "1100",
              end: "2300",
              day: 2,
            },
            {
              is_overnight: false,
              start: "1100",
              end: "2300",
              day: 3,
            },
            {
              is_overnight: false,
              start: "1100",
              end: "2300",
              day: 4,
            },
            {
              is_overnight: false,
              start: "1100",
              end: "2300",
              day: 5,
            },
            {
              is_overnight: false,
              start: "1100",
              end: "2300",
              day: 6,
            },
          ],
          hours_type: "REGULAR",
          is_open_now: true,
        },
      ],
      attributes: {
        business_temp_closed: null,
        menu_url: "https://www.rubirosanyc.com/menus/",
        open24_hours: null,
        waitlist_reservation: null,
      },
    },
    {
      id: "O1fUmxt3kbV-rnyjBtzAfw",
      alias: "thep-thai-restaurant-new-york-5",
      name: "THEP Thai Restaurant",
      image_url:
        "https://s3-media3.fl.yelpcdn.com/bphoto/WymEpZCm4CPRTeVHXVyzXQ/o.jpg",
      is_closed: false,
      url: "https://www.yelp.com/biz/thep-thai-restaurant-new-york-5?adjust_creative=FlLcWTwY94L6PQ5d-K6zjg&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=FlLcWTwY94L6PQ5d-K6zjg",
      review_count: 3243,
      categories: [
        {
          alias: "thai",
          title: "Thai",
        },
        {
          alias: "noodles",
          title: "Noodles",
        },
        {
          alias: "asianfusion",
          title: "Asian Fusion",
        },
      ],
      rating: 4.5,
      coordinates: {
        latitude: 40.77078,
        longitude: -73.95727,
      },
      transactions: ["pickup", "delivery"],
      price: "$$$",
      location: {
        address1: "1439 2nd Ave",
        address2: "",
        address3: null,
        city: "New York",
        zip_code: "10021",
        country: "US",
        state: "NY",
        display_address: ["1439 2nd Ave", "New York, NY 10021"],
      },
      phone: "+12128999995",
      display_phone: "(212) 899-9995",
      distance: 7893.531804274394,
      business_hours: [
        {
          open: [
            {
              is_overnight: false,
              start: "1130",
              end: "1545",
              day: 0,
            },
            {
              is_overnight: false,
              start: "1700",
              end: "2230",
              day: 0,
            },
            {
              is_overnight: false,
              start: "1130",
              end: "1545",
              day: 1,
            },
            {
              is_overnight: false,
              start: "1700",
              end: "2230",
              day: 1,
            },
            {
              is_overnight: false,
              start: "1130",
              end: "1545",
              day: 2,
            },
            {
              is_overnight: false,
              start: "1700",
              end: "2230",
              day: 2,
            },
            {
              is_overnight: false,
              start: "1130",
              end: "1545",
              day: 3,
            },
            {
              is_overnight: false,
              start: "1700",
              end: "2230",
              day: 3,
            },
            {
              is_overnight: false,
              start: "1130",
              end: "1545",
              day: 4,
            },
            {
              is_overnight: false,
              start: "1700",
              end: "2330",
              day: 4,
            },
            {
              is_overnight: false,
              start: "1200",
              end: "2330",
              day: 5,
            },
            {
              is_overnight: false,
              start: "1200",
              end: "2230",
              day: 6,
            },
          ],
          hours_type: "REGULAR",
          is_open_now: true,
        },
      ],
      attributes: {
        business_temp_closed: null,
        menu_url: "https://eat.9fold.me/index.html#/627",
        open24_hours: null,
        waitlist_reservation: true,
      },
    },
    {
      id: "VvsZAnEwU4c8Xkyrzx05Nw",
      alias: "anytime-kitchen-new-york-2",
      name: "Anytime Kitchen ",
      image_url:
        "https://s3-media2.fl.yelpcdn.com/bphoto/q9USNL58Hz3WcQhY8VPB4Q/o.jpg",
      is_closed: false,
      url: "https://www.yelp.com/biz/anytime-kitchen-new-york-2?adjust_creative=FlLcWTwY94L6PQ5d-K6zjg&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=FlLcWTwY94L6PQ5d-K6zjg",
      review_count: 3105,
      categories: [
        {
          alias: "korean",
          title: "Korean",
        },
        {
          alias: "tapasmallplates",
          title: "Tapas/Small Plates",
        },
        {
          alias: "bbq",
          title: "Barbeque",
        },
      ],
      rating: 4.6,
      coordinates: {
        latitude: 40.74776270790539,
        longitude: -73.9867793576711,
      },
      transactions: ["pickup", "delivery"],
      price: "$$",
      location: {
        address1: "23 W 32nd St",
        address2: "Fl 3",
        address3: "",
        city: "New York",
        zip_code: "10001",
        country: "US",
        state: "NY",
        display_address: ["23 W 32nd St", "Fl 3", "New York, NY 10001"],
      },
      phone: "+16466697733",
      display_phone: "(646) 669-7733",
      distance: 4736.528034255248,
      business_hours: [
        {
          open: [
            {
              is_overnight: false,
              start: "1130",
              end: "1500",
              day: 0,
            },
            {
              is_overnight: true,
              start: "1700",
              end: "0100",
              day: 0,
            },
            {
              is_overnight: false,
              start: "1130",
              end: "1500",
              day: 1,
            },
            {
              is_overnight: true,
              start: "1700",
              end: "0100",
              day: 1,
            },
            {
              is_overnight: false,
              start: "1130",
              end: "1500",
              day: 2,
            },
            {
              is_overnight: true,
              start: "1700",
              end: "0100",
              day: 2,
            },
            {
              is_overnight: false,
              start: "1130",
              end: "1500",
              day: 3,
            },
            {
              is_overnight: true,
              start: "1700",
              end: "0100",
              day: 3,
            },
            {
              is_overnight: false,
              start: "1130",
              end: "1500",
              day: 4,
            },
            {
              is_overnight: true,
              start: "1700",
              end: "0330",
              day: 4,
            },
            {
              is_overnight: false,
              start: "1130",
              end: "1500",
              day: 5,
            },
            {
              is_overnight: true,
              start: "1700",
              end: "0330",
              day: 5,
            },
            {
              is_overnight: false,
              start: "1130",
              end: "1500",
              day: 6,
            },
            {
              is_overnight: true,
              start: "1700",
              end: "0100",
              day: 6,
            },
          ],
          hours_type: "REGULAR",
          is_open_now: true,
        },
      ],
      attributes: {
        business_temp_closed: null,
        menu_url: null,
        open24_hours: null,
        waitlist_reservation: true,
      },
    },
    {
      id: "B3_K2kUVbYOU0VaLcj_LTw",
      alias: "thai-villa-new-york-2",
      name: "Thai Villa",
      image_url:
        "https://s3-media2.fl.yelpcdn.com/bphoto/PYopFnTm-C0yA-v0lePQcQ/o.jpg",
      is_closed: false,
      url: "https://www.yelp.com/biz/thai-villa-new-york-2?adjust_creative=FlLcWTwY94L6PQ5d-K6zjg&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=FlLcWTwY94L6PQ5d-K6zjg",
      review_count: 5135,
      categories: [
        {
          alias: "thai",
          title: "Thai",
        },
      ],
      rating: 4.4,
      coordinates: {
        latitude: 40.73902,
        longitude: -73.99065,
      },
      transactions: ["pickup", "delivery"],
      price: "$$",
      location: {
        address1: "5 E 19th St",
        address2: "G Floor",
        address3: "",
        city: "New York",
        zip_code: "10003",
        country: "US",
        state: "NY",
        display_address: ["5 E 19th St", "G Floor", "New York, NY 10003"],
      },
      phone: "+12128029999",
      display_phone: "(212) 802-9999",
      distance: 3733.2340039118267,
      business_hours: [
        {
          open: [
            {
              is_overnight: false,
              start: "1130",
              end: "1515",
              day: 0,
            },
            {
              is_overnight: false,
              start: "1630",
              end: "2215",
              day: 0,
            },
            {
              is_overnight: false,
              start: "1130",
              end: "1515",
              day: 1,
            },
            {
              is_overnight: false,
              start: "1630",
              end: "2215",
              day: 1,
            },
            {
              is_overnight: false,
              start: "1130",
              end: "1515",
              day: 2,
            },
            {
              is_overnight: false,
              start: "1630",
              end: "2215",
              day: 2,
            },
            {
              is_overnight: false,
              start: "1130",
              end: "1515",
              day: 3,
            },
            {
              is_overnight: false,
              start: "1630",
              end: "2215",
              day: 3,
            },
            {
              is_overnight: false,
              start: "1130",
              end: "1515",
              day: 4,
            },
            {
              is_overnight: false,
              start: "1630",
              end: "2240",
              day: 4,
            },
            {
              is_overnight: false,
              start: "1130",
              end: "1515",
              day: 5,
            },
            {
              is_overnight: false,
              start: "1630",
              end: "2240",
              day: 5,
            },
            {
              is_overnight: false,
              start: "1130",
              end: "1515",
              day: 6,
            },
            {
              is_overnight: false,
              start: "1630",
              end: "2215",
              day: 6,
            },
          ],
          hours_type: "REGULAR",
          is_open_now: true,
        },
      ],
      attributes: {
        business_temp_closed: null,
        menu_url: "",
        open24_hours: null,
        waitlist_reservation: null,
      },
    },
    {
      id: "DGhWO1sUWydVeR5j5ZZaMw",
      alias: "la-grande-boucherie-new-york-2",
      name: "La Grande Boucherie",
      image_url:
        "https://s3-media3.fl.yelpcdn.com/bphoto/b9URGcuuhnLq7J-__pHIng/o.jpg",
      is_closed: false,
      url: "https://www.yelp.com/biz/la-grande-boucherie-new-york-2?adjust_creative=FlLcWTwY94L6PQ5d-K6zjg&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=FlLcWTwY94L6PQ5d-K6zjg",
      review_count: 3734,
      categories: [
        {
          alias: "french",
          title: "French",
        },
        {
          alias: "steak",
          title: "Steakhouses",
        },
        {
          alias: "cocktailbars",
          title: "Cocktail Bars",
        },
      ],
      rating: 4.4,
      coordinates: {
        latitude: 40.7626274,
        longitude: -73.98084109999999,
      },
      transactions: ["pickup", "delivery"],
      price: "$$$",
      location: {
        address1: "145 W 53rd St",
        address2: "",
        address3: null,
        city: "New York",
        zip_code: "10019",
        country: "US",
        state: "NY",
        display_address: ["145 W 53rd St", "New York, NY 10019"],
      },
      phone: "+12125107714",
      display_phone: "(212) 510-7714",
      distance: 6447.196690217016,
      business_hours: [
        {
          open: [
            {
              is_overnight: false,
              start: "0800",
              end: "0000",
              day: 0,
            },
            {
              is_overnight: false,
              start: "0800",
              end: "0000",
              day: 1,
            },
            {
              is_overnight: false,
              start: "0800",
              end: "0000",
              day: 2,
            },
            {
              is_overnight: false,
              start: "0800",
              end: "0000",
              day: 3,
            },
            {
              is_overnight: false,
              start: "0800",
              end: "0000",
              day: 4,
            },
            {
              is_overnight: false,
              start: "0900",
              end: "0000",
              day: 5,
            },
            {
              is_overnight: false,
              start: "0900",
              end: "0000",
              day: 6,
            },
          ],
          hours_type: "REGULAR",
          is_open_now: true,
        },
      ],
      attributes: {
        business_temp_closed: null,
        menu_url: "https://www.boucherieus.com/la-grande-boucherie-menus/",
        open24_hours: null,
        waitlist_reservation: null,
      },
    },
    {
      id: "fVbUVAiLiGgLA_nxBFxyww",
      alias: "thursday-kitchen-new-york",
      name: "Thursday Kitchen",
      image_url:
        "https://s3-media2.fl.yelpcdn.com/bphoto/iCP4QYCjWf9i-qDIBQrsnQ/o.jpg",
      is_closed: false,
      url: "https://www.yelp.com/biz/thursday-kitchen-new-york?adjust_creative=FlLcWTwY94L6PQ5d-K6zjg&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=FlLcWTwY94L6PQ5d-K6zjg",
      review_count: 1844,
      categories: [
        {
          alias: "korean",
          title: "Korean",
        },
        {
          alias: "newamerican",
          title: "New American",
        },
        {
          alias: "tapasmallplates",
          title: "Tapas/Small Plates",
        },
      ],
      rating: 4.4,
      coordinates: {
        latitude: 40.72761,
        longitude: -73.98373,
      },
      transactions: ["pickup", "delivery"],
      price: "$$",
      location: {
        address1: "424 E 9th St",
        address2: null,
        address3: "",
        city: "New York",
        zip_code: "10009",
        country: "US",
        state: "NY",
        display_address: ["424 E 9th St", "New York, NY 10009"],
      },
      phone: "",
      display_phone: "",
      distance: 2602.315012688822,
      business_hours: [
        {
          open: [
            {
              is_overnight: false,
              start: "1800",
              end: "2215",
              day: 0,
            },
            {
              is_overnight: false,
              start: "1800",
              end: "2215",
              day: 1,
            },
            {
              is_overnight: false,
              start: "1800",
              end: "2215",
              day: 2,
            },
            {
              is_overnight: false,
              start: "1800",
              end: "2215",
              day: 3,
            },
            {
              is_overnight: false,
              start: "1700",
              end: "2315",
              day: 4,
            },
            {
              is_overnight: false,
              start: "1700",
              end: "2315",
              day: 5,
            },
            {
              is_overnight: false,
              start: "1700",
              end: "2215",
              day: 6,
            },
          ],
          hours_type: "REGULAR",
          is_open_now: true,
        },
      ],
      attributes: {
        business_temp_closed: null,
        menu_url: "https://www.thursdaykitchen.com/menu",
        open24_hours: null,
        waitlist_reservation: null,
      },
    },
    {
      id: "ypqK8DWM8Bcs43YveSJnNw",
      alias: "manhatta-new-york",
      name: "Manhatta",
      image_url:
        "https://s3-media3.fl.yelpcdn.com/bphoto/uHQHaX-Q6_Z0ptEGNFenIw/o.jpg",
      is_closed: false,
      url: "https://www.yelp.com/biz/manhatta-new-york?adjust_creative=FlLcWTwY94L6PQ5d-K6zjg&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=FlLcWTwY94L6PQ5d-K6zjg",
      review_count: 801,
      categories: [
        {
          alias: "newamerican",
          title: "New American",
        },
      ],
      rating: 4.4,
      coordinates: {
        latitude: 40.70800627689857,
        longitude: -74.00888226517013,
      },
      transactions: [],
      price: "$$$$",
      location: {
        address1: "28 Liberty St",
        address2: "Fl 60",
        address3: null,
        city: "New York",
        zip_code: "10005",
        country: "US",
        state: "NY",
        display_address: ["28 Liberty St", "Fl 60", "New York, NY 10005"],
      },
      phone: "+12122305788",
      display_phone: "(212) 230-5788",
      distance: 1262.2789968123395,
      business_hours: [
        {
          open: [
            {
              is_overnight: false,
              start: "1130",
              end: "2230",
              day: 0,
            },
            {
              is_overnight: false,
              start: "1130",
              end: "2230",
              day: 1,
            },
            {
              is_overnight: false,
              start: "1130",
              end: "2230",
              day: 2,
            },
            {
              is_overnight: false,
              start: "1130",
              end: "2230",
              day: 3,
            },
            {
              is_overnight: false,
              start: "1130",
              end: "2230",
              day: 4,
            },
            {
              is_overnight: false,
              start: "1130",
              end: "2230",
              day: 5,
            },
            {
              is_overnight: false,
              start: "1130",
              end: "2230",
              day: 6,
            },
          ],
          hours_type: "REGULAR",
          is_open_now: true,
        },
      ],
      attributes: {
        business_temp_closed: null,
        menu_url: "https://www.manhattarestaurant.com/the-dining-room/",
        open24_hours: null,
        waitlist_reservation: null,
      },
    },
    {
      id: "ryvBsB9FrBBZDak87iGS1w",
      alias: "sea-fire-grill-new-york",
      name: "Sea Fire Grill",
      image_url:
        "https://s3-media4.fl.yelpcdn.com/bphoto/PD633DTyXfIe-iO4z3_xtg/o.jpg",
      is_closed: false,
      url: "https://www.yelp.com/biz/sea-fire-grill-new-york?adjust_creative=FlLcWTwY94L6PQ5d-K6zjg&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=FlLcWTwY94L6PQ5d-K6zjg",
      review_count: 1653,
      categories: [
        {
          alias: "seafood",
          title: "Seafood",
        },
        {
          alias: "steak",
          title: "Steakhouses",
        },
        {
          alias: "bars",
          title: "Bars",
        },
      ],
      rating: 4.5,
      coordinates: {
        latitude: 40.754691900002385,
        longitude: -73.97222533963885,
      },
      transactions: ["pickup", "delivery"],
      price: "$$$",
      location: {
        address1: "158 E 48th St",
        address2: null,
        address3: "",
        city: "New York",
        zip_code: "10017",
        country: "US",
        state: "NY",
        display_address: ["158 E 48th St", "New York, NY 10017"],
      },
      phone: "+12129353785",
      display_phone: "(212) 935-3785",
      distance: 5771.732704349051,
      business_hours: [
        {
          open: [
            {
              is_overnight: false,
              start: "1130",
              end: "2230",
              day: 0,
            },
            {
              is_overnight: false,
              start: "1130",
              end: "2230",
              day: 1,
            },
            {
              is_overnight: false,
              start: "1130",
              end: "2230",
              day: 2,
            },
            {
              is_overnight: false,
              start: "1130",
              end: "2230",
              day: 3,
            },
            {
              is_overnight: false,
              start: "1130",
              end: "2230",
              day: 4,
            },
            {
              is_overnight: false,
              start: "1600",
              end: "2230",
              day: 5,
            },
          ],
          hours_type: "REGULAR",
          is_open_now: true,
        },
      ],
      attributes: {
        business_temp_closed: null,
        menu_url: "https://theseafiregrill.com/menus/lunch/",
        open24_hours: null,
        waitlist_reservation: null,
      },
    },
    {
      id: "-Q8MYIWoE4EsGQtudIOY0w",
      alias: "bua-thai-ramen-and-robata-grill-new-york",
      name: "Bua Thai Ramen & Robata Grill",
      image_url:
        "https://s3-media3.fl.yelpcdn.com/bphoto/STPkeCnzxNZTax2QYGhe-g/o.jpg",
      is_closed: false,
      url: "https://www.yelp.com/biz/bua-thai-ramen-and-robata-grill-new-york?adjust_creative=FlLcWTwY94L6PQ5d-K6zjg&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=FlLcWTwY94L6PQ5d-K6zjg",
      review_count: 3170,
      categories: [
        {
          alias: "thai",
          title: "Thai",
        },
        {
          alias: "ramen",
          title: "Ramen",
        },
        {
          alias: "vegetarian",
          title: "Vegetarian",
        },
      ],
      rating: 4.5,
      coordinates: {
        latitude: 40.7763615,
        longitude: -73.95308,
      },
      transactions: ["pickup", "restaurant_reservation", "delivery"],
      price: "$$",
      location: {
        address1: "1611 2nd Ave",
        address2: null,
        address3: "",
        city: "New York",
        zip_code: "10028",
        country: "US",
        state: "NY",
        display_address: ["1611 2nd Ave", "New York, NY 10028"],
      },
      phone: "+12128797999",
      display_phone: "(212) 879-7999",
      distance: 8604.910580262833,
      business_hours: [
        {
          open: [
            {
              is_overnight: false,
              start: "1130",
              end: "2230",
              day: 0,
            },
            {
              is_overnight: false,
              start: "1130",
              end: "2230",
              day: 1,
            },
            {
              is_overnight: false,
              start: "1130",
              end: "2230",
              day: 2,
            },
            {
              is_overnight: false,
              start: "1130",
              end: "2230",
              day: 3,
            },
            {
              is_overnight: false,
              start: "1130",
              end: "2330",
              day: 4,
            },
            {
              is_overnight: false,
              start: "1200",
              end: "2330",
              day: 5,
            },
            {
              is_overnight: false,
              start: "1200",
              end: "2230",
              day: 6,
            },
          ],
          hours_type: "REGULAR",
          is_open_now: true,
        },
      ],
      attributes: {
        business_temp_closed: null,
        menu_url: null,
        open24_hours: null,
        waitlist_reservation: true,
      },
    },
    {
      id: "WJS06XxRdc6DD1s4LWE9HA",
      alias: "fish-cheeks-new-york",
      name: "Fish Cheeks",
      image_url:
        "https://s3-media2.fl.yelpcdn.com/bphoto/pqupe3fe52869QQ23KkiBg/o.jpg",
      is_closed: false,
      url: "https://www.yelp.com/biz/fish-cheeks-new-york?adjust_creative=FlLcWTwY94L6PQ5d-K6zjg&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=FlLcWTwY94L6PQ5d-K6zjg",
      review_count: 1735,
      categories: [
        {
          alias: "seafood",
          title: "Seafood",
        },
        {
          alias: "thai",
          title: "Thai",
        },
        {
          alias: "raw_food",
          title: "Live/Raw Food",
        },
      ],
      rating: 4.4,
      coordinates: {
        latitude: 40.7258,
        longitude: -73.9927,
      },
      transactions: ["pickup", "delivery"],
      price: "$$",
      location: {
        address1: "55 Bond St",
        address2: "",
        address3: null,
        city: "New York",
        zip_code: "10012",
        country: "US",
        state: "NY",
        display_address: ["55 Bond St", "New York, NY 10012"],
      },
      phone: "+12126772223",
      display_phone: "(212) 677-2223",
      distance: 2242.4252176048417,
      business_hours: [
        {
          open: [
            {
              is_overnight: false,
              start: "1200",
              end: "2200",
              day: 0,
            },
            {
              is_overnight: false,
              start: "1200",
              end: "2200",
              day: 1,
            },
            {
              is_overnight: false,
              start: "1200",
              end: "2200",
              day: 2,
            },
            {
              is_overnight: false,
              start: "1200",
              end: "2200",
              day: 3,
            },
            {
              is_overnight: false,
              start: "1200",
              end: "2300",
              day: 4,
            },
            {
              is_overnight: false,
              start: "1200",
              end: "2300",
              day: 5,
            },
            {
              is_overnight: false,
              start: "1200",
              end: "2200",
              day: 6,
            },
          ],
          hours_type: "REGULAR",
          is_open_now: true,
        },
      ],
      attributes: {
        business_temp_closed: null,
        menu_url: "https://www.fishcheeksnyc.com/menus/",
        open24_hours: null,
        waitlist_reservation: null,
      },
    },
    {
      id: "1DfbZ0VsSCg9g1KILmnvzQ",
      alias: "per-se-new-york",
      name: "Per Se",
      image_url:
        "https://s3-media1.fl.yelpcdn.com/bphoto/9r083qJDOAn9H3Q-vAQgHw/o.jpg",
      is_closed: false,
      url: "https://www.yelp.com/biz/per-se-new-york?adjust_creative=FlLcWTwY94L6PQ5d-K6zjg&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=FlLcWTwY94L6PQ5d-K6zjg",
      review_count: 1971,
      categories: [
        {
          alias: "french",
          title: "French",
        },
      ],
      rating: 4.5,
      coordinates: {
        latitude: 40.7681528889558,
        longitude: -73.9827629623657,
      },
      transactions: [],
      price: "$$$$",
      location: {
        address1: "10 Columbus Cir",
        address2: "Fl 4",
        address3: null,
        city: "New York",
        zip_code: "10019",
        country: "US",
        state: "NY",
        display_address: ["10 Columbus Cir", "Fl 4", "New York, NY 10019"],
      },
      phone: "+12128239335",
      display_phone: "(212) 823-9335",
      distance: 7028.746060156897,
      business_hours: [
        {
          open: [
            {
              is_overnight: false,
              start: "1630",
              end: "2030",
              day: 0,
            },
            {
              is_overnight: false,
              start: "1630",
              end: "2030",
              day: 1,
            },
            {
              is_overnight: false,
              start: "1630",
              end: "2030",
              day: 2,
            },
            {
              is_overnight: false,
              start: "1630",
              end: "2030",
              day: 3,
            },
            {
              is_overnight: false,
              start: "1630",
              end: "2030",
              day: 4,
            },
            {
              is_overnight: false,
              start: "1630",
              end: "2030",
              day: 5,
            },
            {
              is_overnight: false,
              start: "1630",
              end: "2030",
              day: 6,
            },
          ],
          hours_type: "REGULAR",
          is_open_now: false,
        },
      ],
      attributes: {
        business_temp_closed: null,
        menu_url:
          "http://www.thomaskeller.com/new-york-new-york/per-se/todays-menus",
        open24_hours: null,
        waitlist_reservation: null,
      },
    },
    {
      id: "_LJFf9YqpYxvExTvVxb7Rw",
      alias: "the-modern-new-york-3",
      name: "The Modern",
      image_url:
        "https://s3-media3.fl.yelpcdn.com/bphoto/jWYFAgxkZ-Y7sFIr29mDIQ/o.jpg",
      is_closed: false,
      url: "https://www.yelp.com/biz/the-modern-new-york-3?adjust_creative=FlLcWTwY94L6PQ5d-K6zjg&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=FlLcWTwY94L6PQ5d-K6zjg",
      review_count: 1254,
      categories: [
        {
          alias: "newamerican",
          title: "New American",
        },
      ],
      rating: 4.3,
      coordinates: {
        latitude: 40.761106128269006,
        longitude: -73.97670872686992,
      },
      transactions: ["pickup"],
      price: "$$$$",
      location: {
        address1: "9 W 53rd St",
        address2: "",
        address3: "",
        city: "New York",
        zip_code: "10019",
        country: "US",
        state: "NY",
        display_address: ["9 W 53rd St", "New York, NY 10019"],
      },
      phone: "+12123331220",
      display_phone: "(212) 333-1220",
      distance: 6352.669745324919,
      business_hours: [
        {
          open: [
            {
              is_overnight: false,
              start: "1200",
              end: "1400",
              day: 0,
            },
            {
              is_overnight: false,
              start: "1730",
              end: "2100",
              day: 0,
            },
            {
              is_overnight: false,
              start: "1200",
              end: "1400",
              day: 1,
            },
            {
              is_overnight: false,
              start: "1730",
              end: "2100",
              day: 1,
            },
            {
              is_overnight: false,
              start: "1200",
              end: "1400",
              day: 2,
            },
            {
              is_overnight: false,
              start: "1730",
              end: "2100",
              day: 2,
            },
            {
              is_overnight: false,
              start: "1200",
              end: "1400",
              day: 3,
            },
            {
              is_overnight: false,
              start: "1730",
              end: "2100",
              day: 3,
            },
            {
              is_overnight: false,
              start: "1200",
              end: "1400",
              day: 4,
            },
            {
              is_overnight: false,
              start: "1700",
              end: "2100",
              day: 4,
            },
            {
              is_overnight: false,
              start: "1200",
              end: "1400",
              day: 5,
            },
            {
              is_overnight: false,
              start: "1700",
              end: "2100",
              day: 5,
            },
            {
              is_overnight: false,
              start: "1200",
              end: "1400",
              day: 6,
            },
          ],
          hours_type: "REGULAR",
          is_open_now: false,
        },
      ],
      attributes: {
        business_temp_closed: null,
        menu_url: null,
        open24_hours: null,
        waitlist_reservation: null,
      },
    },
    {
      id: "liZmIO0FqZwslLJfLDkfgw",
      alias: "wayla-new-york",
      name: "Wayla",
      image_url:
        "https://s3-media2.fl.yelpcdn.com/bphoto/u17PWWBYzqe3p1uEPgKVuQ/o.jpg",
      is_closed: false,
      url: "https://www.yelp.com/biz/wayla-new-york?adjust_creative=FlLcWTwY94L6PQ5d-K6zjg&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=FlLcWTwY94L6PQ5d-K6zjg",
      review_count: 720,
      categories: [
        {
          alias: "thai",
          title: "Thai",
        },
      ],
      rating: 4.4,
      coordinates: {
        latitude: 40.7183,
        longitude: -73.9926038,
      },
      transactions: ["delivery"],
      price: "$$$",
      location: {
        address1: "100 Forsyth St",
        address2: "Basement",
        address3: null,
        city: "New York",
        zip_code: "10002",
        country: "US",
        state: "NY",
        display_address: ["100 Forsyth St", "Basement", "New York, NY 10002"],
      },
      phone: "+12122062500",
      display_phone: "(212) 206-2500",
      distance: 1425.1367257566037,
      business_hours: [
        {
          open: [
            {
              is_overnight: false,
              start: "1200",
              end: "1500",
              day: 0,
            },
            {
              is_overnight: false,
              start: "1700",
              end: "2230",
              day: 0,
            },
            {
              is_overnight: false,
              start: "1200",
              end: "1500",
              day: 1,
            },
            {
              is_overnight: false,
              start: "1700",
              end: "2230",
              day: 1,
            },
            {
              is_overnight: false,
              start: "1200",
              end: "1500",
              day: 2,
            },
            {
              is_overnight: false,
              start: "1700",
              end: "2230",
              day: 2,
            },
            {
              is_overnight: false,
              start: "1200",
              end: "1500",
              day: 3,
            },
            {
              is_overnight: false,
              start: "1700",
              end: "2300",
              day: 3,
            },
            {
              is_overnight: false,
              start: "1200",
              end: "1500",
              day: 4,
            },
            {
              is_overnight: false,
              start: "1700",
              end: "2300",
              day: 4,
            },
            {
              is_overnight: false,
              start: "1200",
              end: "1500",
              day: 5,
            },
            {
              is_overnight: false,
              start: "1700",
              end: "2300",
              day: 5,
            },
            {
              is_overnight: false,
              start: "1200",
              end: "1500",
              day: 6,
            },
            {
              is_overnight: false,
              start: "1700",
              end: "2230",
              day: 6,
            },
          ],
          hours_type: "REGULAR",
          is_open_now: true,
        },
      ],
      attributes: {
        business_temp_closed: null,
        menu_url: null,
        open24_hours: null,
        waitlist_reservation: null,
      },
    },
    {
      id: "OgM6WwztLVavBQBmb_g5aw",
      alias: "tara-rose-new-york",
      name: "Tara Rose",
      image_url:
        "https://s3-media1.fl.yelpcdn.com/bphoto/kG8tgQIth43z16uTy1qP_w/o.jpg",
      is_closed: false,
      url: "https://www.yelp.com/biz/tara-rose-new-york?adjust_creative=FlLcWTwY94L6PQ5d-K6zjg&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=FlLcWTwY94L6PQ5d-K6zjg",
      review_count: 928,
      categories: [
        {
          alias: "cocktailbars",
          title: "Cocktail Bars",
        },
        {
          alias: "newamerican",
          title: "New American",
        },
        {
          alias: "breakfast_brunch",
          title: "Breakfast & Brunch",
        },
      ],
      rating: 4.6,
      coordinates: {
        latitude: 40.741803261063986,
        longitude: -73.98122457328056,
      },
      transactions: ["pickup", "restaurant_reservation", "delivery"],
      price: "$$",
      location: {
        address1: "384 3rd Ave",
        address2: "",
        address3: "",
        city: "New York",
        zip_code: "10016",
        country: "US",
        state: "NY",
        display_address: ["384 3rd Ave", "New York, NY 10016"],
      },
      phone: "+19296025983",
      display_phone: "(929) 602-5983",
      distance: 4178.744042124024,
      business_hours: [
        {
          open: [
            {
              is_overnight: true,
              start: "1200",
              end: "0100",
              day: 0,
            },
            {
              is_overnight: true,
              start: "1200",
              end: "0200",
              day: 1,
            },
            {
              is_overnight: true,
              start: "1200",
              end: "0200",
              day: 2,
            },
            {
              is_overnight: true,
              start: "1200",
              end: "0200",
              day: 3,
            },
            {
              is_overnight: true,
              start: "1200",
              end: "0300",
              day: 4,
            },
            {
              is_overnight: true,
              start: "1000",
              end: "0300",
              day: 5,
            },
            {
              is_overnight: true,
              start: "1000",
              end: "0100",
              day: 6,
            },
          ],
          hours_type: "REGULAR",
          is_open_now: true,
        },
      ],
      attributes: {
        business_temp_closed: null,
        menu_url:
          "http://tararosenyc.com/NEW-YORK-Murray-Hill-Tara-Rose-food-menu",
        open24_hours: null,
        waitlist_reservation: false,
      },
    },
    {
      id: "gNGxh97n0NZgYG1Q_no9Kg",
      alias: "potluck-club-佰樂-new-york",
      name: "Potluck Club 佰樂",
      image_url:
        "https://s3-media2.fl.yelpcdn.com/bphoto/yKFxQPPeMwobQAWrnsg2Hg/o.jpg",
      is_closed: false,
      url: "https://www.yelp.com/biz/potluck-club-%E4%BD%B0%E6%A8%82-new-york?adjust_creative=FlLcWTwY94L6PQ5d-K6zjg&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=FlLcWTwY94L6PQ5d-K6zjg",
      review_count: 438,
      categories: [
        {
          alias: "cantonese",
          title: "Cantonese",
        },
        {
          alias: "asianfusion",
          title: "Asian Fusion",
        },
      ],
      rating: 4.4,
      coordinates: {
        latitude: 40.719588,
        longitude: -73.993519,
      },
      transactions: ["pickup", "delivery"],
      location: {
        address1: "133 Chrystie St",
        address2: null,
        address3: "",
        city: "New York",
        zip_code: "10002",
        country: "US",
        state: "NY",
        display_address: ["133 Chrystie St", "New York, NY 10002"],
      },
      phone: "",
      display_phone: "",
      distance: 1562.3751366004904,
      business_hours: [
        {
          open: [
            {
              is_overnight: false,
              start: "1730",
              end: "2115",
              day: 2,
            },
            {
              is_overnight: false,
              start: "1730",
              end: "2115",
              day: 3,
            },
            {
              is_overnight: false,
              start: "1730",
              end: "2115",
              day: 4,
            },
            {
              is_overnight: false,
              start: "1100",
              end: "1400",
              day: 5,
            },
            {
              is_overnight: false,
              start: "1730",
              end: "2115",
              day: 5,
            },
            {
              is_overnight: false,
              start: "1100",
              end: "1400",
              day: 6,
            },
            {
              is_overnight: false,
              start: "1730",
              end: "2115",
              day: 6,
            },
          ],
          hours_type: "REGULAR",
          is_open_now: true,
        },
      ],
      attributes: {
        business_temp_closed: null,
        menu_url: "https://thepotluckclubny.com/pages/menu",
        open24_hours: null,
        waitlist_reservation: null,
      },
    },
    {
      id: "oTL_nPII6x0HfPVpEQklUg",
      alias: "planta-queen-nomad-new-york",
      name: "PLANTA Queen Nomad",
      image_url:
        "https://s3-media3.fl.yelpcdn.com/bphoto/3VhsoOZADtBaCLVNF--NnA/o.jpg",
      is_closed: false,
      url: "https://www.yelp.com/biz/planta-queen-nomad-new-york?adjust_creative=FlLcWTwY94L6PQ5d-K6zjg&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=FlLcWTwY94L6PQ5d-K6zjg",
      review_count: 816,
      categories: [
        {
          alias: "vegetarian",
          title: "Vegetarian",
        },
        {
          alias: "sushi",
          title: "Sushi Bars",
        },
        {
          alias: "asianfusion",
          title: "Asian Fusion",
        },
      ],
      rating: 4.4,
      coordinates: {
        latitude: 40.744427,
        longitude: -73.988302,
      },
      transactions: ["pickup", "delivery"],
      price: "$$",
      location: {
        address1: "15 W 27th St",
        address2: null,
        address3: null,
        city: "New York",
        zip_code: "10001",
        country: "US",
        state: "NY",
        display_address: ["15 W 27th St", "New York, NY 10001"],
      },
      phone: "+19176757700",
      display_phone: "(917) 675-7700",
      distance: 4357.073704322944,
      business_hours: [
        {
          open: [
            {
              is_overnight: false,
              start: "1130",
              end: "2200",
              day: 0,
            },
            {
              is_overnight: false,
              start: "1130",
              end: "2200",
              day: 1,
            },
            {
              is_overnight: false,
              start: "1130",
              end: "2200",
              day: 2,
            },
            {
              is_overnight: false,
              start: "1130",
              end: "2200",
              day: 3,
            },
            {
              is_overnight: false,
              start: "1130",
              end: "2300",
              day: 4,
            },
            {
              is_overnight: false,
              start: "1100",
              end: "2300",
              day: 5,
            },
            {
              is_overnight: false,
              start: "1100",
              end: "2200",
              day: 6,
            },
          ],
          hours_type: "REGULAR",
          is_open_now: true,
        },
      ],
      attributes: {
        business_temp_closed: null,
        menu_url:
          "https://www.plantarestaurants.com/location/planta-queen-new-york-city/#all-day-menu-new-york",
        open24_hours: null,
        waitlist_reservation: null,
      },
    },
    {
      id: "7_hGsGEkHrjgAiYVjrCFnw",
      alias: "carbone-new-york",
      name: "Carbone",
      image_url:
        "https://s3-media2.fl.yelpcdn.com/bphoto/of9hnqrTa-rhXg3dLNmfow/o.jpg",
      is_closed: false,
      url: "https://www.yelp.com/biz/carbone-new-york?adjust_creative=FlLcWTwY94L6PQ5d-K6zjg&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=FlLcWTwY94L6PQ5d-K6zjg",
      review_count: 1949,
      categories: [
        {
          alias: "italian",
          title: "Italian",
        },
      ],
      rating: 4.0,
      coordinates: {
        latitude: 40.72800126711089,
        longitude: -74.00024274442806,
      },
      transactions: [],
      price: "$$$$",
      location: {
        address1: "181 Thompson St",
        address2: "",
        address3: "",
        city: "New York",
        zip_code: "10012",
        country: "US",
        state: "NY",
        display_address: ["181 Thompson St", "New York, NY 10012"],
      },
      phone: "+12122543000",
      display_phone: "(212) 254-3000",
      distance: 2547.331717119722,
      business_hours: [
        {
          open: [
            {
              is_overnight: false,
              start: "1700",
              end: "2330",
              day: 0,
            },
            {
              is_overnight: false,
              start: "1130",
              end: "1400",
              day: 1,
            },
            {
              is_overnight: false,
              start: "1700",
              end: "2330",
              day: 1,
            },
            {
              is_overnight: false,
              start: "1130",
              end: "1400",
              day: 2,
            },
            {
              is_overnight: false,
              start: "1700",
              end: "2330",
              day: 2,
            },
            {
              is_overnight: false,
              start: "1130",
              end: "1400",
              day: 3,
            },
            {
              is_overnight: false,
              start: "1700",
              end: "2330",
              day: 3,
            },
            {
              is_overnight: false,
              start: "1130",
              end: "1400",
              day: 4,
            },
            {
              is_overnight: false,
              start: "1700",
              end: "2330",
              day: 4,
            },
            {
              is_overnight: false,
              start: "1130",
              end: "1400",
              day: 5,
            },
            {
              is_overnight: false,
              start: "1700",
              end: "2330",
              day: 5,
            },
            {
              is_overnight: false,
              start: "1130",
              end: "1400",
              day: 6,
            },
            {
              is_overnight: false,
              start: "1700",
              end: "2330",
              day: 6,
            },
          ],
          hours_type: "REGULAR",
          is_open_now: true,
        },
      ],
      attributes: {
        business_temp_closed: null,
        menu_url: "http://carbonenewyork.com/menus.php",
        open24_hours: null,
        waitlist_reservation: null,
      },
    },
    {
      id: "44SY464xDHbvOcjDzRbKkQ",
      alias: "ippudo-ny-new-york-7",
      name: "Ippudo NY",
      image_url:
        "https://s3-media1.fl.yelpcdn.com/bphoto/zF3EgqHCk7zBUwD2B3WTEA/o.jpg",
      is_closed: false,
      url: "https://www.yelp.com/biz/ippudo-ny-new-york-7?adjust_creative=FlLcWTwY94L6PQ5d-K6zjg&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=FlLcWTwY94L6PQ5d-K6zjg",
      review_count: 10791,
      categories: [
        {
          alias: "ramen",
          title: "Ramen",
        },
      ],
      rating: 4.1,
      coordinates: {
        latitude: 40.730925,
        longitude: -73.990254,
      },
      transactions: ["pickup", "delivery"],
      price: "$$",
      location: {
        address1: "65 4th Ave",
        address2: "",
        address3: "",
        city: "New York",
        zip_code: "10003",
        country: "US",
        state: "NY",
        display_address: ["65 4th Ave", "New York, NY 10003"],
      },
      phone: "+12123880088",
      display_phone: "(212) 388-0088",
      distance: 2842.911241534329,
      business_hours: [
        {
          open: [
            {
              is_overnight: false,
              start: "1030",
              end: "2300",
              day: 0,
            },
            {
              is_overnight: false,
              start: "1030",
              end: "2300",
              day: 1,
            },
            {
              is_overnight: false,
              start: "1030",
              end: "2300",
              day: 2,
            },
            {
              is_overnight: false,
              start: "1030",
              end: "0000",
              day: 3,
            },
            {
              is_overnight: false,
              start: "1030",
              end: "0000",
              day: 4,
            },
            {
              is_overnight: false,
              start: "1100",
              end: "0000",
              day: 5,
            },
            {
              is_overnight: false,
              start: "1100",
              end: "2300",
              day: 6,
            },
          ],
          hours_type: "REGULAR",
          is_open_now: true,
        },
      ],
      attributes: {
        business_temp_closed: null,
        menu_url: "",
        open24_hours: null,
        waitlist_reservation: null,
      },
    },
    {
      id: "nI1UYDCYUTt23TpGxqnLKg",
      alias: "buddakan-new-york",
      name: "Buddakan",
      image_url:
        "https://s3-media4.fl.yelpcdn.com/bphoto/c03ky8wjQfUiElTbwGL7Pw/o.jpg",
      is_closed: false,
      url: "https://www.yelp.com/biz/buddakan-new-york?adjust_creative=FlLcWTwY94L6PQ5d-K6zjg&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=FlLcWTwY94L6PQ5d-K6zjg",
      review_count: 4790,
      categories: [
        {
          alias: "chinese",
          title: "Chinese",
        },
        {
          alias: "bars",
          title: "Bars",
        },
        {
          alias: "asianfusion",
          title: "Asian Fusion",
        },
      ],
      rating: 4.1,
      coordinates: {
        latitude: 40.7422762672197,
        longitude: -74.0048000961542,
      },
      transactions: ["pickup", "delivery"],
      price: "$$$$",
      location: {
        address1: "75 9th Ave",
        address2: null,
        address3: "",
        city: "New York",
        zip_code: "10011",
        country: "US",
        state: "NY",
        display_address: ["75 9th Ave", "New York, NY 10011"],
      },
      phone: "+12129896699",
      display_phone: "(212) 989-6699",
      distance: 4179.698118919742,
      business_hours: [
        {
          open: [
            {
              is_overnight: false,
              start: "1700",
              end: "2300",
              day: 0,
            },
            {
              is_overnight: false,
              start: "1700",
              end: "2300",
              day: 1,
            },
            {
              is_overnight: false,
              start: "1700",
              end: "2300",
              day: 2,
            },
            {
              is_overnight: false,
              start: "1700",
              end: "2300",
              day: 3,
            },
            {
              is_overnight: false,
              start: "1700",
              end: "0000",
              day: 4,
            },
            {
              is_overnight: false,
              start: "1600",
              end: "0000",
              day: 5,
            },
            {
              is_overnight: false,
              start: "1600",
              end: "2300",
              day: 6,
            },
          ],
          hours_type: "REGULAR",
          is_open_now: true,
        },
      ],
      attributes: {
        business_temp_closed: null,
        menu_url:
          "http://www.buddakannyc.com/PDF/dinner.pdf?utm_source=Yelp&utm_medium=Menu&utm_campaign=Enhanced%20Listings",
        open24_hours: null,
        waitlist_reservation: null,
      },
    },
    {
      id: "npiIhpcWePbVT3JYEcy3zg",
      alias: "wayan-new-york-4",
      name: "Wayan",
      image_url:
        "https://s3-media4.fl.yelpcdn.com/bphoto/aZaqqEEq4HjRLNw2s08NOg/o.jpg",
      is_closed: false,
      url: "https://www.yelp.com/biz/wayan-new-york-4?adjust_creative=FlLcWTwY94L6PQ5d-K6zjg&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=FlLcWTwY94L6PQ5d-K6zjg",
      review_count: 768,
      categories: [
        {
          alias: "indonesian",
          title: "Indonesian",
        },
        {
          alias: "french",
          title: "French",
        },
        {
          alias: "breakfast_brunch",
          title: "Breakfast & Brunch",
        },
      ],
      rating: 4.2,
      coordinates: {
        latitude: 40.7213813139202,
        longitude: -73.9950757664721,
      },
      transactions: ["pickup", "delivery"],
      price: "$$$",
      location: {
        address1: "20 Spring St",
        address2: "",
        address3: null,
        city: "New York",
        zip_code: "10012",
        country: "US",
        state: "NY",
        display_address: ["20 Spring St", "New York, NY 10012"],
      },
      phone: "+19172614388",
      display_phone: "(917) 261-4388",
      distance: 1762.2129884972733,
      business_hours: [
        {
          open: [
            {
              is_overnight: false,
              start: "1200",
              end: "1600",
              day: 0,
            },
            {
              is_overnight: false,
              start: "1730",
              end: "2300",
              day: 0,
            },
            {
              is_overnight: false,
              start: "1200",
              end: "1600",
              day: 1,
            },
            {
              is_overnight: false,
              start: "1730",
              end: "2300",
              day: 1,
            },
            {
              is_overnight: false,
              start: "1200",
              end: "1600",
              day: 2,
            },
            {
              is_overnight: false,
              start: "1730",
              end: "0000",
              day: 2,
            },
            {
              is_overnight: false,
              start: "1200",
              end: "1600",
              day: 3,
            },
            {
              is_overnight: false,
              start: "1730",
              end: "0000",
              day: 3,
            },
            {
              is_overnight: false,
              start: "1200",
              end: "1600",
              day: 4,
            },
            {
              is_overnight: false,
              start: "1730",
              end: "0000",
              day: 4,
            },
            {
              is_overnight: false,
              start: "1130",
              end: "1600",
              day: 5,
            },
            {
              is_overnight: false,
              start: "1700",
              end: "0000",
              day: 5,
            },
            {
              is_overnight: false,
              start: "1130",
              end: "1600",
              day: 6,
            },
            {
              is_overnight: false,
              start: "1700",
              end: "2300",
              day: 6,
            },
          ],
          hours_type: "REGULAR",
          is_open_now: true,
        },
      ],
      attributes: {
        business_temp_closed: null,
        menu_url: "https://www.wayan-nyc.com/menus/menu",
        open24_hours: null,
        waitlist_reservation: null,
      },
    },
    {
      id: "zRXMvxUX_rOliKZPpkWi_g",
      alias: "valerie-new-york",
      name: "Valerie",
      image_url:
        "https://s3-media3.fl.yelpcdn.com/bphoto/mnH5QFkSMzZgd6P5eSZvvw/o.jpg",
      is_closed: false,
      url: "https://www.yelp.com/biz/valerie-new-york?adjust_creative=FlLcWTwY94L6PQ5d-K6zjg&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=FlLcWTwY94L6PQ5d-K6zjg",
      review_count: 1116,
      categories: [
        {
          alias: "newamerican",
          title: "New American",
        },
        {
          alias: "cocktailbars",
          title: "Cocktail Bars",
        },
      ],
      rating: 4.3,
      coordinates: {
        latitude: 40.756326,
        longitude: -73.981117,
      },
      transactions: ["delivery"],
      price: "$$",
      location: {
        address1: "45 W 45th St between 5th & 6th Ave",
        address2: "",
        address3: null,
        city: "New York",
        zip_code: "10036",
        country: "US",
        state: "NY",
        display_address: [
          "45 W 45th St between 5th & 6th Ave",
          "New York, NY 10036",
        ],
      },
      phone: "+12123024545",
      display_phone: "(212) 302-4545",
      distance: 5758.012347666175,
      business_hours: [
        {
          open: [
            {
              is_overnight: false,
              start: "1130",
              end: "0000",
              day: 0,
            },
            {
              is_overnight: true,
              start: "1130",
              end: "0200",
              day: 1,
            },
            {
              is_overnight: true,
              start: "1130",
              end: "0200",
              day: 2,
            },
            {
              is_overnight: true,
              start: "1130",
              end: "0200",
              day: 3,
            },
            {
              is_overnight: true,
              start: "1130",
              end: "0200",
              day: 4,
            },
            {
              is_overnight: true,
              start: "1100",
              end: "0200",
              day: 5,
            },
            {
              is_overnight: false,
              start: "1100",
              end: "0000",
              day: 6,
            },
          ],
          hours_type: "REGULAR",
          is_open_now: true,
        },
      ],
      attributes: {
        business_temp_closed: null,
        menu_url: "https://www.valerienewyorkcity.com/menus/",
        open24_hours: null,
        waitlist_reservation: null,
      },
    },
    {
      id: "U5hCNNyJmb7f3dmC1HTzSQ",
      alias: "juniors-restaurant-new-york-9",
      name: "Junior's Restaurant",
      image_url:
        "https://s3-media2.fl.yelpcdn.com/bphoto/TYN_fNi2GDWVwE_emxX7dg/o.jpg",
      is_closed: false,
      url: "https://www.yelp.com/biz/juniors-restaurant-new-york-9?adjust_creative=FlLcWTwY94L6PQ5d-K6zjg&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=FlLcWTwY94L6PQ5d-K6zjg",
      review_count: 6444,
      categories: [
        {
          alias: "bakeries",
          title: "Bakeries",
        },
        {
          alias: "breakfast_brunch",
          title: "Breakfast & Brunch",
        },
        {
          alias: "burgers",
          title: "Burgers",
        },
      ],
      rating: 4.0,
      coordinates: {
        latitude: 40.75754728725579,
        longitude: -73.98608001118411,
      },
      transactions: ["pickup", "delivery"],
      price: "$$",
      location: {
        address1: "1515 Broadway",
        address2: "45th Street between Broadway & 8th Ave",
        address3: "",
        city: "New York",
        zip_code: "10036",
        country: "US",
        state: "NY",
        display_address: [
          "1515 Broadway",
          "45th Street between Broadway & 8th Ave",
          "New York, NY 10036",
        ],
      },
      phone: "+12123022000",
      display_phone: "(212) 302-2000",
      distance: 5823.317699660371,
      business_hours: [
        {
          open: [
            {
              is_overnight: false,
              start: "0700",
              end: "0000",
              day: 0,
            },
            {
              is_overnight: false,
              start: "0700",
              end: "0000",
              day: 1,
            },
            {
              is_overnight: false,
              start: "0700",
              end: "0000",
              day: 2,
            },
            {
              is_overnight: false,
              start: "0700",
              end: "0000",
              day: 3,
            },
            {
              is_overnight: true,
              start: "0700",
              end: "0100",
              day: 4,
            },
            {
              is_overnight: true,
              start: "0700",
              end: "0100",
              day: 5,
            },
            {
              is_overnight: false,
              start: "0700",
              end: "0000",
              day: 6,
            },
          ],
          hours_type: "REGULAR",
          is_open_now: true,
        },
      ],
      attributes: {
        business_temp_closed: null,
        menu_url:
          "http://www.juniorscheesecake.com/content/wp-content/uploads/2021/05/45th-Street-Main-Menu-5.3.21.pdf",
        open24_hours: null,
        waitlist_reservation: true,
      },
    },
    {
      id: "4yPqqJDJOQX69gC66YUDkA",
      alias: "peter-luger-brooklyn-2",
      name: "Peter Luger",
      image_url:
        "https://s3-media3.fl.yelpcdn.com/bphoto/rL7gJudmnBVLw3268m4Lcg/o.jpg",
      is_closed: false,
      url: "https://www.yelp.com/biz/peter-luger-brooklyn-2?adjust_creative=FlLcWTwY94L6PQ5d-K6zjg&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=FlLcWTwY94L6PQ5d-K6zjg",
      review_count: 7261,
      categories: [
        {
          alias: "steak",
          title: "Steakhouses",
        },
      ],
      rating: 4.0,
      coordinates: {
        latitude: 40.709945,
        longitude: -73.962478,
      },
      transactions: ["pickup"],
      price: "$$$$",
      location: {
        address1: "178 Broadway",
        address2: "",
        address3: "",
        city: "Brooklyn",
        zip_code: "11211",
        country: "US",
        state: "NY",
        display_address: ["178 Broadway", "Brooklyn, NY 11211"],
      },
      phone: "+17183877400",
      display_phone: "(718) 387-7400",
      distance: 2723.5099306751026,
      business_hours: [
        {
          open: [
            {
              is_overnight: false,
              start: "1145",
              end: "2115",
              day: 0,
            },
            {
              is_overnight: false,
              start: "1145",
              end: "2115",
              day: 1,
            },
            {
              is_overnight: false,
              start: "1145",
              end: "2115",
              day: 2,
            },
            {
              is_overnight: false,
              start: "1145",
              end: "2115",
              day: 3,
            },
            {
              is_overnight: false,
              start: "1145",
              end: "2115",
              day: 4,
            },
            {
              is_overnight: false,
              start: "1145",
              end: "2115",
              day: 5,
            },
            {
              is_overnight: false,
              start: "1145",
              end: "2115",
              day: 6,
            },
          ],
          hours_type: "REGULAR",
          is_open_now: true,
        },
      ],
      attributes: {
        business_temp_closed: null,
        menu_url: "http://peterluger.com/brooklyn-menu/",
        open24_hours: null,
        waitlist_reservation: null,
      },
    },
    {
      id: "nU4XBdvxDABXqZ6CnB8Dig",
      alias: "clinton-street-baking-company-new-york-5",
      name: "Clinton Street Baking Company",
      image_url:
        "https://s3-media3.fl.yelpcdn.com/bphoto/tqcuWVI48j9RVpKKFf37fA/o.jpg",
      is_closed: false,
      url: "https://www.yelp.com/biz/clinton-street-baking-company-new-york-5?adjust_creative=FlLcWTwY94L6PQ5d-K6zjg&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=FlLcWTwY94L6PQ5d-K6zjg",
      review_count: 5975,
      categories: [
        {
          alias: "bakeries",
          title: "Bakeries",
        },
        {
          alias: "newamerican",
          title: "New American",
        },
        {
          alias: "breakfast_brunch",
          title: "Breakfast & Brunch",
        },
      ],
      rating: 4.0,
      coordinates: {
        latitude: 40.721128,
        longitude: -73.983933,
      },
      transactions: ["pickup", "delivery"],
      price: "$$",
      location: {
        address1: "4 Clinton St",
        address2: "",
        address3: "",
        city: "New York",
        zip_code: "10002",
        country: "US",
        state: "NY",
        display_address: ["4 Clinton St", "New York, NY 10002"],
      },
      phone: "+16466026263",
      display_phone: "(646) 602-6263",
      distance: 1939.170188721576,
      business_hours: [
        {
          open: [
            {
              is_overnight: false,
              start: "0900",
              end: "1600",
              day: 0,
            },
            {
              is_overnight: false,
              start: "0900",
              end: "1600",
              day: 1,
            },
            {
              is_overnight: false,
              start: "0900",
              end: "1600",
              day: 2,
            },
            {
              is_overnight: false,
              start: "1730",
              end: "2200",
              day: 2,
            },
            {
              is_overnight: false,
              start: "0900",
              end: "1600",
              day: 3,
            },
            {
              is_overnight: false,
              start: "1730",
              end: "2200",
              day: 3,
            },
            {
              is_overnight: false,
              start: "0900",
              end: "1600",
              day: 4,
            },
            {
              is_overnight: false,
              start: "1730",
              end: "2200",
              day: 4,
            },
            {
              is_overnight: false,
              start: "0900",
              end: "1600",
              day: 5,
            },
            {
              is_overnight: false,
              start: "1730",
              end: "2200",
              day: 5,
            },
            {
              is_overnight: false,
              start: "0900",
              end: "1600",
              day: 6,
            },
          ],
          hours_type: "REGULAR",
          is_open_now: true,
        },
      ],
      attributes: {
        business_temp_closed: null,
        menu_url: "",
        open24_hours: null,
        waitlist_reservation: null,
      },
    },
    {
      id: "OCTiJwvjoK81WoDwsTkFvA",
      alias: "paesano-of-mulberry-street-new-york",
      name: "Paesano of Mulberry Street",
      image_url:
        "https://s3-media2.fl.yelpcdn.com/bphoto/yN9ARCE3LF6u9E0yN5WpIw/o.jpg",
      is_closed: false,
      url: "https://www.yelp.com/biz/paesano-of-mulberry-street-new-york?adjust_creative=FlLcWTwY94L6PQ5d-K6zjg&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=FlLcWTwY94L6PQ5d-K6zjg",
      review_count: 1625,
      categories: [
        {
          alias: "italian",
          title: "Italian",
        },
        {
          alias: "salad",
          title: "Salad",
        },
        {
          alias: "seafood",
          title: "Seafood",
        },
      ],
      rating: 4.1,
      coordinates: {
        latitude: 40.718554,
        longitude: -73.997447,
      },
      transactions: ["restaurant_reservation", "pickup", "delivery"],
      price: "$$",
      location: {
        address1: "136 Mulberry St",
        address2: "",
        address3: "",
        city: "New York",
        zip_code: "10013",
        country: "US",
        state: "NY",
        display_address: ["136 Mulberry St", "New York, NY 10013"],
      },
      phone: "+12129651188",
      display_phone: "(212) 965-1188",
      distance: 1471.1783179853867,
      business_hours: [
        {
          open: [
            {
              is_overnight: false,
              start: "1100",
              end: "2200",
              day: 0,
            },
            {
              is_overnight: false,
              start: "1100",
              end: "2200",
              day: 1,
            },
            {
              is_overnight: false,
              start: "1100",
              end: "2200",
              day: 2,
            },
            {
              is_overnight: false,
              start: "1100",
              end: "2200",
              day: 3,
            },
            {
              is_overnight: false,
              start: "1100",
              end: "2200",
              day: 4,
            },
            {
              is_overnight: false,
              start: "1100",
              end: "2200",
              day: 5,
            },
            {
              is_overnight: false,
              start: "1100",
              end: "2200",
              day: 6,
            },
          ],
          hours_type: "REGULAR",
          is_open_now: true,
        },
      ],
      attributes: {
        business_temp_closed: null,
        menu_url: null,
        open24_hours: null,
        waitlist_reservation: true,
      },
    },
    {
      id: "Sj3JYCbaEFrAqUzRrenQbg",
      alias: "jora-long-island-city-5",
      name: "Jora",
      image_url:
        "https://s3-media4.fl.yelpcdn.com/bphoto/1csyxdf-8aYdm4yO24GfwQ/o.jpg",
      is_closed: false,
      url: "https://www.yelp.com/biz/jora-long-island-city-5?adjust_creative=FlLcWTwY94L6PQ5d-K6zjg&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=FlLcWTwY94L6PQ5d-K6zjg",
      review_count: 1016,
      categories: [
        {
          alias: "peruvian",
          title: "Peruvian",
        },
        {
          alias: "cocktailbars",
          title: "Cocktail Bars",
        },
      ],
      rating: 4.3,
      coordinates: {
        latitude: 40.74378048345341,
        longitude: -73.95141330235197,
      },
      transactions: ["pickup", "delivery"],
      price: "$$$",
      location: {
        address1: "47-46 11th St",
        address2: "",
        address3: "",
        city: "Long Island City",
        zip_code: "11101",
        country: "US",
        state: "NY",
        display_address: ["47-46 11th St", "Long Island City, NY 11101"],
      },
      phone: "+17183922033",
      display_phone: "(718) 392-2033",
      distance: 5578.048459649403,
      business_hours: [
        {
          open: [
            {
              is_overnight: false,
              start: "1200",
              end: "2200",
              day: 0,
            },
            {
              is_overnight: false,
              start: "1200",
              end: "2200",
              day: 1,
            },
            {
              is_overnight: false,
              start: "1200",
              end: "2200",
              day: 2,
            },
            {
              is_overnight: false,
              start: "1200",
              end: "2200",
              day: 3,
            },
            {
              is_overnight: false,
              start: "1200",
              end: "2230",
              day: 4,
            },
            {
              is_overnight: false,
              start: "1200",
              end: "2230",
              day: 5,
            },
            {
              is_overnight: false,
              start: "1200",
              end: "2230",
              day: 6,
            },
          ],
          hours_type: "REGULAR",
          is_open_now: true,
        },
      ],
      attributes: {
        business_temp_closed: null,
        menu_url: "https://www.jorany.com/menu",
        open24_hours: null,
        waitlist_reservation: null,
      },
    },
    {
      id: "pk89jzL1RsE9U0thf_z6tw",
      alias: "locanda-verde-new-york-6",
      name: "Locanda Verde",
      image_url:
        "https://s3-media2.fl.yelpcdn.com/bphoto/kg1U5XUE7PqGuvmCP59s8g/o.jpg",
      is_closed: false,
      url: "https://www.yelp.com/biz/locanda-verde-new-york-6?adjust_creative=FlLcWTwY94L6PQ5d-K6zjg&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=FlLcWTwY94L6PQ5d-K6zjg",
      review_count: 1915,
      categories: [
        {
          alias: "italian",
          title: "Italian",
        },
        {
          alias: "cocktailbars",
          title: "Cocktail Bars",
        },
        {
          alias: "breakfast_brunch",
          title: "Breakfast & Brunch",
        },
      ],
      rating: 3.9,
      coordinates: {
        latitude: 40.7198601300801,
        longitude: -74.010039072422,
      },
      transactions: ["pickup", "delivery"],
      price: "$$$",
      location: {
        address1: "377 Greenwich St",
        address2: "",
        address3: "",
        city: "New York",
        zip_code: "10013",
        country: "US",
        state: "NY",
        display_address: ["377 Greenwich St", "New York, NY 10013"],
      },
      phone: "+12129253797",
      display_phone: "(212) 925-3797",
      distance: 2074.0278096546217,
      business_hours: [
        {
          open: [
            {
              is_overnight: false,
              start: "0700",
              end: "1500",
              day: 0,
            },
            {
              is_overnight: false,
              start: "1700",
              end: "2300",
              day: 0,
            },
            {
              is_overnight: false,
              start: "0700",
              end: "1100",
              day: 1,
            },
            {
              is_overnight: false,
              start: "1130",
              end: "1500",
              day: 1,
            },
            {
              is_overnight: false,
              start: "1700",
              end: "2300",
              day: 1,
            },
            {
              is_overnight: false,
              start: "0700",
              end: "1100",
              day: 2,
            },
            {
              is_overnight: false,
              start: "1130",
              end: "1500",
              day: 2,
            },
            {
              is_overnight: false,
              start: "1700",
              end: "2300",
              day: 2,
            },
            {
              is_overnight: false,
              start: "0700",
              end: "1100",
              day: 3,
            },
            {
              is_overnight: false,
              start: "1130",
              end: "1500",
              day: 3,
            },
            {
              is_overnight: false,
              start: "1700",
              end: "2300",
              day: 3,
            },
            {
              is_overnight: false,
              start: "0700",
              end: "1100",
              day: 4,
            },
            {
              is_overnight: false,
              start: "1130",
              end: "1500",
              day: 4,
            },
            {
              is_overnight: false,
              start: "1700",
              end: "2300",
              day: 4,
            },
            {
              is_overnight: false,
              start: "0700",
              end: "1500",
              day: 5,
            },
            {
              is_overnight: false,
              start: "1700",
              end: "2300",
              day: 5,
            },
            {
              is_overnight: false,
              start: "0700",
              end: "1500",
              day: 6,
            },
            {
              is_overnight: false,
              start: "1700",
              end: "2300",
              day: 6,
            },
          ],
          hours_type: "REGULAR",
          is_open_now: true,
        },
      ],
      attributes: {
        business_temp_closed: null,
        menu_url: "https://www.locandaverdenyc.com/tribeca/",
        open24_hours: null,
        waitlist_reservation: null,
      },
    },
    {
      id: "wx9mXol6jOrUoAK4vaFS9Q",
      alias: "mission-ceviche-upper-east-side-new-york-3",
      name: "Mission Ceviche Upper East Side",
      image_url:
        "https://s3-media3.fl.yelpcdn.com/bphoto/9224BQzxteU5uCaU6-vq4Q/o.jpg",
      is_closed: false,
      url: "https://www.yelp.com/biz/mission-ceviche-upper-east-side-new-york-3?adjust_creative=FlLcWTwY94L6PQ5d-K6zjg&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=FlLcWTwY94L6PQ5d-K6zjg",
      review_count: 1063,
      categories: [
        {
          alias: "peruvian",
          title: "Peruvian",
        },
        {
          alias: "seafood",
          title: "Seafood",
        },
        {
          alias: "cocktailbars",
          title: "Cocktail Bars",
        },
      ],
      rating: 4.4,
      coordinates: {
        latitude: 40.7692325,
        longitude: -73.9578759,
      },
      transactions: ["pickup", "delivery"],
      price: "$$$$",
      location: {
        address1: "1400 2nd Ave",
        address2: "",
        address3: null,
        city: "New York",
        zip_code: "10021",
        country: "US",
        state: "NY",
        display_address: ["1400 2nd Ave", "New York, NY 10021"],
      },
      phone: "+12126500014",
      display_phone: "(212) 650-0014",
      distance: 7703.772071685194,
      business_hours: [
        {
          open: [
            {
              is_overnight: false,
              start: "1200",
              end: "2200",
              day: 0,
            },
            {
              is_overnight: false,
              start: "1200",
              end: "2200",
              day: 1,
            },
            {
              is_overnight: false,
              start: "1200",
              end: "2200",
              day: 2,
            },
            {
              is_overnight: false,
              start: "1200",
              end: "2200",
              day: 3,
            },
            {
              is_overnight: false,
              start: "1200",
              end: "2230",
              day: 4,
            },
            {
              is_overnight: false,
              start: "1100",
              end: "2230",
              day: 5,
            },
            {
              is_overnight: false,
              start: "1100",
              end: "2200",
              day: 6,
            },
          ],
          hours_type: "REGULAR",
          is_open_now: true,
        },
      ],
      attributes: {
        business_temp_closed: null,
        menu_url: "https://missionceviche.com/menu/",
        open24_hours: null,
        waitlist_reservation: null,
      },
    },
    {
      id: "iTj5T_jPYvznd1QTgs7NZw",
      alias: "nai-new-york",
      name: "Nai ",
      image_url:
        "https://s3-media2.fl.yelpcdn.com/bphoto/YOINY6MFVayDl9v_M3RH8A/o.jpg",
      is_closed: false,
      url: "https://www.yelp.com/biz/nai-new-york?adjust_creative=FlLcWTwY94L6PQ5d-K6zjg&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=FlLcWTwY94L6PQ5d-K6zjg",
      review_count: 1132,
      categories: [
        {
          alias: "tapasmallplates",
          title: "Tapas/Small Plates",
        },
        {
          alias: "spanish",
          title: "Spanish",
        },
      ],
      rating: 4.3,
      coordinates: {
        latitude: 40.726579267369175,
        longitude: -73.9889093327649,
      },
      transactions: ["delivery"],
      price: "$$$",
      location: {
        address1: "84 2nd Ave",
        address2: null,
        address3: "",
        city: "New York",
        zip_code: "10003",
        country: "US",
        state: "NY",
        display_address: ["84 2nd Ave", "New York, NY 10003"],
      },
      phone: "+12126771030",
      display_phone: "(212) 677-1030",
      distance: 2381.998063787472,
      business_hours: [
        {
          open: [
            {
              is_overnight: false,
              start: "1700",
              end: "2300",
              day: 0,
            },
            {
              is_overnight: false,
              start: "1700",
              end: "2300",
              day: 1,
            },
            {
              is_overnight: false,
              start: "1700",
              end: "2300",
              day: 2,
            },
            {
              is_overnight: false,
              start: "1700",
              end: "2300",
              day: 3,
            },
            {
              is_overnight: false,
              start: "1700",
              end: "2330",
              day: 4,
            },
            {
              is_overnight: false,
              start: "1200",
              end: "2330",
              day: 5,
            },
            {
              is_overnight: false,
              start: "1200",
              end: "2200",
              day: 6,
            },
          ],
          hours_type: "REGULAR",
          is_open_now: true,
        },
      ],
      attributes: {
        business_temp_closed: null,
        menu_url:
          "https://www.nairestaurant.com/_files/ugd/08fd8b_89b5e3f36b394d8ba5ebca470d396a5d.pdf",
        open24_hours: null,
        waitlist_reservation: null,
      },
    },
    {
      id: "RfxOtJ4SQmEeVX_XjFLWUQ",
      alias: "otis-brooklyn-2",
      name: "Otis",
      image_url:
        "https://s3-media4.fl.yelpcdn.com/bphoto/rC5FzcJOLElAgQvWAcKi9w/o.jpg",
      is_closed: false,
      url: "https://www.yelp.com/biz/otis-brooklyn-2?adjust_creative=FlLcWTwY94L6PQ5d-K6zjg&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=FlLcWTwY94L6PQ5d-K6zjg",
      review_count: 583,
      categories: [
        {
          alias: "newamerican",
          title: "New American",
        },
        {
          alias: "cocktailbars",
          title: "Cocktail Bars",
        },
      ],
      rating: 4.7,
      coordinates: {
        latitude: 40.706011,
        longitude: -73.932598,
      },
      transactions: ["pickup", "delivery"],
      price: "$$$",
      location: {
        address1: "18 Harrison Pl",
        address2: null,
        address3: "",
        city: "Brooklyn",
        zip_code: "11206",
        country: "US",
        state: "NY",
        display_address: ["18 Harrison Pl", "Brooklyn, NY 11206"],
      },
      phone: "+16468860601",
      display_phone: "(646) 886-0601",
      distance: 5198.230452860656,
      business_hours: [
        {
          open: [
            {
              is_overnight: false,
              start: "1800",
              end: "2300",
              day: 1,
            },
            {
              is_overnight: false,
              start: "1800",
              end: "2300",
              day: 2,
            },
            {
              is_overnight: false,
              start: "1800",
              end: "2300",
              day: 3,
            },
            {
              is_overnight: false,
              start: "1800",
              end: "0000",
              day: 4,
            },
            {
              is_overnight: false,
              start: "1800",
              end: "0000",
              day: 5,
            },
            {
              is_overnight: false,
              start: "1800",
              end: "2300",
              day: 6,
            },
          ],
          hours_type: "REGULAR",
          is_open_now: true,
        },
      ],
      attributes: {
        business_temp_closed: null,
        menu_url: "https://www.otisbk.com/menu-hours",
        open24_hours: null,
        waitlist_reservation: null,
      },
    },
    {
      id: "bZQryeTD6hIsT6lSUxzSSw",
      alias: "hanoi-house-new-york",
      name: "Hanoi House",
      image_url:
        "https://s3-media4.fl.yelpcdn.com/bphoto/AG6DrZBWHPi0IP-mzHYSJA/o.jpg",
      is_closed: false,
      url: "https://www.yelp.com/biz/hanoi-house-new-york?adjust_creative=FlLcWTwY94L6PQ5d-K6zjg&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=FlLcWTwY94L6PQ5d-K6zjg",
      review_count: 801,
      categories: [
        {
          alias: "vietnamese",
          title: "Vietnamese",
        },
      ],
      rating: 4.3,
      coordinates: {
        latitude: 40.727066,
        longitude: -73.983505,
      },
      transactions: [],
      price: "$$",
      location: {
        address1: "119 Saint Marks Pl",
        address2: "",
        address3: null,
        city: "New York",
        zip_code: "10009",
        country: "US",
        state: "NY",
        display_address: ["119 Saint Marks Pl", "New York, NY 10009"],
      },
      phone: "+12129955010",
      display_phone: "(212) 995-5010",
      distance: 2559.975200712584,
      business_hours: [
        {
          open: [
            {
              is_overnight: false,
              start: "1730",
              end: "2130",
              day: 1,
            },
            {
              is_overnight: false,
              start: "1730",
              end: "2130",
              day: 2,
            },
            {
              is_overnight: false,
              start: "1730",
              end: "2130",
              day: 3,
            },
            {
              is_overnight: false,
              start: "1730",
              end: "2230",
              day: 4,
            },
            {
              is_overnight: false,
              start: "1130",
              end: "1500",
              day: 5,
            },
            {
              is_overnight: false,
              start: "1730",
              end: "2230",
              day: 5,
            },
            {
              is_overnight: false,
              start: "1130",
              end: "1500",
              day: 6,
            },
            {
              is_overnight: false,
              start: "1730",
              end: "2100",
              day: 6,
            },
          ],
          hours_type: "REGULAR",
          is_open_now: true,
        },
      ],
      attributes: {
        business_temp_closed: null,
        menu_url: null,
        open24_hours: null,
        waitlist_reservation: null,
      },
    },
    {
      id: "xKIv_b2L2pUHmsoJ-xOepg",
      alias: "gran-morsi-new-york",
      name: "Gran Morsi",
      image_url:
        "https://s3-media3.fl.yelpcdn.com/bphoto/GpR9eqovfF0zHQ6BgnbvcA/o.jpg",
      is_closed: false,
      url: "https://www.yelp.com/biz/gran-morsi-new-york?adjust_creative=FlLcWTwY94L6PQ5d-K6zjg&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=FlLcWTwY94L6PQ5d-K6zjg",
      review_count: 558,
      categories: [
        {
          alias: "italian",
          title: "Italian",
        },
        {
          alias: "venues",
          title: "Venues & Event Spaces",
        },
        {
          alias: "cocktailbars",
          title: "Cocktail Bars",
        },
      ],
      rating: 4.4,
      coordinates: {
        latitude: 40.714312,
        longitude: -74.007791,
      },
      transactions: ["pickup", "delivery"],
      price: "$$$",
      location: {
        address1: "22 Warren St",
        address2: "",
        address3: null,
        city: "New York",
        zip_code: "10007",
        country: "US",
        state: "NY",
        display_address: ["22 Warren St", "New York, NY 10007"],
      },
      phone: "+12125772725",
      display_phone: "(212) 577-2725",
      distance: 1499.3090266168608,
      business_hours: [
        {
          open: [
            {
              is_overnight: false,
              start: "1600",
              end: "2230",
              day: 0,
            },
            {
              is_overnight: false,
              start: "1600",
              end: "2230",
              day: 1,
            },
            {
              is_overnight: false,
              start: "1600",
              end: "2230",
              day: 2,
            },
            {
              is_overnight: false,
              start: "1600",
              end: "2230",
              day: 3,
            },
            {
              is_overnight: false,
              start: "1600",
              end: "2230",
              day: 4,
            },
            {
              is_overnight: false,
              start: "1700",
              end: "2230",
              day: 5,
            },
            {
              is_overnight: false,
              start: "1700",
              end: "2230",
              day: 6,
            },
          ],
          hours_type: "REGULAR",
          is_open_now: true,
        },
      ],
      attributes: {
        business_temp_closed: null,
        menu_url: "http://www.granmorsi.com/menu",
        open24_hours: null,
        waitlist_reservation: null,
      },
    },
    {
      id: "xZ96vaoL-cQjfotmUKtjJQ",
      alias: "barn-joo-35-new-york",
      name: "Barn Joo 35",
      image_url:
        "https://s3-media1.fl.yelpcdn.com/bphoto/R2On3eNr3a2MjgtrTCp0pA/o.jpg",
      is_closed: false,
      url: "https://www.yelp.com/biz/barn-joo-35-new-york?adjust_creative=FlLcWTwY94L6PQ5d-K6zjg&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=FlLcWTwY94L6PQ5d-K6zjg",
      review_count: 2515,
      categories: [
        {
          alias: "korean",
          title: "Korean",
        },
        {
          alias: "gastropubs",
          title: "Gastropubs",
        },
        {
          alias: "tapasmallplates",
          title: "Tapas/Small Plates",
        },
      ],
      rating: 4.2,
      coordinates: {
        latitude: 40.74964,
        longitude: -73.98582,
      },
      transactions: ["pickup", "delivery"],
      price: "$$",
      location: {
        address1: "34 W 35th St",
        address2: "",
        address3: "",
        city: "New York",
        zip_code: "10001",
        country: "US",
        state: "NY",
        display_address: ["34 W 35th St", "New York, NY 10001"],
      },
      phone: "+12125644430",
      display_phone: "(212) 564-4430",
      distance: 4957.058995250786,
      business_hours: [
        {
          open: [
            {
              is_overnight: false,
              start: "1200",
              end: "2200",
              day: 0,
            },
            {
              is_overnight: false,
              start: "1200",
              end: "2200",
              day: 1,
            },
            {
              is_overnight: false,
              start: "1200",
              end: "2200",
              day: 2,
            },
            {
              is_overnight: false,
              start: "1200",
              end: "2300",
              day: 3,
            },
            {
              is_overnight: false,
              start: "1200",
              end: "2300",
              day: 4,
            },
            {
              is_overnight: false,
              start: "1200",
              end: "2300",
              day: 5,
            },
            {
              is_overnight: false,
              start: "1200",
              end: "2200",
              day: 6,
            },
          ],
          hours_type: "REGULAR",
          is_open_now: true,
        },
      ],
      attributes: {
        business_temp_closed: null,
        menu_url:
          "https://www.barnjoo.com/_files/ugd/5295e1_718f47d506344d429567e7d8de8bdf9e.pdf",
        open24_hours: null,
        waitlist_reservation: true,
      },
    },
    {
      id: "Xk3BVvlX-KXh6kJhbClMKw",
      alias: "the-flatiron-room-murray-hill-new-york",
      name: "The Flatiron Room Murray Hill",
      image_url:
        "https://s3-media3.fl.yelpcdn.com/bphoto/EW77wCFMXEJ-HyVrFBjhfQ/o.jpg",
      is_closed: false,
      url: "https://www.yelp.com/biz/the-flatiron-room-murray-hill-new-york?adjust_creative=FlLcWTwY94L6PQ5d-K6zjg&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=FlLcWTwY94L6PQ5d-K6zjg",
      review_count: 570,
      categories: [
        {
          alias: "newamerican",
          title: "New American",
        },
        {
          alias: "jazzandblues",
          title: "Jazz & Blues",
        },
        {
          alias: "lounges",
          title: "Lounges",
        },
      ],
      rating: 4.3,
      coordinates: {
        latitude: 40.750165,
        longitude: -73.98221,
      },
      transactions: ["pickup", "delivery"],
      price: "$$$",
      location: {
        address1: "9 E 37th St",
        address2: null,
        address3: "",
        city: "New York",
        zip_code: "10016",
        country: "US",
        state: "NY",
        display_address: ["9 E 37th St", "New York, NY 10016"],
      },
      phone: "+12127253866",
      display_phone: "(212) 725-3866",
      distance: 5066.590719106051,
      business_hours: [
        {
          open: [
            {
              is_overnight: false,
              start: "1700",
              end: "0000",
              day: 0,
            },
            {
              is_overnight: false,
              start: "1700",
              end: "0000",
              day: 1,
            },
            {
              is_overnight: false,
              start: "1700",
              end: "0000",
              day: 2,
            },
            {
              is_overnight: true,
              start: "1700",
              end: "0200",
              day: 3,
            },
            {
              is_overnight: true,
              start: "1700",
              end: "0200",
              day: 4,
            },
            {
              is_overnight: true,
              start: "1700",
              end: "0200",
              day: 5,
            },
            {
              is_overnight: false,
              start: "1700",
              end: "0000",
              day: 6,
            },
          ],
          hours_type: "REGULAR",
          is_open_now: true,
        },
      ],
      attributes: {
        business_temp_closed: null,
        menu_url: "https://www.theflatironroom.com/murray-hill-food-menu/",
        open24_hours: null,
        waitlist_reservation: null,
      },
    },
    {
      id: "QhE50zhSMnQaudpHW1jp7g",
      alias: "the-tyger-new-york-2",
      name: "The Tyger",
      image_url:
        "https://s3-media4.fl.yelpcdn.com/bphoto/RRg_UV8qR5FRcyWl9V-cfA/o.jpg",
      is_closed: false,
      url: "https://www.yelp.com/biz/the-tyger-new-york-2?adjust_creative=FlLcWTwY94L6PQ5d-K6zjg&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=FlLcWTwY94L6PQ5d-K6zjg",
      review_count: 538,
      categories: [
        {
          alias: "cocktailbars",
          title: "Cocktail Bars",
        },
        {
          alias: "noodles",
          title: "Noodles",
        },
        {
          alias: "panasian",
          title: "Pan Asian",
        },
      ],
      rating: 4.2,
      coordinates: {
        latitude: 40.7189,
        longitude: -73.99942,
      },
      transactions: ["pickup", "delivery"],
      price: "$$$",
      location: {
        address1: "1 Howard St",
        address2: null,
        address3: null,
        city: "New York",
        zip_code: "10013",
        country: "US",
        state: "NY",
        display_address: ["1 Howard St", "New York, NY 10013"],
      },
      phone: "+16463558693",
      display_phone: "(646) 355-8693",
      distance: 1545.9894211008036,
      business_hours: [
        {
          open: [
            {
              is_overnight: false,
              start: "1700",
              end: "2300",
              day: 0,
            },
            {
              is_overnight: false,
              start: "1700",
              end: "2300",
              day: 1,
            },
            {
              is_overnight: false,
              start: "1700",
              end: "2300",
              day: 2,
            },
            {
              is_overnight: false,
              start: "1700",
              end: "2330",
              day: 3,
            },
            {
              is_overnight: false,
              start: "1700",
              end: "2330",
              day: 4,
            },
            {
              is_overnight: false,
              start: "1700",
              end: "2330",
              day: 5,
            },
            {
              is_overnight: false,
              start: "1700",
              end: "2300",
              day: 6,
            },
          ],
          hours_type: "REGULAR",
          is_open_now: true,
        },
      ],
      attributes: {
        business_temp_closed: null,
        menu_url: "http://www.thetygernyc.com/dinnermenu",
        open24_hours: null,
        waitlist_reservation: null,
      },
    },
    {
      id: "-Gc5sTFxoXM3Tiv_dkSJZg",
      alias: "cecconis-dumbo-brooklyn",
      name: "Cecconi's Dumbo",
      image_url:
        "https://s3-media2.fl.yelpcdn.com/bphoto/wLkTt8QVE6awOocmAW194A/o.jpg",
      is_closed: false,
      url: "https://www.yelp.com/biz/cecconis-dumbo-brooklyn?adjust_creative=FlLcWTwY94L6PQ5d-K6zjg&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=FlLcWTwY94L6PQ5d-K6zjg",
      review_count: 1192,
      categories: [
        {
          alias: "italian",
          title: "Italian",
        },
      ],
      rating: 3.5,
      coordinates: {
        latitude: 40.703851696718694,
        longitude: -73.99146477492025,
      },
      transactions: ["delivery"],
      price: "$$$",
      location: {
        address1: "55 Water St",
        address2: "",
        address3: null,
        city: "Brooklyn",
        zip_code: "11201",
        country: "US",
        state: "NY",
        display_address: ["55 Water St", "Brooklyn, NY 11201"],
      },
      phone: "+17186503900",
      display_phone: "(718) 650-3900",
      distance: 301.85186918146724,
      business_hours: [
        {
          open: [
            {
              is_overnight: false,
              start: "1200",
              end: "2300",
              day: 0,
            },
            {
              is_overnight: false,
              start: "1200",
              end: "2300",
              day: 1,
            },
            {
              is_overnight: false,
              start: "1200",
              end: "2300",
              day: 2,
            },
            {
              is_overnight: false,
              start: "1200",
              end: "2300",
              day: 3,
            },
            {
              is_overnight: false,
              start: "1200",
              end: "2300",
              day: 4,
            },
            {
              is_overnight: false,
              start: "1200",
              end: "2300",
              day: 5,
            },
            {
              is_overnight: false,
              start: "1200",
              end: "2300",
              day: 6,
            },
          ],
          hours_type: "REGULAR",
          is_open_now: true,
        },
      ],
      attributes: {
        business_temp_closed: null,
        menu_url: "http://cecconisdumbo.com/#menus",
        open24_hours: null,
        waitlist_reservation: null,
      },
    },
    {
      id: "CuwHhq1MKX5hm8YyxtqukQ",
      alias: "shukette-new-york",
      name: "Shukette",
      image_url:
        "https://s3-media2.fl.yelpcdn.com/bphoto/2QlGekOdWWrkmAKVfVPbnw/o.jpg",
      is_closed: false,
      url: "https://www.yelp.com/biz/shukette-new-york?adjust_creative=FlLcWTwY94L6PQ5d-K6zjg&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=FlLcWTwY94L6PQ5d-K6zjg",
      review_count: 525,
      categories: [
        {
          alias: "mideastern",
          title: "Middle Eastern",
        },
      ],
      rating: 4.4,
      coordinates: {
        latitude: 40.74745,
        longitude: -74.00041,
      },
      transactions: ["delivery"],
      price: "$$$$",
      location: {
        address1: "230 9th Ave",
        address2: "",
        address3: null,
        city: "New York",
        zip_code: "10001",
        country: "US",
        state: "NY",
        display_address: ["230 9th Ave", "New York, NY 10001"],
      },
      phone: "+12122421803",
      display_phone: "(212) 242-1803",
      distance: 4688.284628063795,
      business_hours: [
        {
          open: [
            {
              is_overnight: false,
              start: "1700",
              end: "2300",
              day: 0,
            },
            {
              is_overnight: false,
              start: "1700",
              end: "2300",
              day: 1,
            },
            {
              is_overnight: false,
              start: "1700",
              end: "2300",
              day: 2,
            },
            {
              is_overnight: false,
              start: "1700",
              end: "2300",
              day: 3,
            },
            {
              is_overnight: false,
              start: "1700",
              end: "2300",
              day: 4,
            },
            {
              is_overnight: false,
              start: "1700",
              end: "2300",
              day: 5,
            },
            {
              is_overnight: false,
              start: "1600",
              end: "2200",
              day: 6,
            },
          ],
          hours_type: "REGULAR",
          is_open_now: true,
        },
      ],
      attributes: {
        business_temp_closed: null,
        menu_url: "https://shukette.shop/menu",
        open24_hours: null,
        waitlist_reservation: null,
      },
    },
    {
      id: "_EBQhV-UQ7NoV66uXYH0dw",
      alias: "golden-diner-new-york-2",
      name: "Golden Diner",
      image_url:
        "https://s3-media4.fl.yelpcdn.com/bphoto/5c1hox9kAg_XzXFMAOqwZQ/o.jpg",
      is_closed: false,
      url: "https://www.yelp.com/biz/golden-diner-new-york-2?adjust_creative=FlLcWTwY94L6PQ5d-K6zjg&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=FlLcWTwY94L6PQ5d-K6zjg",
      review_count: 784,
      categories: [
        {
          alias: "diners",
          title: "Diners",
        },
        {
          alias: "breakfast_brunch",
          title: "Breakfast & Brunch",
        },
        {
          alias: "sandwiches",
          title: "Sandwiches",
        },
      ],
      rating: 4.3,
      coordinates: {
        latitude: 40.71244,
        longitude: -73.994,
      },
      transactions: ["pickup", "delivery"],
      price: "$$",
      location: {
        address1: "123 Madison St",
        address2: "",
        address3: null,
        city: "New York",
        zip_code: "10002",
        country: "US",
        state: "NY",
        display_address: ["123 Madison St", "New York, NY 10002"],
      },
      phone: "+19174727800",
      display_phone: "(917) 472-7800",
      distance: 764.0858435637925,
      business_hours: [
        {
          open: [
            {
              is_overnight: false,
              start: "1000",
              end: "2200",
              day: 0,
            },
            {
              is_overnight: false,
              start: "1000",
              end: "2200",
              day: 1,
            },
            {
              is_overnight: false,
              start: "1000",
              end: "2200",
              day: 2,
            },
            {
              is_overnight: false,
              start: "1000",
              end: "2200",
              day: 3,
            },
            {
              is_overnight: false,
              start: "1000",
              end: "2200",
              day: 4,
            },
            {
              is_overnight: false,
              start: "1000",
              end: "2200",
              day: 5,
            },
            {
              is_overnight: false,
              start: "1000",
              end: "2200",
              day: 6,
            },
          ],
          hours_type: "REGULAR",
          is_open_now: true,
        },
      ],
      attributes: {
        business_temp_closed: null,
        menu_url: "https://www.goldendinerny.com/menu",
        open24_hours: null,
        waitlist_reservation: false,
      },
    },
    {
      id: "BPZfuPvSxCfoppU4lPFm0Q",
      alias: "domodomo-new-york-new-york-4",
      name: "DOMODOMO - New York",
      image_url:
        "https://s3-media1.fl.yelpcdn.com/bphoto/YX89PDM_-aBCL2USyNyhuw/o.jpg",
      is_closed: false,
      url: "https://www.yelp.com/biz/domodomo-new-york-new-york-4?adjust_creative=FlLcWTwY94L6PQ5d-K6zjg&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=FlLcWTwY94L6PQ5d-K6zjg",
      review_count: 1664,
      categories: [
        {
          alias: "japanese",
          title: "Japanese",
        },
        {
          alias: "sushi",
          title: "Sushi Bars",
        },
      ],
      rating: 4.2,
      coordinates: {
        latitude: 40.7280299,
        longitude: -74.00167,
      },
      transactions: ["delivery"],
      price: "$$$",
      location: {
        address1: "140 W Houston St",
        address2: null,
        address3: "",
        city: "New York",
        zip_code: "10012",
        country: "US",
        state: "NY",
        display_address: ["140 W Houston St", "New York, NY 10012"],
      },
      phone: "+16467070301",
      display_phone: "(646) 707-0301",
      distance: 2574.0443002043376,
      business_hours: [
        {
          open: [
            {
              is_overnight: false,
              start: "1200",
              end: "1430",
              day: 0,
            },
            {
              is_overnight: false,
              start: "1700",
              end: "2100",
              day: 0,
            },
            {
              is_overnight: false,
              start: "1200",
              end: "1430",
              day: 1,
            },
            {
              is_overnight: false,
              start: "1700",
              end: "2100",
              day: 1,
            },
            {
              is_overnight: false,
              start: "1200",
              end: "1430",
              day: 2,
            },
            {
              is_overnight: false,
              start: "1700",
              end: "2100",
              day: 2,
            },
            {
              is_overnight: false,
              start: "1200",
              end: "1430",
              day: 3,
            },
            {
              is_overnight: false,
              start: "1700",
              end: "2115",
              day: 3,
            },
            {
              is_overnight: false,
              start: "1200",
              end: "1430",
              day: 4,
            },
            {
              is_overnight: false,
              start: "1700",
              end: "2200",
              day: 4,
            },
            {
              is_overnight: false,
              start: "1200",
              end: "1500",
              day: 5,
            },
            {
              is_overnight: false,
              start: "1700",
              end: "2200",
              day: 5,
            },
            {
              is_overnight: false,
              start: "1200",
              end: "1430",
              day: 6,
            },
            {
              is_overnight: false,
              start: "1700",
              end: "2100",
              day: 6,
            },
          ],
          hours_type: "REGULAR",
          is_open_now: true,
        },
      ],
      attributes: {
        business_temp_closed: null,
        menu_url: "http://www.domodomonyc.com/",
        open24_hours: null,
        waitlist_reservation: null,
      },
    },
    {
      id: "X8yEmEDD9ZTkHoIRFqzcRw",
      alias: "osamil-new-york",
      name: "Osamil",
      image_url:
        "https://s3-media2.fl.yelpcdn.com/bphoto/H6vmivma_q2fk_Vfbo9ZVA/o.jpg",
      is_closed: false,
      url: "https://www.yelp.com/biz/osamil-new-york?adjust_creative=FlLcWTwY94L6PQ5d-K6zjg&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=FlLcWTwY94L6PQ5d-K6zjg",
      review_count: 832,
      categories: [
        {
          alias: "korean",
          title: "Korean",
        },
        {
          alias: "gastropubs",
          title: "Gastropubs",
        },
        {
          alias: "tapasmallplates",
          title: "Tapas/Small Plates",
        },
      ],
      rating: 4.3,
      coordinates: {
        latitude: 40.74697,
        longitude: -73.9864,
      },
      transactions: ["delivery"],
      price: "$$$",
      location: {
        address1: "5 West 31st St",
        address2: null,
        address3: "",
        city: "New York",
        zip_code: "10001",
        country: "US",
        state: "NY",
        display_address: ["5 West 31st St", "New York, NY 10001"],
      },
      phone: "+12123004713",
      display_phone: "(212) 300-4713",
      distance: 4654.084936114401,
      business_hours: [
        {
          open: [
            {
              is_overnight: false,
              start: "1700",
              end: "2300",
              day: 0,
            },
            {
              is_overnight: false,
              start: "1700",
              end: "2300",
              day: 1,
            },
            {
              is_overnight: false,
              start: "1700",
              end: "2300",
              day: 2,
            },
            {
              is_overnight: true,
              start: "1700",
              end: "0100",
              day: 3,
            },
            {
              is_overnight: true,
              start: "1700",
              end: "0200",
              day: 4,
            },
            {
              is_overnight: true,
              start: "1700",
              end: "0200",
              day: 5,
            },
            {
              is_overnight: false,
              start: "1700",
              end: "2300",
              day: 6,
            },
          ],
          hours_type: "REGULAR",
          is_open_now: true,
        },
      ],
      attributes: {
        business_temp_closed: null,
        menu_url: "https://www.osamil.com/menu",
        open24_hours: null,
        waitlist_reservation: null,
      },
    },
    {
      id: "R7EGjHWw0tNheY6-ahH8fQ",
      alias: "tuome-new-york-2",
      name: "Tuome",
      image_url:
        "https://s3-media2.fl.yelpcdn.com/bphoto/sYllty7lVrry8871hOuq0w/o.jpg",
      is_closed: false,
      url: "https://www.yelp.com/biz/tuome-new-york-2?adjust_creative=FlLcWTwY94L6PQ5d-K6zjg&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=FlLcWTwY94L6PQ5d-K6zjg",
      review_count: 723,
      categories: [
        {
          alias: "newamerican",
          title: "New American",
        },
        {
          alias: "asianfusion",
          title: "Asian Fusion",
        },
      ],
      rating: 4.3,
      coordinates: {
        latitude: 40.72412482724,
        longitude: -73.9828906263924,
      },
      transactions: ["delivery"],
      price: "$$$$",
      location: {
        address1: "536 E 5th St",
        address2: "",
        address3: null,
        city: "New York",
        zip_code: "10009",
        country: "US",
        state: "NY",
        display_address: ["536 E 5th St", "New York, NY 10009"],
      },
      phone: "+16468337811",
      display_phone: "(646) 833-7811",
      distance: 2277.472127875525,
      business_hours: [
        {
          open: [
            {
              is_overnight: false,
              start: "1800",
              end: "2100",
              day: 1,
            },
            {
              is_overnight: false,
              start: "1800",
              end: "2100",
              day: 2,
            },
            {
              is_overnight: false,
              start: "1800",
              end: "2100",
              day: 3,
            },
            {
              is_overnight: false,
              start: "1700",
              end: "2130",
              day: 4,
            },
            {
              is_overnight: false,
              start: "1700",
              end: "2130",
              day: 5,
            },
          ],
          hours_type: "REGULAR",
          is_open_now: true,
        },
      ],
      attributes: {
        business_temp_closed: null,
        menu_url: "",
        open24_hours: null,
        waitlist_reservation: null,
      },
    },
    {
      id: "fVsH6QIJPzXpVbgmeiolsA",
      alias: "jungsik-new-york",
      name: "Jungsik",
      image_url:
        "https://s3-media1.fl.yelpcdn.com/bphoto/O7GWZ_aclOrZiHZnPkWQaA/o.jpg",
      is_closed: false,
      url: "https://www.yelp.com/biz/jungsik-new-york?adjust_creative=FlLcWTwY94L6PQ5d-K6zjg&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=FlLcWTwY94L6PQ5d-K6zjg",
      review_count: 796,
      categories: [
        {
          alias: "korean",
          title: "Korean",
        },
      ],
      rating: 4.6,
      coordinates: {
        latitude: 40.7188032533572,
        longitude: -74.0090829725856,
      },
      transactions: [],
      price: "$$$$",
      location: {
        address1: "2 Harrison St",
        address2: "",
        address3: "",
        city: "New York",
        zip_code: "10013",
        country: "US",
        state: "NY",
        display_address: ["2 Harrison St", "New York, NY 10013"],
      },
      phone: "+12122190900",
      display_phone: "(212) 219-0900",
      distance: 1932.2276428730465,
      business_hours: [
        {
          open: [
            {
              is_overnight: false,
              start: "1700",
              end: "2100",
              day: 0,
            },
            {
              is_overnight: false,
              start: "1700",
              end: "2100",
              day: 1,
            },
            {
              is_overnight: false,
              start: "1700",
              end: "2100",
              day: 2,
            },
            {
              is_overnight: false,
              start: "1700",
              end: "2100",
              day: 3,
            },
            {
              is_overnight: false,
              start: "1700",
              end: "2100",
              day: 4,
            },
            {
              is_overnight: false,
              start: "1700",
              end: "2100",
              day: 5,
            },
            {
              is_overnight: false,
              start: "1700",
              end: "2100",
              day: 6,
            },
          ],
          hours_type: "REGULAR",
          is_open_now: false,
        },
      ],
      attributes: {
        business_temp_closed: null,
        menu_url: "http://jungsik.com/eat/",
        open24_hours: null,
        waitlist_reservation: null,
      },
    },
    {
      id: "28CNHYULci66pJAz-0_pOg",
      alias: "cote-korean-steakhouse-new-york",
      name: "COTE Korean Steakhouse",
      image_url:
        "https://s3-media3.fl.yelpcdn.com/bphoto/6JYXhn0Jad6jHihGavPU9A/o.jpg",
      is_closed: false,
      url: "https://www.yelp.com/biz/cote-korean-steakhouse-new-york?adjust_creative=FlLcWTwY94L6PQ5d-K6zjg&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=FlLcWTwY94L6PQ5d-K6zjg",
      review_count: 1943,
      categories: [
        {
          alias: "korean",
          title: "Korean",
        },
        {
          alias: "steak",
          title: "Steakhouses",
        },
        {
          alias: "cocktailbars",
          title: "Cocktail Bars",
        },
      ],
      rating: 4.2,
      coordinates: {
        latitude: 40.741046,
        longitude: -73.991421,
      },
      transactions: ["delivery"],
      price: "$$$$",
      location: {
        address1: "16 W 22nd St",
        address2: "",
        address3: null,
        city: "New York",
        zip_code: "10010",
        country: "US",
        state: "NY",
        display_address: ["16 W 22nd St", "New York, NY 10010"],
      },
      phone: "+12124017986",
      display_phone: "(212) 401-7986",
      distance: 3954.7532631780564,
      business_hours: [
        {
          open: [
            {
              is_overnight: false,
              start: "1700",
              end: "2300",
              day: 0,
            },
            {
              is_overnight: false,
              start: "1700",
              end: "2300",
              day: 1,
            },
            {
              is_overnight: false,
              start: "1700",
              end: "2300",
              day: 2,
            },
            {
              is_overnight: false,
              start: "1700",
              end: "2300",
              day: 3,
            },
            {
              is_overnight: false,
              start: "1700",
              end: "2300",
              day: 4,
            },
            {
              is_overnight: false,
              start: "1700",
              end: "2300",
              day: 5,
            },
            {
              is_overnight: false,
              start: "1700",
              end: "2300",
              day: 6,
            },
          ],
          hours_type: "REGULAR",
          is_open_now: true,
        },
      ],
      attributes: {
        business_temp_closed: null,
        menu_url:
          "https://cdn.sanity.io/files/ynn6kpu5/nyc/bcf65535b4589717d1f04dbf16ed1f1eb5c6f4d5.pdf",
        open24_hours: null,
        waitlist_reservation: null,
      },
    },
    {
      id: "hk3ohp_A4L4UgWTexDxf_Q",
      alias: "gallaghers-steakhouse-new-york",
      name: "Gallaghers Steakhouse",
      image_url:
        "https://s3-media4.fl.yelpcdn.com/bphoto/Z1ugGF9xFFF6Kjq-h7WQjw/o.jpg",
      is_closed: false,
      url: "https://www.yelp.com/biz/gallaghers-steakhouse-new-york?adjust_creative=FlLcWTwY94L6PQ5d-K6zjg&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=FlLcWTwY94L6PQ5d-K6zjg",
      review_count: 2019,
      categories: [
        {
          alias: "steak",
          title: "Steakhouses",
        },
        {
          alias: "seafood",
          title: "Seafood",
        },
        {
          alias: "tradamerican",
          title: "American",
        },
      ],
      rating: 4.2,
      coordinates: {
        latitude: 40.762876,
        longitude: -73.983837,
      },
      transactions: ["pickup", "delivery"],
      price: "$$$$",
      location: {
        address1: "228 W 52nd St",
        address2: null,
        address3: "",
        city: "New York",
        zip_code: "10019",
        country: "US",
        state: "NY",
        display_address: ["228 W 52nd St", "New York, NY 10019"],
      },
      phone: "+12125865000",
      display_phone: "(212) 586-5000",
      distance: 6435.1215228684405,
      business_hours: [
        {
          open: [
            {
              is_overnight: false,
              start: "1145",
              end: "2200",
              day: 0,
            },
            {
              is_overnight: false,
              start: "1145",
              end: "2200",
              day: 1,
            },
            {
              is_overnight: false,
              start: "1145",
              end: "2200",
              day: 2,
            },
            {
              is_overnight: false,
              start: "1145",
              end: "2200",
              day: 3,
            },
            {
              is_overnight: false,
              start: "1145",
              end: "2300",
              day: 4,
            },
            {
              is_overnight: false,
              start: "1145",
              end: "2300",
              day: 5,
            },
            {
              is_overnight: false,
              start: "1145",
              end: "2200",
              day: 6,
            },
          ],
          hours_type: "REGULAR",
          is_open_now: true,
        },
      ],
      attributes: {
        business_temp_closed: null,
        menu_url: "https://www.gallaghersnysteakhouse.com/menu.php",
        open24_hours: null,
        waitlist_reservation: null,
      },
    },
    {
      id: "egDEaHpDumYHzRUZ8JBU-w",
      alias: "pranakhon-thai-restaurant-new-york-2",
      name: "Pranakhon Thai Restaurant",
      image_url:
        "https://s3-media1.fl.yelpcdn.com/bphoto/zTa3XlrmtyzEZi0hKjzPew/o.jpg",
      is_closed: false,
      url: "https://www.yelp.com/biz/pranakhon-thai-restaurant-new-york-2?adjust_creative=FlLcWTwY94L6PQ5d-K6zjg&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=FlLcWTwY94L6PQ5d-K6zjg",
      review_count: 545,
      categories: [
        {
          alias: "thai",
          title: "Thai",
        },
        {
          alias: "salad",
          title: "Salad",
        },
        {
          alias: "noodles",
          title: "Noodles",
        },
      ],
      rating: 4.5,
      coordinates: {
        latitude: 40.73369,
        longitude: -73.99316,
      },
      transactions: ["pickup", "delivery"],
      price: "$$",
      location: {
        address1: "88 University Pl",
        address2: null,
        address3: "",
        city: "New York",
        zip_code: "10003",
        country: "US",
        state: "NY",
        display_address: ["88 University Pl", "New York, NY 10003"],
      },
      phone: "+12127866789",
      display_phone: "(212) 786-6789",
      distance: 3133.170716842546,
      business_hours: [
        {
          open: [
            {
              is_overnight: false,
              start: "1130",
              end: "1515",
              day: 0,
            },
            {
              is_overnight: false,
              start: "1630",
              end: "2200",
              day: 0,
            },
            {
              is_overnight: false,
              start: "1130",
              end: "1515",
              day: 1,
            },
            {
              is_overnight: false,
              start: "1630",
              end: "2200",
              day: 1,
            },
            {
              is_overnight: false,
              start: "1130",
              end: "1515",
              day: 2,
            },
            {
              is_overnight: false,
              start: "1630",
              end: "2200",
              day: 2,
            },
            {
              is_overnight: false,
              start: "1130",
              end: "1515",
              day: 3,
            },
            {
              is_overnight: false,
              start: "1630",
              end: "2200",
              day: 3,
            },
            {
              is_overnight: false,
              start: "1130",
              end: "1515",
              day: 4,
            },
            {
              is_overnight: false,
              start: "1630",
              end: "2230",
              day: 4,
            },
            {
              is_overnight: false,
              start: "1130",
              end: "1515",
              day: 5,
            },
            {
              is_overnight: false,
              start: "1630",
              end: "2230",
              day: 5,
            },
            {
              is_overnight: false,
              start: "1130",
              end: "1515",
              day: 6,
            },
            {
              is_overnight: false,
              start: "1630",
              end: "2200",
              day: 6,
            },
          ],
          hours_type: "REGULAR",
          is_open_now: true,
        },
      ],
      attributes: {
        business_temp_closed: null,
        menu_url: "https://pranakhonnyc.com/pdf/qrcode_menu.pdf",
        open24_hours: null,
        waitlist_reservation: null,
      },
    },
    {
      id: "LMyvruexOQzzHQrAgbdqiA",
      alias: "nowon-east-village-new-york-3",
      name: "Nowon East Village",
      image_url:
        "https://s3-media2.fl.yelpcdn.com/bphoto/PYmtwgFqAPMT_W9LnrlwYA/o.jpg",
      is_closed: false,
      url: "https://www.yelp.com/biz/nowon-east-village-new-york-3?adjust_creative=FlLcWTwY94L6PQ5d-K6zjg&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=FlLcWTwY94L6PQ5d-K6zjg",
      review_count: 423,
      categories: [
        {
          alias: "korean",
          title: "Korean",
        },
        {
          alias: "newamerican",
          title: "New American",
        },
        {
          alias: "gastropubs",
          title: "Gastropubs",
        },
      ],
      rating: 4.3,
      coordinates: {
        latitude: 40.7253574,
        longitude: -73.9833014,
      },
      transactions: ["pickup", "delivery"],
      price: "$$$",
      location: {
        address1: "507 E 6th St",
        address2: null,
        address3: "",
        city: "New York",
        zip_code: "10009",
        country: "US",
        state: "NY",
        display_address: ["507 E 6th St", "New York, NY 10009"],
      },
      phone: "+16466923867",
      display_phone: "(646) 692-3867",
      distance: 2388.886142841433,
      business_hours: [
        {
          open: [
            {
              is_overnight: false,
              start: "1700",
              end: "2300",
              day: 0,
            },
            {
              is_overnight: false,
              start: "1700",
              end: "2300",
              day: 1,
            },
            {
              is_overnight: false,
              start: "1700",
              end: "2300",
              day: 2,
            },
            {
              is_overnight: false,
              start: "1700",
              end: "2300",
              day: 3,
            },
            {
              is_overnight: false,
              start: "1700",
              end: "2359",
              day: 4,
            },
            {
              is_overnight: false,
              start: "1700",
              end: "2359",
              day: 5,
            },
            {
              is_overnight: false,
              start: "1700",
              end: "2300",
              day: 6,
            },
          ],
          hours_type: "REGULAR",
          is_open_now: true,
        },
      ],
      attributes: {
        business_temp_closed: null,
        menu_url: null,
        open24_hours: null,
        waitlist_reservation: null,
      },
    },
    {
      id: "FizBsTIAJwNrImIG1mPDcg",
      alias: "barn-joo-new-york-3",
      name: "Barn Joo",
      image_url:
        "https://s3-media2.fl.yelpcdn.com/bphoto/fhhPiWcVrSkLeZYkZxlhcA/o.jpg",
      is_closed: false,
      url: "https://www.yelp.com/biz/barn-joo-new-york-3?adjust_creative=FlLcWTwY94L6PQ5d-K6zjg&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=FlLcWTwY94L6PQ5d-K6zjg",
      review_count: 2010,
      categories: [
        {
          alias: "korean",
          title: "Korean",
        },
        {
          alias: "cocktailbars",
          title: "Cocktail Bars",
        },
        {
          alias: "tapasmallplates",
          title: "Tapas/Small Plates",
        },
      ],
      rating: 4.0,
      coordinates: {
        latitude: 40.73687872208401,
        longitude: -73.99076297177562,
      },
      transactions: ["pickup", "delivery"],
      price: "$$",
      location: {
        address1: "35 Union Sq W",
        address2: "",
        address3: null,
        city: "New York",
        zip_code: "10003",
        country: "US",
        state: "NY",
        display_address: ["35 Union Sq W", "New York, NY 10003"],
      },
      phone: "+16463989663",
      display_phone: "(646) 398-9663",
      distance: 3496.5788182983224,
      business_hours: [
        {
          open: [
            {
              is_overnight: false,
              start: "1200",
              end: "2200",
              day: 0,
            },
            {
              is_overnight: false,
              start: "1200",
              end: "2200",
              day: 1,
            },
            {
              is_overnight: false,
              start: "1200",
              end: "2200",
              day: 2,
            },
            {
              is_overnight: false,
              start: "1200",
              end: "2300",
              day: 3,
            },
            {
              is_overnight: false,
              start: "1200",
              end: "2300",
              day: 4,
            },
            {
              is_overnight: false,
              start: "1200",
              end: "2300",
              day: 5,
            },
            {
              is_overnight: false,
              start: "1200",
              end: "2200",
              day: 6,
            },
          ],
          hours_type: "REGULAR",
          is_open_now: true,
        },
      ],
      attributes: {
        business_temp_closed: null,
        menu_url:
          "https://1df2f693-890a-4294-9696-f5d644b9f5ba.filesusr.com/ugd/5295e1_6012d8d3ad4e4129b43d9efd66899e09.pdf",
        open24_hours: null,
        waitlist_reservation: null,
      },
    },
    {
      id: "jc7lVTvmYMIK5RNpENtS6w",
      alias: "szechuan-mountain-house-new-york-2",
      name: "Szechuan Mountain House",
      image_url:
        "https://s3-media2.fl.yelpcdn.com/bphoto/_xUllWdQ9DMSwrLC4q8kgQ/o.jpg",
      is_closed: false,
      url: "https://www.yelp.com/biz/szechuan-mountain-house-new-york-2?adjust_creative=FlLcWTwY94L6PQ5d-K6zjg&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=FlLcWTwY94L6PQ5d-K6zjg",
      review_count: 812,
      categories: [
        {
          alias: "szechuan",
          title: "Szechuan",
        },
      ],
      rating: 4.3,
      coordinates: {
        latitude: 40.72911,
        longitude: -73.98858,
      },
      transactions: ["pickup", "delivery"],
      price: "$$",
      location: {
        address1: "23 St Marks Pl",
        address2: "",
        address3: null,
        city: "New York",
        zip_code: "10003",
        country: "US",
        state: "NY",
        display_address: ["23 St Marks Pl", "New York, NY 10003"],
      },
      phone: "+19173883866",
      display_phone: "(917) 388-3866",
      distance: 2675.1962888402086,
      business_hours: [
        {
          open: [
            {
              is_overnight: false,
              start: "1130",
              end: "2200",
              day: 0,
            },
            {
              is_overnight: false,
              start: "1130",
              end: "2200",
              day: 1,
            },
            {
              is_overnight: false,
              start: "1130",
              end: "2200",
              day: 2,
            },
            {
              is_overnight: false,
              start: "1130",
              end: "2200",
              day: 3,
            },
            {
              is_overnight: false,
              start: "1130",
              end: "2300",
              day: 4,
            },
            {
              is_overnight: false,
              start: "1130",
              end: "2300",
              day: 5,
            },
            {
              is_overnight: false,
              start: "1130",
              end: "2200",
              day: 6,
            },
          ],
          hours_type: "REGULAR",
          is_open_now: true,
        },
      ],
      attributes: {
        business_temp_closed: null,
        menu_url: "https://www.szechuanmountainhouse.com/menu",
        open24_hours: null,
        waitlist_reservation: null,
      },
    },
    {
      id: "f4QBa0khsF9Ut99Tc9IMIA",
      alias: "haswell-greens-new-york-3",
      name: "Haswell Green's",
      image_url:
        "https://s3-media2.fl.yelpcdn.com/bphoto/iQh-1Rsa-CUZ61Xr7g8Oeg/o.jpg",
      is_closed: false,
      url: "https://www.yelp.com/biz/haswell-greens-new-york-3?adjust_creative=FlLcWTwY94L6PQ5d-K6zjg&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=FlLcWTwY94L6PQ5d-K6zjg",
      review_count: 622,
      categories: [
        {
          alias: "newamerican",
          title: "New American",
        },
        {
          alias: "pianobars",
          title: "Piano Bars",
        },
        {
          alias: "sportsbars",
          title: "Sports Bars",
        },
      ],
      rating: 4.5,
      coordinates: {
        latitude: 40.76301,
        longitude: -73.98416,
      },
      transactions: ["pickup", "delivery"],
      price: "$$",
      location: {
        address1: "240 W 52nd St",
        address2: "",
        address3: null,
        city: "New York",
        zip_code: "10019",
        country: "US",
        state: "NY",
        display_address: ["240 W 52nd St", "New York, NY 10019"],
      },
      phone: "+12122452801",
      display_phone: "(212) 245-2801",
      distance: 6441.073289973154,
      business_hours: [
        {
          open: [
            {
              is_overnight: true,
              start: "1500",
              end: "0300",
              day: 0,
            },
            {
              is_overnight: true,
              start: "1500",
              end: "0300",
              day: 1,
            },
            {
              is_overnight: true,
              start: "1500",
              end: "0300",
              day: 2,
            },
            {
              is_overnight: true,
              start: "1500",
              end: "0400",
              day: 3,
            },
            {
              is_overnight: true,
              start: "1500",
              end: "0400",
              day: 4,
            },
            {
              is_overnight: true,
              start: "1200",
              end: "0400",
              day: 5,
            },
            {
              is_overnight: true,
              start: "1200",
              end: "0300",
              day: 6,
            },
          ],
          hours_type: "REGULAR",
          is_open_now: true,
        },
      ],
      attributes: {
        business_temp_closed: null,
        menu_url: "https://haswellgreens.com/",
        open24_hours: null,
        waitlist_reservation: null,
      },
    },
  ],
  total: 15000,
  region: {
    center: {
      longitude: -73.99429321289062,
      latitude: 40.70544486444615,
    },
  },
};
